//Componenet App
import { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Form, Badge, Modal, Button } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import '../Reservation/reservation.css';

//Utils
import { RenderIf } from '../utils/RenderIf';
import Empty from '../utils/Empty';
import Socket from '../../components/utils/Socket.config';
import useAlarmSound from '../../hooks/useAlarmSound';
import { haversineKm, computeKilometerFee } from '../utils/CalculateDistanceFee';
import ZoomModalImg from '../utils/ZoomModalImg';
import { PaymentOperations } from '../../utils/PaymentOperations';
import validSession from '../utils/validSession';
import HiddenImg from '../utils/HiddenImg'
import { checkUserPermission } from '../utils/CheckUserPermitions';
import { checkUserModules } from '../utils/CheckUserModules';


//Components 
import Totals from './Totals';
import NavBar from './Nav/NavBar';
import moment from 'moment-timezone';

//Modals components 
import ModalDetaillsEvent from './ModalDetaillsEvent';
import ModalPendingOrders from './ModalPendingOrders';
import ModalLoginUserByCode from './ModalLoginUserByCode';
import ModalDiscounts from './ModalDiscounts'
import ModalReturn from './ModalReturn';
import ModalCoupons from './ModalCoupons'
import ModalPaymet from './ModalPayMet';
import ModalIngredient from './ModalIngredient';
import ModalCreatePreOrder from './ModalCreatePreOrder';
import ModalParthners from './ModalParthners';
import ModalSeparators from './ModalSeparators';
import ModalWarehouses from './ModalWarehouses';
import ModalCallCenter from './ModalCallCenter';
import ModalReservation from './ModalReservation';
import RfmTableRequestsPanel from '../Reservation/components/RfmTableRequestsPanel';

//API
import { EventsFetchAPI } from '../../api/Events';
import { SegmentsFechtAPI } from '../../api/Segments';
import { BusinessFetchAPI } from '../../api/Business';
import { StatusMenu } from '../../api/StatusMenu';
import { AuthFetchAPI } from '../../api/Auth';
import { PromotionsFechtAPI } from '../../api/Promotions';
import { MachinesFetchAPI } from '../../api/Machines';
import { InventoryFechtAPI } from '../../api/Inventory';
import { GroupsFechtAPI } from '../../api/Groups';
import { ParthnerFetchAPI } from '../../api/Parthner';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { ProductsFetchAPI } from '../../api/Paymentpost/Products';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { UsersFetchAPI } from '../../api/Users';
import { OrdersFetchAPI } from '../../api/Orders';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { WarehouseFetchAPI } from '../../api/Paymentpost/Warehouse';
import { DeliveryFeeRulesFetchAPI } from '../../api/DeliveryFeeRules';
import { TookanFetchAPI } from '../../api/Tookan';
import { AsapFetchAPI } from '../../api/Asap';
import { OrderNumberFetchAPI } from '../../api/Paymentpost/OrderNumber';
import { MailFetchAPI } from '../../api/Mail';
import { TableSessionsFetchAPI } from '../../api/TableSessions';

//Img
import logo_sp from '../../assets/img/logos/icon-black.png';
import empty_img from './img/empty_cart.png';
import promotion_img from './img/promos.png'
import all_products from './img/all.png';
import sad_products from './img/emptyassing.png'
import img_default from './img/imagen.png'
import img_combo from './img/combo.png';
import Favorite from './img/Favorite.png';
import sadImg from './img/sad.png'

//Alerts
import Swal from "sweetalert2";
import LoadingAlert from '../Alerts/LoadingAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import AlertSmallInfo from '../Alerts/AlertSmallInfo';

//CSS 
import './css/payment.css'; import './nav.css';
import Pos from '../../pages/Pos/Pos';
import FullScreen from '../../components/FullScreen'
import Theme from '../Theme/Theme';
import StepByStepSegments from './StepByStepSegments';
import ClientPillCard from '../ClientPillCard/ClientPillCard';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { normalizeRecoveredPreOrderItems, getPendingImpressAmountAfterQuantityChange } from '../../utils/PreOrderPaymentPrint';
import { kinposPaymentBridge } from '../../utils/KinposBridge';
import InvoiceTotals from './InvoiceTotals';
import SecretSettingsIcon from './SecretSettingsIcon';

//Selccion del restaurante delimitantando las sucursales

//Payment post componet 
// Props solo para el modo `embedded`: Reservation.jsx monta esta pantalla oculta para poder abrir el
// "Centro de Pagos" de un cobro en terminal ("Pagar con POS") sin salir de /reservation. En la ruta
// /payments no llega ninguna prop y todo se comporta exactamente igual que antes.
//   posPaymentRequest  - la solicitud a cobrar (antes llegaba por location.state)
//   business_code / branchoffice_code - en /reservation no hay params de ruta
//   onPosPaymentSettled(result) - cobro confirmado / cancelado / vencido
//   onDismiss - el cajero cerró el Centro de Pagos sin cobrar (o la solicitud venció)
const PaymentPost = ({
   embedded = false,
   posPaymentRequest: embeddedPosRequest = null,
   business_code: businessCodeProp,
   branchoffice_code: branchofficeCodeProp,
   onPosPaymentSettled: onEmbeddedSettled,
   onDismiss: onEmbeddedDismiss
}) => {
   //let index = 0;
   let business = ''
   let token = ''
   let branchoffice = ''
   let user = localStorage.getItem('user');
   let eventData = localStorage.getItem('event');
   const routeParams = useParams();
   const business_code = businessCodeProp ?? routeParams.business_code;
   const branchoffice_code = branchofficeCodeProp ?? routeParams.branchoffice_code;
   const [modalInformZSettleInfo, setModalInformZSettleInfo] = useState(false);
   const [modalInformZSettle, setModalInformZSettle] = useState(false);
   const [showTableRequestsPanel, setShowTableRequestsPanel] = useState(false);
   const [tableSessionRequests, setTableSessionRequests] = useState([]);
   const [processingTableSessionId, setProcessingTableSessionId] = useState(null);
   // IDs de mesa con actividad sin revisar (nueva ronda / solicitud de pago). Alimenta tanto el punto
   // rojo generico de los botones Mesas/Precuentas/Solicitudes como el punto rojo puntual por pedido
   // dentro de la lista de Precuentas (ver ModalPendingOrders) - cada mesa se apaga solo cuando se
   // abre ese pedido/mesa en particular, no al abrir el panel entero.
   const [alertedTableIds, setAlertedTableIds] = useState(() => new Set());
   const pendingTableAlert = alertedTableIds.size > 0;
   const markTableAlerted = (tableId) => {
      if (!tableId) return;
      setAlertedTableIds((prev) => {
         if (prev.has(tableId)) return prev;
         const next = new Set(prev);
         next.add(tableId);
         return next;
      });
   };
   const clearTableAlert = (tableId) => {
      setAlertedTableIds((prev) => {
         if (!prev.has(tableId)) return prev;
         const next = new Set(prev);
         next.delete(tableId);
         return next;
      });
   };
   const clearAllTableAlerts = () => setAlertedTableIds(new Set());
   const { startAlarm: startTableAlarm, stopAlarm: stopTableAlarm, showAudioUnlock: showTableAudioUnlock, handleUnlockAudio: handleUnlockTableAudio } = useAlarmSound();
   const [domain, setDomain] = useState("");
   const [editPrice, setEditPrice] = useState(() => {
      if (localStorage.getItem('edit_price') == "true") {
         return true
      } else {
         return false
      }
   })

   //We get the actual date 
   const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')

   const navigate = useNavigate();

   const [eventDataState, setEventDataState] = useState(() => {
      if (eventData !== null && eventData !== undefined && eventData !== '') {
         return eventData = JSON.parse(localStorage.getItem('event'))
      } else { return null }
   });

   if (localStorage.getItem("x-access-machine-token") == "" || localStorage.getItem("user") == "" || localStorage.getItem("branchoffice") == "") {
      business = JSON.parse(localStorage.getItem("business"))
      // Machine still logged in but nobody signed in as cashier (user cleared): go to the cashier
      // login. /machines/login forwards any valid machine session straight back to the POS, so
      // sending it there loops forever between both screens.
      const branchStored = localStorage.getItem("branchoffice");
      if (localStorage.getItem("user") == "" && localStorage.getItem("x-access-machine-token") && branchStored) {
         navigate(`/machine/cashier/login/${business.code}/${JSON.parse(branchStored).code}`)
      } else {
         navigate(`/machines/login/` + business.code)
      }
   } else {
      business = JSON.parse(localStorage.getItem("business"))
      token = localStorage.getItem("x-access-machine-token")
      branchoffice = JSON.parse(localStorage.getItem("branchoffice"));
   }

   //We validate if the user is logged in
   if (user === null || user === undefined || user === '' || user === 'null') {
      user = {
         name: 'No registrado',
         img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
      }
   } else {
      user = JSON.parse(localStorage.getItem('user'))
   }
   //States
   const [aditional_data, setAditional_data] = useState("")
   const [productEditPrice, setProductEditPrice] = useState({ name: '', price: 0.00, img: '', segments: [] });
   const [productEditPriceTemp, setProductEditPriceTemp] = useState(null);
   const [showModalEditPrice, setShowModalEditPrice] = useState(false);
   const [recoveryOrderApproved, setRecoveryOrderApproved] = useState(false);
   const [dataStyleBusiness, setDataStyleBusiness] = useState({})
   const [enabledOnlineOrder, setEnabledOnlineOrder] = useState(false)
   const [enabledTypeSelect, setEnabledTypeSelect] = useState(false)
   const [catalogSelect, setCatalogSelect] = useState(0)
   const [catalogs, setcatalogs] = useState([])
   const [favorites, setFavorites] = useState([])
   const [pointsMenuEnabled, setPointsMenuEnabled] = useState(false)
   const [dataReferenceOrderMicros, setDataReferenceOrderMicros] = useState({ micros_reference: { checkNum: "", checkSeq: "" } })
   const [devolution_validation, setDevolution_validation] = useState(0)
   const [discount_validation, setDiscount_validation] = useState(0)
   const [activeTab, setActiveTab] = useState(0);
   const [dataDicountApply, setdataDiscountApply] = useState([])
   const [statusRequest, setStatusRequest] = useState(true)
   const [segmentsNow, setSegmentsNow] = useState([])
   const [groupNow, setGroupNow] = useState({ nama: '', price: 0.00, img: '', description: '', segments: [] })
   const [showModalIngredient, setShowModalIngredient] = useState(false)
   const [comboSelect, setComboSelect] = useState([])
   const [stepsReadyComboNow, setStepsReadyComboNow] = useState([])
   const [businessLogo, setBusinessLogo] = useState("")
   const [number, setNumber] = useState(1);
   const [client_phone, setClient_phone] = useState("00")
   const [amountPaymentReady, setAmountPaymenReady] = useState(0.00)
   const [locator, setLocator] = useState("0");
   const [showModuleLocator, setShowModuleLocator] = useState(false);
   const [dataClient, setDataClient] = useState([]);
   const [allCategories, setAllCategories] = useState([]);
   const [categories, setCategories] = useState([]);
   const [categorieSelect, setCategorieSelect] = useState({})
   const [products, setProducts] = useState([]);
   const [promotionsList, setPromotionsList] = useState([]);
   const [dataPreOrder, setDataPreOrder] = useState({ pre_Order: false, _id: "" });
   const [viewProducts, setViewProducts] = useState([]);
   const [allProducts, setAllProducts] = useState([]);
   const [showModalSelectItem, setShowModalSelectItem] = useState(false);
   const [listPaymentReady, setlistPaymentReady] = useState([])
   const [registerTurnOrder, setRegisterTurnOrder] = useState(0);
   const [notesItem, setNotesItem] = useState("");
   const [inputFocusState, setInputFocusState] = useState(true);
   const [previewPriceItemsegmentSelect, setPreviewPriceItemsegmentSelect] = useState(0)
   const [selectProduct, setSelectProduct] = useState({
      img: '',
      name: '',
      img: '',
      name: '',
      price: ''
   });

   const [eventSelect, setEventSelect] = useState(() => {
      if (localStorage.getItem('event') !== null && localStorage.getItem('event') !== undefined && localStorage.getItem('event') !== '') {
         return JSON.parse(localStorage.getItem('event')).id
      } else {
         return null
      }
   })
   const [moduleEvents, setModuleEvents] = useState(false);
   const [events, setEvents] = useState([]);
   const [separators, setSeparators] = useState([])
   const [previewSegment, setPreviewSegment] = useState([])
   const [segments, setSegments] = useState([]);
   const [removedPreOrderShoppingCartProducts, setRemovedPreOrderShoppingCartProducts] = useState([]);
   const [shoppingCart, setShoppingCart] = useState([]);
   const [shoppingCartCombos, setShoppingCartCombos] = useState([])
   const [parthner_order, setParthner_order] = useState(false)
   //Event handler
   const [eventHandlerPreviewsegment, setEventHandlerPreviewsegment] = useState(0);
   const [eventHandler, setEventHandler] = useState(0);
   const [pageLoader, setPageLoader] = useState(0)
   //Totals states
   const [invoiceTotal, setInvoiceTotal] = useState(0);
   const [invoiceTotalItbms, setInvoiceTotalItbms] = useState(0);
   const [invoiceSubtotal, setInvoiceSubtotal] = useState(0);
   const [invoiceBaseReducedTax, setInvoiceBaseReducedTax] = useState(0);
   const [invoiceTotalDiscount, setInvoiceTotalDiscount] = useState(0)
   // Este es el monto que vas a mostrar en la línea "Delivery:"
   const [invoiceTotalDelivery, setInvoiceTotalDelivery] = useState(0);
   // Impuesto asociado al delivery (si lo quieres tener separado)
   const [invoiceTaxDeliveryFee, setInvoiceTaxDeliveryFee] = useState(0);
   const [taxesArrayAll, setTaxesArrayAll] = useState([])
   const [invoiceTips, setInvoiceTips] = useState(0)
   const [recomendationTips, setRecomendationTips] = useState([])
   const [moduleTips, setModuleTips] = useState(0)
   const [totaltopay, setTotaltopay] = useState(0)
   const [pos_integration_name, setPos_integration_name] = useState("");
   const [callCenter, setCallCenter] = useState(false);
   //filter
   const [temporalProducts, setTemporalProducts] = useState([]);
   const [searchTerm, setSearchTerm] = useState('');
   const [paramsMicros, setParamsMicros] = useState(0)
   const [parthners, setParthners] = useState([]);
   const [codeParthner, setCodeParthner] = useState(0)
   const [resetData, setResetData] = useState(0)
   const [yappy_transaction_id, setYappy_transaction_id] = useState("");
   const [showLoginByCode, setShowLoginByCode] = useState(false)
   const [showWaiters, setShowWaiters] = useState(false)
   const [showModalWarehouses, setShowModalWarehouses] = useState(false)
   const [warehouses, setWarehouses] = useState([])
   const [warehouseSelected, setWarehouseSelected] = useState(() => {
      if (localStorage.getItem('warehouse') !== "" && localStorage.getItem('warehouse') !== null && localStorage.getItem('warehouse') !== undefined) {
         return JSON.parse(localStorage.getItem('warehouse'))
      } else {
         return { name: "Selecciona una bodega", id: 0 }
      }
   })
   // delivery modal
   const [showDeliveryModal, setShowDeliveryModal] = useState(false);
   const [deliveryFeeRule, setDeliveryFeeRule] = useState(() => {
      if (
         localStorage.getItem('deliveryFeeRule') !== null &&
         localStorage.getItem('deliveryFeeRule') !== undefined &&
         localStorage.getItem('deliveryFeeRule') !== ''
      ) {
         return JSON.parse(localStorage.getItem('deliveryFeeRule'));
      } else {
         return [];
      }
   });

   const [selectedDeliveryRule, setSelectedDeliveryRule] = useState(() => {
      if (localStorage.getItem('posDeliveryRuleSelected')) {
         return JSON.parse(localStorage.getItem('posDeliveryRuleSelected'));
      }
      return null;
   });

   //PreOrder Table info
   const [tableInfo, setTableInfo] = useState({ table_id: 0, table_code: "0", table_name: "" })

   // "Pagar con POS": set while ModalPaymet is charging a claim raised from a pre-pago table's
   // ecommerce client (see Reservation.jsx#handleChargePosPayment, which navigates here with
   // location.state.posPaymentRequest) - {session_uuid, payment_attempt_id, calculation_id,
   // table_name}. null for every normal (non-table-claim) sale.
   const [posPaymentContext, setPosPaymentContext] = useState(null);
   // Read from inside the table-events socket handler below, whose own useEffect only depends on
   // business/branchoffice - without this ref that handler would close over a stale posPaymentContext
   // and never notice a claim it's currently waiting on has expired.
   const posPaymentContextRef = useRef(null);
   useEffect(() => {
      posPaymentContextRef.current = posPaymentContext;
   }, [posPaymentContext]);

   //data client
   //call center
   const [dataClientSelected, setdataClientSelected] = useState(() => {
      const stored = localStorage.getItem('client_data');
      return stored ? JSON.parse(stored) : null;
   });

   const [addressNowLocation, setAddressNowLocation] = useState(() => {
      if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
         return JSON.parse(localStorage.getItem('addressNowLocation'))
      } else {
         return null
      }
   });
   const [addresDescriptionClientFiscal, setAddresDescriptionClientFiscal] = useState("")
   const [optionalData, setOptionalData] = useState(false);
   const [dataResponse, setDataResponse] = useState(false);
   const [ruc, setRuc] = useState(0);
   const [name, setName] = useState("Cliente generico");
   const [dv, setDv] = useState(0);
   const [checkDeliveryOrder, setCheckDeliveryOrder] = useState("comer aqui")
   let machine = localStorage.getItem('machine');
   const inputRefLog = useRef(null);

   //We validate if the branch
   if (machine !== null && machine !== undefined && machine !== '') {
      machine = JSON.parse(localStorage.getItem('machine'))
   }

   //data checked discount
   const [productChecked, setProductChecked] = useState([]);
   const [combosChecked, setCombosChecked] = useState([])
   const [preOrderInvoice, setPreOrderInvoice] = useState(false);
   const [selectPreOrder, setSelectPreOrder] = useState({ order: "" })

   //Auto open pending orders
   const location = useLocation();
   // Auto-open preselect a temporal order when coming from URL params
   const [autoOpenPendingOrders, setAutoOpenPendingOrders] = useState(false);
   const [autoSelectPendingOrderId, setAutoSelectPendingOrderId] = useState(null);


   //Mobile Modal
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   const [orderNumber, setOrderNumber] = useState("0")
   const [orderNumberNow, setOrderNumberNow] = useState("0")
   const [sendStatus, setSendStatus] = useState(false);

   const controlModalLog = () => {
      // Solo mostrar login por código si no es pre_order=true en la URL
      const params = new URLSearchParams(window.location.search);
      const isPreOrder = params.get('pre_order') === 'true';
      if (!isPreOrder) {
         setShowLoginByCode(true);
      } else {
         setShowLoginByCode(false);
      }
   }

   //===========================Send preorder or quote to shopping cart functions===========================
   let intervalAply = 0
   const questionConfirmation = (dataNow, clientDataByTemporalOrder) => {
      console.log("Enviando", dataNow);
      console.log("select order quote", selectPreOrder);
      setSelectPreOrder({ order: dataNow, Team: true });


      if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
         const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
               confirmButton: 'btn btn-success',
               cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
         })

         swalWithBootstrapButtons.fire({
            title: 'Aun hay productos en la cartilla',
            text: "¿Quieres aplicar la precuenta?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si aplicar!',
            cancelButtonText: 'No, cancelar!',
            reverseButtons: true
         }).then((result) => {
            if (result.isConfirmed) {
               swalWithBootstrapButtons.fire(
                  'Precuenta aplicada!',
                  'success'
               )
               setShoppingCart([]);
               setShoppingCartCombos([])
               setProductChecked([])
               setCombosChecked([])
               LoadingAlert()
               intervalAply = setInterval(() => { aplyPreOrder(dataNow, clientDataByTemporalOrder) }, 1000);

            } else if (
               /* Read more about handling dismissals below */
               result.dismiss === Swal.DismissReason.cancel
            ) {
               swalWithBootstrapButtons.fire(
                  'Precuenta no aplicada!',
                  '',
                  'info'
               )
            }
         })
      } else {
         setShoppingCart([]);
         setShoppingCartCombos([])
         setProductChecked([])
         setCombosChecked([])
         LoadingAlert()
         intervalAply = setInterval(() => { aplyPreOrder(dataNow, clientDataByTemporalOrder) }, 1000);

      }
   }


   const aplyPreOrder = (dataNow, clientDataByTemporalOrder) => {
      let dataSelectOrder = dataNow
      if (dataNow != undefined) {
         dataSelectOrder = dataNow
      }

      localStorage.setItem('preOrderComparativeOld', JSON.stringify(dataSelectOrder))
      clearInterval(intervalAply)
      let message = ""
      let title = ""
      let icon = ""
      ErrorAlert(message, title, icon)
      if (dataSelectOrder.order == "") {
         console.log("no hay pre cuenta seleccionada");
         message = "No ha selecciona ninguna precuenta."
         title = "Bebe seleccionar una precuenta."
         icon = "info"
         ErrorAlert(message, title, icon)
      } else {

         setDataPreOrder({ pre_Order: true, _id: dataSelectOrder._id, code: dataSelectOrder.code, status_id: dataSelectOrder.status_id, transaction_code: dataSelectOrder.transaction_code, event_id: dataSelectOrder.event_id })
         setDataReferenceOrderMicros(dataSelectOrder.micros_reference)
         setName(dataSelectOrder.client_name)
         if (dataSelectOrder?.event_id) { setEventSelect({ id: dataSelectOrder.event_id }); }

         setAddresDescriptionClientFiscal(dataSelectOrder.client_address ? dataSelectOrder.client_address : "")
         setAditional_data(dataSelectOrder.aditional_info ? dataSelectOrder.aditional_info : "")

         if (clientDataByTemporalOrder != null) {
            localStorage.setItem('client_data', JSON.stringify(clientDataByTemporalOrder));
            setdataClientSelected(clientDataByTemporalOrder);
         }


         if (dataSelectOrder.client_ruc && dataSelectOrder.client_dv) {
            setRuc(dataSelectOrder.client_ruc)
            setDv(dataSelectOrder.client_dv)
         } else {
            setRuc("0")
            setDv("0")
         }


         if (dataSelectOrder.table_id && dataSelectOrder.table_code) {
            setTableInfo({ table_id: dataSelectOrder.table_id, table_code: dataSelectOrder.table_code, table_name: dataSelectOrder.table_name })
         } else {
            setTableInfo({ table_id: 0, table_code: "", table_name: "" })
         }

         setDataResponse(true)
         setOptionalData(true)
         setShowModalNew(false)
         setRemovedPreOrderShoppingCartProducts([])


         //format json 
         for (let i = 0; i < dataSelectOrder.groups.length; i++) {

            for (let s = 0; s < dataSelectOrder.groups[i].segments.length; s++) {

               dataSelectOrder.groups[i].segments[s].img = dataSelectOrder.groups[i].segments[s].item.img
               dataSelectOrder.groups[i].segments[s].item_id = dataSelectOrder.groups[i].segments[s].item.item_id
               dataSelectOrder.groups[i].segments[s].name = dataSelectOrder.groups[i].segments[s].item.name
               dataSelectOrder.groups[i].segments[s].segment_name = dataSelectOrder.groups[i].segments[s].name
               dataSelectOrder.groups[i].segments[s].cantidadItem = dataSelectOrder.groups[i].segments[s].item.amount
               dataSelectOrder.groups[i].segments[s].description = dataSelectOrder.groups[i].segments[s].item.description
               dataSelectOrder.groups[i].segments[s].tax = dataSelectOrder.groups[i].segments[s].item.tax
               dataSelectOrder.groups[i].segments[s].price = dataSelectOrder.groups[i].segments[s].item.price
            }
            dataSelectOrder.groups[i].DetalleSegmentos = dataSelectOrder.groups[i].segments
            dataSelectOrder.groups[i].cantidadItem = dataSelectOrder.groups[i].amount
            dataSelectOrder.groups[i].amount_Original = dataSelectOrder.groups[i].amount
            dataSelectOrder.groups[i].descuento = dataSelectOrder.groups[i].discount
         }


         message = "Orden consultada."
         title = "Operacion exitosa"
         icon = "success"
         setdataDiscountApply(dataSelectOrder.discounts)
         setPreOrderInvoice(true);
         setTaxesArrayAll(dataSelectOrder.taxes)
         ErrorAlert(message, title, icon)
         setCheckDeliveryOrder(dataSelectOrder.order_type)
         setShoppingCart(normalizeRecoveredPreOrderItems(dataSelectOrder.groups))
         setShoppingCartCombos(normalizeRecoveredPreOrderItems(dataSelectOrder.combos))
         setInvoiceTotal(dataSelectOrder.total)
         setInvoiceSubtotal(dataSelectOrder.subtotal)
         setInvoiceTotalItbms(dataSelectOrder.tax)


         setInvoiceTotalDiscount(dataSelectOrder.discount)
         setEventHandler(1)
         //We clean the url of parameters
         const cleanUrl = window.location.origin + window.location.pathname;
         window.history.replaceState({}, document.title, cleanUrl);
      }
   }

   //=======================================================================================================

   const sendMail = (EmailData) => {
      // Gets a temporary order by code from the API
      let token = localStorage.getItem('x-access-machine-token')
      let data = EmailData

      try {
         const response = MailFetchAPI.sendMail(data, token)
         AlertSmall('Correo enviado con exito', 'success')
         setSendStatus(true)

      } catch (err) {
         // Gets a temporary order by ID and navigates to the cart/order page
         ErrorAlert('', err.response.data ? err.response.data.error : "Error al enviar correo", 'error')
         setSendStatus(false)

      }
   }

   // get order number in process
   const getOrderNumber = async (sendOrder) => {
      try {
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
         const response = await OrderNumberFetchAPI.getOrderNumber(branchoffice.id, token)

         setOrderNumber(response.data.next_transaction_code);
         setOrderNumberNow(response.data.next_transaction_code);
         if (sendOrder == true) {
            return response.data.next_transaction_code;
         }
      } catch (err) {

      }
   }

   //Hook to get the URL params and check if we need to auto open the pending orders modal and preselect an order
   useEffect(() => {
      const params = new URLSearchParams(location.search);

      const preOrder = (params.get('pre_order') || '').toLowerCase() === 'true';
      const orderId = params.get('order_id');



      if (preOrder && orderId) {

         setAutoSelectPendingOrderId(orderId);
         setAutoOpenPendingOrders(true);
      } else {
         setAutoOpenPendingOrders(false);
         setAutoSelectPendingOrderId(null);
      }
   }, [location.search]);

   //Hook Socket 
   useEffect(() => {
      // Connection with the sockets server
      const socket = Socket({ "machine_code": machine.code, "branchoffice_code": branchoffice_code });
      //We listen the event of the server 
      socket.on("settle", async (data) => {
         let initialDate, finalDate, settleSuccess = false;

         //We check the lastDate of the inform z
         if (localStorage.getItem('lastDateInformZ') === null) {
            initialDate = moment(new Date()).format('YYYY-MM-DD');
            finalDate = new Date().toJSON();

         } else {
            initialDate = localStorage.getItem('lastDateInformZ');
            finalDate = new Date().toJSON();

         }

         LoadingAlert('Espere por favor, haciendo cierre de transacciones...')
         let generalData = localStorage.getItem('generalData');
         let generalDataParse = JSON.parse(generalData);


         //We create the settle data to send to the server
         let dataSettle = {
            "informz": "true",
            "machine_code": machine.code,
            "business_code": JSON.parse(localStorage.getItem('business')).code,
            "minDate": initialDate,
            "maxDate": finalDate,
         }

         //We check wich payment integration evertech the user want to make the settle
         if (data.paymentmethod_integration_id === 6) {
            let evertec = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 6);
            //We check if the evertec array have data
            if (evertec.length > 0) {
               //We call the api to make the settle
               try {
                  //We call the payment operation to make the settle
                  let response = await PaymentOperations({
                     operationType: 'settle', integrationType: 'Evertech', params: evertec[0].params,
                     sECRStationID: generalDataParse[0].data.machine.code,
                     sCashierID: generalDataParse[0].data.machine.code, sRefNumber: 0, tips: 0
                  });

                  //We check if the response is success
                  if (response && response.data && response.data.approval_code === "00") {

                     //We add the data that we want to update
                     dataSettle.voucher = response.data.receipt_output.settle;
                     dataSettle.paymentmethod_integration_id = 6;
                     //We show the success alert
                     ErrorAlert('', 'Cierre de evertech exitoso', 'success');
                     settleSuccess = true;
                  } else {

                     //We show the error alert
                     ErrorAlert('', 'Error en el cierre de evertech', 'error')
                  }
               } catch (err) {

                  ErrorAlert('', 'Error en el cierre de evertech', 'error')
               }
            }
         }

         //We check payment integration banesco
         if (data.paymentmethod_integration_id === 4) {
            let banesco = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 4);
            //We check if the banesco array have data
            if (banesco.length > 0) {
               //We call the api to make the settle
               try {
                  //We call the payment operation to make the settle
                  let response = await PaymentOperations({
                     operationType: 'settle', integrationType: 'Banesco', params: banesco[0].params
                  });

                  //We check if the response is success
                  if (response && response.data && response.data.ResponseCode === "00") {

                     //We add the data that we want to update
                     dataSettle.voucher = response.data.BatchTotals;
                     dataSettle.paymentmethod_integration_id = 4;
                     //We show the success alert
                     ErrorAlert('', 'Cierre de banesco exitoso', 'success');
                     settleSuccess = true;
                  } else {

                     //We show the error alert
                     ErrorAlert('', 'Error en el cierre de banesco', 'error')
                  }
               } catch (err) {

                  ErrorAlert('', 'Error en el cierre de banesco', 'error')
               }
            }
         }

         //If the payment integration is not evertech or banesco we just do the settle
         if (data.paymentmethod_integration_id !== 4 && data.paymentmethod_integration_id !== 6) {
            dataSettle.paymentmethod_integration_id = data.paymentmethod_integration_id;
            dataSettle.voucher = "0"
            settleSuccess = true;
         }
         //If the settle was success we call the api to update the orders inform z
         if (settleSuccess) {
            try {
               updateOrdersInformZ(dataSettle.voucher, dataSettle.paymentmethod_integration_id)
               //We show the success alert
               ErrorAlert('', 'Cierre de transacciones exitoso', 'success');

            } catch (err) {
               //We show the error alert
               ErrorAlert('', 'Error en el cierre de transacciones', 'error')
            }
         }


      });

      // Single-session-per-cashier: emitted by controller.login (smartpay-dashboard) to
      // `machine_${machine_code}_room` - the exact room this socket already joined by connecting
      // with machine_code/branchoffice_code above - when this same user confirms moving their
      // session to a different terminal. The backend already freed this machine and dropped this
      // cashier's active session record; this just forces the logout on screen to match.
      socket.on("cashierSessionTransferred", (data) => {
         const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
         if (!currentUser || String(currentUser.id) !== String(data?.user_id)) return;

         Swal.fire({
            icon: 'info',
            title: 'Sesion movida a otra terminal',
            text: `Tu sesion fue trasladada a la maquina "${data.moved_to_machine_name || data.moved_to_machine_code || 'otra terminal'}"${data.moved_to_branchoffice_name ? ` de la sucursal "${data.moved_to_branchoffice_name}"` : ''}. Esta terminal cerrara sesion.`,
            confirmButtonText: 'Entendido',
         }).then(() => {
            const business = JSON.parse(localStorage.getItem('business') || 'null');
            localStorage.clear();
            navigate(`/machines/login/${business?.code || business_code}`);
         });
      });

      // Single-session-per-terminal: emitted by controller.loginSmartPay when someone else confirms
      // taking over THIS machine from a different browser/device. Unlike cashierSessionTransferred,
      // this isn't scoped to a specific user_id - the machine itself changed hands, so whoever is
      // working here right now (any cashier, logged in or not) has to be logged out.
      socket.on("machineSessionTaken", (data) => {
         Swal.fire({
            icon: 'info',
            title: 'Esta terminal fue tomada por otro equipo',
            text: 'Alguien inicio sesion en esta misma terminal desde otro dispositivo. Esta sesion se cerrara.',
            confirmButtonText: 'Entendido',
         }).then(() => {
            const business = JSON.parse(localStorage.getItem('business') || 'null');
            localStorage.clear();
            navigate(`/machines/login/${business?.code || business_code}`);
         });
      });

      return () => {
         socket.disconnect();
      };
   }, []);

   //Function to update the orders inform z
   const updateOrdersInformZ = async (informZResponseVoucher, paymenthod_integration_id) => {
      let initialDate, finalDate;

      if (localStorage.getItem('lastDateInformZ') === null) {
         initialDate = moment(new Date()).format('YYYY-MM-DD');
         finalDate = new Date().toJSON();

      } else {
         initialDate = localStorage.getItem('lastDateInformZ');
         finalDate = new Date().toJSON();

      }

      let codeParthner = localStorage.getItem('codeParthner');
      let bussinesCode = business_code
      let branchCode = branchoffice_code

      if (codeParthner !== null && codeParthner !== undefined && codeParthner !== '') {
         codeParthner = JSON.parse(localStorage.getItem('codeParthner'))
         bussinesCode = codeParthner.business_code
         branchCode = codeParthner.branchoffice_code
      }

      try {
         let data = {
            "informz": "true",
            "user_code": user.user_code,
            "business_code": bussinesCode,
            "minDate": initialDate,
            "maxDate": finalDate,
            "voucher": informZResponseVoucher !== undefined && informZResponseVoucher !== null ? informZResponseVoucher : null
         }
         //We check if the payment method integration id is not null
         if (paymenthod_integration_id !== undefined && paymenthod_integration_id !== null) {
            data.paymenthod_integration_id = paymenthod_integration_id
         }
         //We call the api to update the orders inform z
         await OrdersFetchAPI.updateOrderStatusinformZ(actualDate, finalDate, false, user.user_code, bussinesCode, branchCode, token, data);
         //We set the last date of the inform z
         let dateArray = finalDate.split("T");
         localStorage.setItem('lastDateInformZ', dateArray[0] + "T00:00:00.000Z");
         ErrorAlert('', 'Se realizo el cierre con exito', 'success');
         //We save the last voucher 
         setModalInformZSettleInfo(informZResponseVoucher);
         //We set the modal inform z settle
         setModalInformZSettle(true);
      } catch (err) {
         ErrorAlert('', 'Error en el cierre', 'error')

      }
   }
   //Function to increment the amount of products on the product detail modal
   const incrementNumber = (amountDirect) => {
      // Validación para input manual y botones
      let value = amountDirect !== undefined ? amountDirect : number + 1;
      if (isNaN(value) || value < 1) value = 1;
      if (selectProduct.quantity) {
         let filter = shoppingCart.filter(group => group.group_id == selectProduct.group_id);
         let amountNow = 0;
         if (filter && filter.length > 0) {
            filter.forEach(group => { amountNow = (amountNow + group.amount); });
         }
         let newLimit = selectProduct.quantity - amountNow;
         if (value <= newLimit) {
            setNumber(value);
         } else {
            setNumber(newLimit > 0 ? newLimit : 1);
            const Toast = Swal.mixin({
               toast: true,
               position: "top-end",
               showConfirmButton: false,
               width: 600,
               timer: 3000,
               timerProgressBar: true,
               didOpen: (toast) => {
                  toast.onmouseenter = Swal.stopTimer;
                  toast.onmouseleave = Swal.resumeTimer;
               }
            });
            Toast.fire({
               icon: "info",
               title: "Este producto solo tiene " + selectProduct.quantity + " unidades disponibles"
            });
         }
      } else {
         setNumber(value);
      }
   };

   //Function to get the warehouse of branch office
   const getWarehouseByBrachoffice = async (branchoffice_id) => {
      try {
         const response = await WarehouseFetchAPI.getwarehousebybracnhoffice(branchoffice_id, 0, token)
         let filteredWarehouses = response.data.warehouses.filter(warehouse => warehouse.is_enable == 1)

         setWarehouses(filteredWarehouses)
         if (machine.user_code_validation !== 1) { validWarehouse(filteredWarehouses) }


      } catch (err) {
         setWarehouses([])

      }
   }

   const getInfoBusiness = async (statusParthners) => {
      let infoBusiness = JSON.parse(localStorage.getItem("business"))
      try {
         const response = await BusinessFetchAPI.getBusinessById(infoBusiness.id, localStorage.getItem("x-access-machine-token"));

         setBusinessLogo(response.data.data.logo);
         localStorage.setItem('businessLogo', response.data.data.logo);

         //let external_menu = localStorage.getItem('external_menu_manual')


         if (statusParthners == 1) {
            getParthners(response.data.data);
         } else {
            //if (external_menu == "true") {
            if (machine.external_menu == "1") {
               getParthners(response.data.data);
            }
         }
      } catch (err) {

      }
   }



   // We check wich delivery fee rule is active and we get the data
   const getDeliveryFeeRule = async () => {
      try {
         const response = await DeliveryFeeRulesFetchAPI.getDeliveryFeeRules(business.id, undefined, "ecommerce", token);
         //We check if we have any delivery fee rule
         if (response.data.data.length > 0) {
            //We map the rules and get the ones that are active
            let activeRules = response.data.data.filter(({ is_active }) => is_active === 1);

            //We map the active rules and get the details of each rule
            for (let i = 0; i < activeRules.length; i++) {
               const responseDetails = await DeliveryFeeRulesFetchAPI.getDetailsDeliveryFeeRules(activeRules[i].id, token);
               //We check if the delivery fee rule is taxable
               if (responseDetails.data.data.taxable === 1) {
                  activeRules[i].taxes = responseDetails.data.data.taxes
               } else {
                  activeRules[i].taxes = []
               }
            }
            //We save the active rules in localStorage
            localStorage.setItem('deliveryFeeRule', JSON.stringify(activeRules))
            setDeliveryFeeRule(activeRules); // <-- IMPORTANTE
         } else {
            localStorage.setItem('deliveryFeeRule', null)
            setDeliveryFeeRule([]);
         }
      } catch (err) {
         localStorage.setItem('deliveryFeeRule', null)
         setDeliveryFeeRule([]);
      }
   }


   //get parthners of the business
   const getParthners = async (data) => {

      try {
         const response = await ParthnerFetchAPI.getBusinessParthners(token);
         //setParthners(response.data.parthners);
         let array = []
         array.push({ parthner_id: data.id, logo: data.logo, parthner_name: data.name })

         response.data.parthners.forEach((parthner) => {
            array.push(parthner)
         });




         setParthners(array);

      } catch (err) {
         setParthners([]);

      }
   }


   //Function to decrement the amount of products on the product detail modal
   const decrementNumber = () => {
      //If the amount of product is more than 1 we decrement it
      if (number > 1) {
         setNumber(number - 1);
      }
   };

   const canProductBePaidWithPoints = (product) => {
      return product?.can_be_paid_with_points === true || Number(product?.can_be_paid_with_points) === 1;
   }

   const filterProductsPaidWithPoints = (productList = []) => {
      return productList.filter(canProductBePaidWithPoints);
   }

   const applyPointsMenuFilter = (productList = []) => {
      return pointsMenuEnabled ? filterProductsPaidWithPoints(productList) : productList;
   }

   const formatProductPrice = (price) => {
      const productPrice = parseFloat(price);
      return Number.isFinite(productPrice) ? productPrice.toFixed(2) : "0.00";
   }

   const formatProductPoints = (points) => {
      const productPoints = parseFloat(points);
      if (!Number.isFinite(productPoints)) return "0";
      return Number.isInteger(productPoints) ? productPoints.toString() : productPoints.toFixed(2);
   }

   const isProductInPointsMenuMode = (product = selectProduct) => {
      return pointsMenuEnabled && canProductBePaidWithPoints(product);
   }

   const getModifierPrice = (price, product = selectProduct) => {
      if (isProductInPointsMenuMode(product)) return 0;
      const modifierPrice = parseFloat(price);
      return Number.isFinite(modifierPrice) ? modifierPrice : 0;
   }

   const formatModifierPrice = (price, product = selectProduct) => {
      if (isProductInPointsMenuMode(product)) return "0 pts";
      return "+ $" + getModifierPrice(price, product).toFixed(2);
   }

   const getProductPointsValue = (product) => {
      const pointsValue = parseFloat(product?.points_value);
      return Number.isFinite(pointsValue) ? pointsValue : 0;
   }

   const isCartProductPaidWithPoints = (product) => {
      return product?.paid_with_points === true;
   }

   const getCartProductPointsTotal = (product) => {
      if (!isCartProductPaidWithPoints(product)) return 0;
      const amount = parseFloat(product?.amount);
      return getProductPointsValue(product) * (Number.isFinite(amount) ? amount : 1);
   }

   const applyPointsPaymentData = (product) => {
      const paidWithPoints = isProductInPointsMenuMode(product);
      product.paid_with_points = paidWithPoints;
      product.points_value = getProductPointsValue(product);
      product.points_total = paidWithPoints ? getCartProductPointsTotal(product) : 0;
      return product;
   }

   const syncProductPointsTotal = (product) => {
      if (isCartProductPaidWithPoints(product)) {
         product.points_total = getCartProductPointsTotal(product);
      }
      return product;
   }

   const buildModifierItemForProduct = (item, product = selectProduct) => {
      const modifierPrice = getModifierPrice(item?.price, product);
      return {
         ...item,
         price: modifierPrice,
         item: item?.item ? { ...item.item, price: modifierPrice } : item?.item
      }
   }

   const resetMenuSearch = () => {
      const searchInput = document.getElementById("searchInput");
      if (searchInput) searchInput.value = "";
      setSearchTerm("");
   }

   const togglePointsMenu = () => {
      const nextPointsMenuEnabled = !pointsMenuEnabled;
      const productsToShow = nextPointsMenuEnabled ? filterProductsPaidWithPoints(temporalProducts) : temporalProducts;

      if (cartHasProducts) {
         setShoppingCart([]);
         setShoppingCartCombos([]);
         setProductChecked([]);
         setCombosChecked([]);
         setdataDiscountApply([]);
         setTaxesArrayAll([]);
         setInvoiceTotalDiscount(0);
         setInvoiceSubtotal(0);
         setInvoiceTotalItbms(0);
         setInvoiceTotal(0);
         setInvoiceBaseReducedTax(0);
         setInvoiceTotalDelivery(0);
         setInvoiceTaxDeliveryFee(0);
         setTotaltopay(0);
         setEventHandler(1);
         AlertSmall("Cartilla limpiada por cambio de modo", "info");
      }

      resetMenuSearch();
      setCategorieSelect(nextPointsMenuEnabled ? "points" : {});
      setCatalogSelect(0);
      setCategories(allCategories);
      setProducts(productsToShow);
      setViewProducts(productsToShow);
      setPointsMenuEnabled(nextPointsMenuEnabled);
   }

   //Filter the products by the term searched
   const filteredProducts = useMemo(() => {


      if (searchTerm === '') {
         return products
      }
      return viewProducts.filter(product => {

         const nameMatch = product.name?.toLowerCase().includes(searchTerm.toLowerCase());
         const descriptionMatch = product.description?.toLowerCase().includes(searchTerm.toLowerCase());
         //const upc_code_match = product.upc_codes.some((upc) => upc.upc_code === searchTerm);
         //return nameMatch || descriptionMatch || upc_code_match;
         return nameMatch || descriptionMatch;
      })
   }, [searchTerm, products, viewProducts]);

   const cartProducts = shoppingCart.concat(shoppingCartCombos);
   const cartHasProducts = cartProducts.length > 0;
   const cartIsPointsOrder = cartProducts.some(isCartProductPaidWithPoints);
   const invoiceTotalPoints = cartProducts.reduce((total, product) => {
      return total + getCartProductPointsTotal(product);
   }, 0);

   //function to select type delivery order
   const selectTypyDeliveryOrder = (typeOrder) => {

      let intervalRadioButton = 0
      let temShopingCart = shoppingCart
      let temShopingCartCombo = shoppingCartCombos
      setCheckDeliveryOrder(typeOrder)

      const initShopingcard = () => {
         clearInterval(intervalRadioButton)
         setShoppingCart(temShopingCart)
         setShoppingCartCombos(temShopingCartCombo)
         setEventHandler(1)
         SuccessAlert()
      }

      // si es delivery, abrimos el modal y marcamos el delivery_type en los productos
      if (typeOrder === "delivery") {
         // seteamos el tipo en los productos
         temShopingCart.forEach(product => {
            product.delivery_type = typeOrder;
         });
         temShopingCartCombo.forEach(product => {
            product.delivery_type = typeOrder;
         });

         setShowDeliveryModal(true);   // ← aquí se abre el modal
         setShoppingCart(temShopingCart);
         setShoppingCartCombos(temShopingCartCombo);
         setEventHandler(1);
         getDeliveryFeeRule()
         return;
      }

      if (typeOrder != "Mixto") {
         LoadingAlert()
         setShoppingCart([])
         setShoppingCartCombos([])
         setEventHandler(1)
         temShopingCart.forEach(product => {
            product.delivery_type = typeOrder
         })
         temShopingCartCombo.forEach(product => {
            product.delivery_type = typeOrder
         })
         intervalRadioButton = setInterval(initShopingcard, 1000)
      }
   }



   //-------------------------------------------------------------------------------------
   //-------------------------------------------------------------------------------------
   // get status change of the info to  menu
   const getStatusContentMenu = async (budinessParthner, branchofficeParthner, machineParthner) => {

      let business_id = 0
      let branchoffice_id_general = 0
      let machine_id = 0


      if (budinessParthner === undefined) {
         business_id = business.id
         branchoffice_id_general = branchoffice.id
         machine_id = machine.id
      } else {
         business_id = budinessParthner
         branchoffice_id_general = branchofficeParthner
         // machine_id = machineParthner
         machine_id = machine.id
      }




      if (localStorage.getItem('generalData') == '' || localStorage.getItem('generalData') == undefined || localStorage.getItem('generalData') == null) {
         getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 1)
      } else {

         let generalData = JSON.parse(localStorage.getItem('generalData'))
         let filterData = generalData.find(({ branchoffice_id }) => branchoffice_id == branchoffice_id_general)

         if (filterData != undefined) {
            try {
               const response = await StatusMenu.getContentMenu(token, machine_id)

               if (response.data.data.content_status == true) {
                  getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 2)
               } else {

                  dataconsolidation(generalData)
               }
            } catch (err) {

            }
         } else {
            getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 3)
         }
      }
   }

   //Function get the groups by machine
   const getDataGeneralSmartpay = async (business_id, branchoffice_id, machine_id, step) => {

      try {

         //getProductsByBranchOfficessByStatus(branchoffice.id, token)
         const response_allgroups = await ProductsFetchAPI.getProductsByBranchOfficessByStatus(branchoffice_id, 1, token)

         const response = await AuthFetchAPI.getMenuGenerate(token, machine_id, branchoffice_id, business_id)

         let data = []
         switch (step) {
            case 1://first time guarda data si no encuentra el parametro

               data = [{ "branchoffice_id": branchoffice_id, "data": response.data.data, "groups_by_branchoffice": response_allgroups.data.data }]
               break;
            case 2://consulta nueva data de una sucursal especifica

               let generalData1 = JSON.parse(localStorage.getItem('generalData'))
               //let filterData = generalData1.filter(({ branchoffice_id }) => branchoffice_id != branchoffice_id);
               //filterData.data=response.data.data

               generalData1.forEach((dataNow) => {
                  if (dataNow.branchoffice_id == branchoffice_id) {
                     dataNow.data = response.data.data
                     dataNow.groups_by_branchoffice = response_allgroups.data.data
                  }
               })


               data = generalData1


               break;
            case 3:

               let generalData2 = JSON.parse(localStorage.getItem('generalData'))
               generalData2.push({ "branchoffice_id": branchoffice_id, "data": response.data.data, "groups_by_branchoffice": response_allgroups.data.data })

               data = generalData2

               break;

         }

         AlertSmall("Información cargada con éxito", "success")
         localStorage.setItem('generalData', JSON.stringify(data))
         dataconsolidation(data)
      } catch (err) {

      }
   }

   const getEventsByBusiness = async (business_id) => {
      try {
         const response = await EventsFetchAPI.getEventsByBusiness(business_id)

         setEvents(response.data.events)
      } catch (err) {

      }
   }


   //consolidates data into corresponding statements
   const dataconsolidation = (generalData, status) => {
      console.log("consolidacion de datos");
      let data = {}
      let allGroups = []

      generalData.forEach((dataNow) => {
         if (dataNow.branchoffice_id == branchoffice.id) {
            data = dataNow.data
            //allGroups = dataNow.groups_by_branchoffice
            allGroups = dataNow.data.groups

            setSeparators(dataNow.groups_by_branchoffice.filter(({ type }) => type == "separator"))
         }
      })

      setDataStyleBusiness(data.configuration)

      if (data.business.events_enabled == 1) {
         getEventsByBusiness(data.business.id)
      }
      setModuleEvents(data.business?.events_enabled === 1 ? true : false)
      //save branchoffice with lat and lng

      localStorage.setItem('branchoffice', JSON.stringify({ ...branchoffice, lat: data.branchoffice.lat, lng: data.branchoffice.lng, ruc: data.branchoffice.ruc, dv: data.branchoffice.dv, fiscal_name: data.branchoffice.fiscal_name }))
      localStorage.setItem('publicity', JSON.stringify(data.publicity))
      //section categories------------------------------------------------
      //let dataCategories = data.category
      //let typeCodeCategories = 'P'
      //let categories_info = dataCategories.filter(({ code }) => code === typeCodeCategories);
      //console.log(" categorias filtradas");
      //console.log(categories_info);


      setCategories(data.category)
      setAllCategories(data.category)
      setcatalogs(data.catalogs)



      let dataFavoriteGroups = data.groups.filter(({ favorite }) => favorite == 1)
      setFavorites(dataFavoriteGroups)

      //---------------------------------------------------------------------
      //section promotions---------------------------------------------------

      //filter promotion by status 1
      let dataPromotions = data.promotions
      let dataTemp = [];
      dataPromotions.forEach((promotionNow) => {
         if (promotionNow.status == 1) {
            dataTemp.push(promotionNow)
         }
      })

      setPromotionsList(data.promotions)

      //---------------------------------------------------------------------
      //section paymentMethods---------------------------------------------------
      //let dataPaymentMethods= data.paymentMethods
      //setPaymentMethod(dataPaymentMethods);
      //---------------------------------------------------------------------



      //all groups=================================================================

      setAllProducts(allGroups)
      setProducts(applyPointsMenuFilter(allGroups))
      setViewProducts(applyPointsMenuFilter(allGroups))
      setTemporalProducts(allGroups)
      //===========================================================================

      setDevolution_validation(data.branchoffice.devolution_validation)
      setDiscount_validation(data.branchoffice.discount_validation)

      let dataTips = data.branchoffice.tips_validation
      setModuleTips(dataTips)

      if (data.branchoffice.locator == 1) {
         setShowModuleLocator(true)
      } else {
         setShowModuleLocator(false)
      }



      //set data type integration
      setPos_integration_name(data.business.pos_integration_name)
      if (data.business.pos_integration_id != null) {
         setParamsMicros({ "pos_integration_id": data.business.pos_integration_id, "pos_integration_name": data.business.pos_integration_name, "pos_integration_params": data.business.pos_integration_params })
      } else {
         setParamsMicros(0)
      }


      //preserves the value of the selected category
      if (status == true) {
         data.category.forEach((category) => {
            if (category.category_id == categorieSelect.category_id) {
               setCategorieSelect(category)
               selectCategorie(category)
            }
         })
      }

      //data code parthner

      if (parthner_order == true) {
         setCodeParthner({ business_id: data.business.id, business_code: data.business.code, branchoffice_id: data.branchoffice.id, branchoffice_code: data.branchoffice.code, machine_id: data.machine.machine_id, machine_code: data.machine.code })
         localStorage.setItem('codeParthner', JSON.stringify({ business_id: data.business.id, business_code: data.business.code, branchoffice_id: data.branchoffice.id, branchoffice_code: data.branchoffice.code, machine_id: data.machine.machine_id, machine_code: data.machine.code }))

      } else {

         if (branchoffice.parthner_business) {
            setParthner_order(true)
            setCodeParthner({ business_id: data.business.id, business_code: data.business.code, branchoffice_id: data.branchoffice.id, branchoffice_code: data.branchoffice.code, machine_id: data.machine.machine_id, machine_code: data.machine.code })
            localStorage.setItem('codeParthner', JSON.stringify({ business_id: data.business.id, business_code: data.business.code, branchoffice_id: data.branchoffice.id, branchoffice_code: data.branchoffice.code, machine_id: data.machine.machine_id, machine_code: data.machine.code }))

         } else {
            setParthner_order(false)
            setCodeParthner(0)
            localStorage.setItem('codeParthner', "")

         }
      }

      getWarehouseByBrachoffice(branchoffice.id)
      if (data.business.domain !== null) {
         setDomain(data.business.domain)
         let dataBusiness = JSON.parse(localStorage.getItem('business'))
         localStorage.setItem('business', JSON.stringify({ ...dataBusiness, domain: data.business.subdomain }))
      } else {

         setDomain("")
      }


      //Data consultada de localStorage temporalmente
      let dataCallCenter = localStorage.getItem('callCenter')
      if (dataCallCenter == "true") {
         setCallCenter(true)
      } else {
         setCallCenter(false)
      }

      //enabled online order
      if (data.machine.allow_online_orders && data.machine.allow_online_orders == 1) {
         setEnabledOnlineOrder(true)
      } else {
         setEnabledOnlineOrder(false)
      }

      //enabled type select order
      if (data.machine.show_order_type_selector && data.machine.show_order_type_selector == 1) {
         setEnabledTypeSelect(true)
      } else {
         setEnabledTypeSelect(false)
      }


      getOrderNumber()

   }

   //-------------------------------------------------------------------------------------
   //-------------------------------------------------------------------------------------


   //function get categories by brach office and by status
   const getCategoriesByBranchOffices = async (branchoffice_id, token) => {
      try {
         const response = await CategriesPosFetchAPI.getCategoriesByBranchOffices(branchoffice_id, 1, token);
         setCategories(response.data.data)
      } catch (error) {
         console.log(error);
      }
   }

   //function get products by branch offices and by status
   const getProductsByBranchOfficessByStatus = async (branchoffice_id, token) => {

      try {
         const response = await ProductsFetchAPI.getProductsByBranchOfficessByStatus(branchoffice_id, 1, token)
         setAllProducts(response.data.data)
         setProducts(applyPointsMenuFilter(response.data.data))
         setViewProducts(applyPointsMenuFilter(response.data.data))
         setTemporalProducts(response.data.data)

      } catch (err) {
         console.log(err);
      }
   }

   // function get segment by id product
   const getSegmentByProduct = async (info) => {


      if (info.group_id) {
         let group_id = info.group_id
         let token = localStorage.getItem('x-access-machine-token');
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

         console.log(info);

         if (info.segments) {
            setShowModalSelectItem(true)
            compilationDataSegments(info, info.segments)
            if (!info.segments.length) {
               nextStep();
            }
         } else {
            LoadingAlert()
            try {
               //For default we clean the segments of the state
               setSegments([])
               //We get the active segments of the group
               const response = await ProductsFetchAPI.getSegmentsByProducts(group_id, 1, branchoffice.id, token);
               setShowModalSelectItem(true)
               AlertSmall("Consulta exitosa")
               //ErrorAlert("", "Producto consultado", "success")
               //save item default by segment

               compilationDataSegments(response.data.group, response.data.data)
               if (!response.data.data.length) {
                  nextStep();
               }
            } catch (err) {

               if (err.response.data.error === "No tiene acompañantes registrados para este combo") {
                  setSegments([]);
                  nextStep();
                  getGroupById(group_id)
               } else {
                  ErrorAlert("Verificar los segmentos he items del producto", "Error de consulta", "error")
                  setShowModalSelectItem(false)
                  setSegments([]);
                  nextStep();
                  console.log(err);
               }
            }

         }

      } else {
         console.log("Combos:");


         let data = info
         let priceCombo = 0

         if (data.setGroups.length > 0) {
            data.setGroups.forEach((combo) => {
               if (combo.isMainSetGroup == 1) {
                  if (combo.groups.length > 0) {
                     priceCombo = (combo.groups[0].price + priceCombo)
                  }
               }
            })
            data.price = priceCombo
         }

         console.log(data);
         setSelectProduct(data)
         setSegments([])
         setShowModalSelectItem(true)
      }

      function compilationDataSegments(group, segments) {
         let validItemsSgments = true
         let arrayTem = new Array
         for (let k = 0; k < segments.length; k++) {
            let segment = segments[k]
            let itemDefault = 0
            let turnItem = false

            if (segment.items.length == 0) {
               validItemsSgments = false
               console.log("no habia items en este segmento")
            } else {
               for (let f = 0; f < segment.items.length; f++) {
                  if (segment.segment_item_id_default == segment.items[f].item_id) {

                     console.log("este es el item default")
                     itemDefault = segment.items[f]
                     turnItem = true
                  }
               }

               if (turnItem == true) {
                  arrayTem.push({ segment: segment, item: itemDefault })
                  setPreviewSegment(arrayTem)
               } else {
                  console.log("Este producto no tiene default")
                  arrayTem.push({ segment: segment, item: segment.items[0] })
                  setPreviewSegment(arrayTem)
               }
            }
         }

         //setPreviewPriceItemsegmentSelect(response.data.group.price)

         if (validItemsSgments = true) {
            let segmentsTemp = segments
            let priceGroupTemp = group.price
            segmentsTemp.forEach((segmentTempI) => {
               if (segmentTempI.items.length > 0) {
                  let defaultCheckedSegment = segmentTempI.segment_item_id_default
                  let items = segmentTempI.items

                  if (defaultCheckedSegment == null || defaultCheckedSegment == "" || defaultCheckedSegment == undefined) {
                     priceGroupTemp = (priceGroupTemp + items[0].price);
                  } else {
                     items.forEach((itemTemp) => {
                        if (itemTemp.item_id == defaultCheckedSegment) {
                           priceGroupTemp = (priceGroupTemp + itemTemp.price);
                        }
                     });
                  }
               }

            });

            //We set the segments
            setSegments(segments);
            setSelectProduct(group);

            setPreviewPriceItemsegmentSelect(priceGroupTemp)
         } else {

            ErrorAlert("Hay un segmento sin items", "Error de consulta", "error")
            setShowModalSelectItem(false)
            setSegments([]);
         }

      }
   }

   //Function get group by id
   const getGroupById = async (group_id) => {

      let token = localStorage.getItem('x-access-machine-token');
      try {
         setShowModalSelectItem(true)
         const response = await GroupsFechtAPI.getGroupById(group_id, token)
         console.log(response);
         let formatProductAdd = response.data.data
         //ErrorAlert('', 'producto encontrado', 'success')
         AlertSmall("Consulta exitosa")

         //For default we set that the amount of the selected product depending the number
         formatProductAdd.isNewAdd = true;
         formatProductAdd.amount = 1;
         formatProductAdd.cantidadItem = 1;
         formatProductAdd.delivery_type = "comer aqui";
         formatProductAdd.note = '';
         formatProductAdd.unit_discount = 0;
         formatProductAdd.product_discount = 0;
         formatProductAdd.base_price = formatProductAdd.price;
         formatProductAdd.descuento = formatProductAdd.product_discount;
         formatProductAdd.discount = formatProductAdd.product_discount;
         //For default we initialice the segments empty of the selected product 
         formatProductAdd.segments = [];
         formatProductAdd.DetalleSegmentos = [];
         formatProductAdd.segments_string = "" + formatProductAdd.group_id

         //let temporal_segment_string = formatProductAdd.segments_string
         setSelectProduct(formatProductAdd);




      } catch (err) {
         console.log(err);
      }
   }


   // function get segment by id product
   const getSegmentByPromotion = async (promotion) => {
      if (promotion.segments) {

         setShowModalSelectItem(true)
         compilationDataSegments(promotion, promotion.segments)

         if (!promotion.segments.length) {
            nextStep();
         }
      } else {

         LoadingAlert()
         let token = localStorage.getItem('x-access-machine-token');

         try {
            //For default we clean the segments of the state
            setSegments([])
            //We get the active segments of the group
            const response = await SegmentsFechtAPI.getSegmentsByPromotion(promotion.promotion_id, token);
            setShowModalSelectItem(true)
            AlertSmall("Consulta exitosa")
            compilationDataSegments(promotion, response.data.data)
            if (!response.data.data.length) {
               nextStep();
            }

         } catch (err) {

            if (err.response.data.error === "No tiene acompañantes registrados para esta promoción") {
               AlertSmall("Consulta exitosa")
               setSegments([]);
               nextStep();
               setSelectProduct(promotion);
               setShowModalSelectItem(true)
            } else {
               ErrorAlert("Verificar los segmentos he items de la promocion", "Error de consulta", "error")
               setShowModalSelectItem(false)
               setSegments([]);
               nextStep();
               console.log(err);
            }
         }

      }

      function compilationDataSegments(promotion, segments) {
         console.log(promotion);
         let promotionJson = segments
         promotionJson.group = promotion
         promotionJson.group.name = promotion.promotion_name
         promotionJson.group.description = promotion.promotion_description

         let validItemsSgments = true
         let arrayTem = new Array
         for (let k = 0; k < promotionJson.length; k++) {
            let segment = promotionJson[k]
            let itemDefault = 0
            let turnItem = false

            if (segment.items.length == 0) {
               validItemsSgments = false
               console.log("no habia items en este segmento")
            } else {
               for (let f = 0; f < segment.items.length; f++) {
                  if (segment.segment_item_id_default == segment.items[f].item_id) {
                     itemDefault = segment.items[f]
                     turnItem = true
                  }
               }


               if (turnItem == true) {
                  arrayTem.push({ segment: segment, item: itemDefault })
                  setPreviewSegment(arrayTem)
               } else {
                  arrayTem.push({ segment: segment, item: segment.items[0] })
                  setPreviewSegment(arrayTem)
               }
            }
         }

         if (validItemsSgments = true) {
            let segmentsTemp = promotionJson
            let priceGroupTemp = promotionJson.group.price
            segmentsTemp.forEach((segmentTempI) => {
               let defaultCheckedSegment = segmentTempI.segment_item_id_default
               let items = segmentTempI.items

               if (defaultCheckedSegment == null || defaultCheckedSegment == "" || defaultCheckedSegment == undefined) {
                  priceGroupTemp = (priceGroupTemp + items[0].price);
               } else {
                  items.forEach((itemTemp) => {
                     if (itemTemp.item_id == defaultCheckedSegment) {
                        priceGroupTemp = (priceGroupTemp + itemTemp.price);
                     }
                  });
               }

            });


            //We set the segments
            setSegments(promotionJson);
            setSelectProduct(promotionJson.group);

            setPreviewPriceItemsegmentSelect(priceGroupTemp)
         } else {
            ErrorAlert("Hay un segmento sin items", "Error de consulta", "error")
            setShowModalSelectItem(false)
            setSegments([]);
         }
      }
   }

   //view categories
   const listCategories = () => {
      const listCategorie = categories.map((categorie, index) => (
         <>
            <li key={index}>
               <div className="button-container">
                  <input
                     type="radio"
                     className="btn-check"
                     id={categorie.category_id}
                     name='options-outlined'
                     value={JSON.stringify(categorie)}
                     autoComplete="off"
                     onChange={(e) => selectCategorie(categorie)}
                  />
                  <label
                     className="btn btn-outline-dark rounded-pill border "
                     htmlFor={categorie.category_id}
                  >
                     <span className='my-3'>
                        {categorie.category_name}
                     </span>
                  </label>
               </div>
            </li>
         </>
      ));
      return (listCategorie)
   }

   const changeLanguage = (languague) => {

      document.cookie = "googtrans=/" + languague;


      {/*if (languague === 'es') {
         document.cookie = "googtrans=" + "/es";
      } else {
         document.cookie = "googtrans=" + "/es/zh-CN";
      }*/}
      new window.google.translate.TranslateElement({ pageLanguage: 'es' }, 'google_translate_element')



   }

   const promotions = async () => {
      console.log("Estoy en promociones")

      let token = localStorage.getItem('x-access-machine-token');
      let business = JSON.parse(localStorage.getItem('business'))
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));

      console.log(promotionsList);

      if (promotionsList.length > 0) {
         let arrayPromotions = promotionsList;

         arrayPromotions.forEach((promotion) => {
            promotion.cloudinary_id = null
            promotion.id = promotion.promotion_id
            promotion.suggested_price = 0
            promotion.group_type = "infinite"
            promotion.status = 1
            promotion.preparation = 0
            promotion.expiration_date = promotion.expirationDate
            promotion.batch = null
            promotion.presentation = null
            promotion.brand_id = null
            promotion.especial_discount = 0
            promotion.dTasaITBMSValue = "01"


            promotion.name = promotion.promotion_name
            promotion.description = promotion.promotion_description
            promotion.upc_codes = [{ upc_code: "" }];
         })

         console.log("detalle de la promocion")
         console.log(arrayPromotions)
         setProducts(applyPointsMenuFilter(arrayPromotions))
         setViewProducts(applyPointsMenuFilter(arrayPromotions))

      } else {
         try {
            const response = await PromotionsFechtAPI.getPromotionsByBranchoffice(branchoffice.id, token)
            console.log(response.data.promotions)

            let arrayPromotions = response.data.promotions;

            arrayPromotions.forEach((promotion) => {
               promotion.cloudinary_id = null
               promotion.id = promotion.promotion_id
               promotion.suggested_price = 0
               promotion.group_type = "infinite"
               promotion.status = 1
               promotion.preparation = 0
               promotion.expiration_date = promotion.expirationDate
               promotion.batch = null
               promotion.presentation = null
               promotion.brand_id = null
               promotion.especial_discount = 0
               promotion.dTasaITBMSValue = "01"


               promotion.name = promotion.promotion_name
               promotion.description = promotion.promotion_description
               promotion.upc_codes = [{ upc_code: "" }];
            })


            setProducts(applyPointsMenuFilter(arrayPromotions))
            setViewProducts(applyPointsMenuFilter(arrayPromotions))

         } catch (err) {
            setProducts([])
            setViewProducts([])
            console.log("No hay productos aqui ");
            console.log(err)
         }
      }
   }

   //function to set the catalog selected
   const selectCatalog = async (catalog) => {

      if (catalog == 0) {
         setCatalogSelect(catalog)
         setCategories(allCategories)
      } else {
         setCatalogSelect(catalog.catalog_id)
         setCategories(catalog.categories)
         let catalogToCategories = []
         allCategories.forEach((category) => {
            let filter = catalog.categories.find(({ category_id }) => category_id == category.category_id)

            if (filter != undefined) {
               catalogToCategories.push(category)
            }
         })
         setCategories(catalogToCategories)
      }

   }

   //function filter products by category
   const selectCategorie = async (categorie) => {

      console.log("seleccion categorias------------------------------*-*-*-*-*-*-*-*-*");
      setCategorieSelect(categorie)
      //clean input filter menu
      document.getElementById("searchInput").value = "";
      setSearchTerm("");

      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      if (categorie == "todos") {
         setProducts(applyPointsMenuFilter(temporalProducts))
         setViewProducts(applyPointsMenuFilter(temporalProducts))
      } else if (categorie == "promociones") {
         promotions();
      } else if (categorie == "favorite") {
         setProducts(applyPointsMenuFilter(favorites))
         setViewProducts(applyPointsMenuFilter(favorites))
      } else {
         let categorieJson = categorie
         let category_id = categorieJson.category_id

         if ((categorieJson.groups.length + categorieJson.combos.length) > 0) {
            console.log("data local");

            let allProducts = categorieJson.groups.concat(categorieJson.combos)
            console.log(allProducts);
            setProducts(applyPointsMenuFilter(allProducts))
            setViewProducts(applyPointsMenuFilter(allProducts))
         } else {
            try {
               const response = await ProductsFetchAPI.getProductsByBranchOfficessByStatusByCategories(category_id, branchoffice.id, 1, token)
               setProducts(applyPointsMenuFilter(response.data.data))
               setViewProducts(applyPointsMenuFilter(response.data.data))
               console.log("data por categoria");
               console.log(products);
            } catch (err) {
               setProducts([])
               setViewProducts([])
               console.log("No hay productos aqui ");
               console.log(err);
            }
         }
      }
   }


   // function set product select
   const selectProductoInfo = async (info) => {



      setShowModalSelectItem(true)


      //clean input filter menu
      document.getElementById("searchInput").value = "";
      setSearchTerm("");

      setPreviewSegment([]);

      //We set the amount of the product
      setNumber(1);
      //We set for default the amount of the info product selected on 1
      info.amount = 1;
      info.cantidadItem = 1;
      //We set the info of the product and segment


      if (info.promotion_id) {

         getSegmentByPromotion(info)
      } else {
         getSegmentByProduct(info)
      }

      //getSegmentByProduct(info.group_id)

   }

   //view product select
   const contentProduct = () => {
      const contentetProductInfo = (
         <>

         </>
      );
      return (contentetProductInfo)
   }

   const handlerchangePriceProductGeneric = (e) => {
      console.log(selectProduct);
      console.log(e.target.value);
      selectProduct.price = parseFloat(e.target.value)
      console.log(selectProduct.price);
      setSelectProduct(selectProduct)
   }

   const handlerchangeTaxProductGeneric = (e) => {
      console.log(e.target.value);
      selectProduct.taxtValue = parseFloat(e.target.value)
      console.log(selectProduct.price);
      setSelectProduct(selectProduct)
   }

   //view segments by products
   const contentSegments = () => {

      const contentetProductInfo = segments.map((segment, index) => (
         <>
            {segment.items.length > 0 ? <>

               <div key={index}>
                  <h5 className='pt-1 text-underline mt-3 title-segments-modal'>
                     <u>{segment.name} {segment.type === "UNIQ"
                        ? <><small className='text-muted opacity-25'>(<i class="fa-solid fa-circle-info"></i> Solo puedes elegir una opción.)</small></>
                        : <><small className='text-muted opacity-25'>(<i class="fa-solid fa-circle-info"></i> Puedes seleccionar una o varias opciones.)</small></>}</u>

                  </h5>
               </div>
               <div className='' key={index}>
                  <div className="mt-1 ms-1 overflow-auto d-flex gap-3">
                     {segmentsItems(segment)}
                  </div>
               </div>


            </>


               : <>  </>}
         </>
      ));
      return (contentetProductInfo)
   }

   //Function to populate the segment items
   const segmentsItems = (segment) => {
      //validates the item by default and if it does not exist, sets the first position
      let itemSegments = segment.items
      let turnDefault = false


      itemSegments.forEach((item) => {
         if (segment.segment_item_id_default == item.item_id) {
            turnDefault = true
            item.turnDefault = true
         }
      })

      //set first position
      if (turnDefault == false) { itemSegments[0].turnDefault = true }

      const listItems = itemSegments.map((item, index) => (<>
         <div className="btn-group my-1 ms-1" role="group" >
            <input

               className="btn-check-sp input-visually-hidden"
               type={segment.type == "UNIQ" ? "radio" : "checkbox"}
               name={"listGroupCheckableRadios" + segment.segment_id}
               id={"listGroupCheckableRadios" + segment.segment_id + item.item_id}
               onChange={() => (previewSegmentDetected(segment, item))}
               //defaultChecked={segment.segment_item_id_default === item.item_id || (!segment.segment_item_id_default && item.item_id === segment.items[0].item_id)}
               defaultChecked={segment.default_items.length == 0 ? index == 0 ? true : false : segment.default_items.find((default_item) => default_item.item_id == item.item_id) != undefined ? true : false}
            //defaultChecked={item.turnDefault}
            />
            <label
               htmlFor={"listGroupCheckableRadios" + segment.segment_id + item.item_id}
               className={`btn btn-choice p-lg-2 p-1  border `}>
               <div className='d-lg-flex align-items-lg-center  justify-content-lg-start flex-nowrap d-grid '>
                  <div className="  py-1 rounded me-1" >

                     {!hidden ? (
                        <div className={`fade-enter fade-enter-active`}>
                           <img
                              src={buildCloudinaryImageUrl({ url: item.img, width: 300, height: 300, quality: "auto", type: "image" }) || img_default}
                              width="50" height="50" className="rounded-circle flex-shrink-0 border"
                              alt="Product"
                              loading="lazy"
                           />
                        </div>
                     ) : (
                        <> </>
                     )}

                  </div>
                  <span>
                     {item.name} hhh  <div className='block'>
                        <div class="text-primary-emphasis rounded-pill small">
                           {formatModifierPrice(item.price)}</div>
                     </div>
                  </span>

               </div>

            </label>

         </div>
      </>
      ));
      return (listItems)
   }

   //Template card Group of setGroup
   const cardGroup = (product) => {
      return (
         <div className="card-group">
            <div className="card">
               <div className='d-flex justify-constent- between'>
                  <img loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, height: 300, quality: "auto", type: "image" }) || img_default} className='m-2' alt="..." width="50" height="50" />
                  <div className="card-body">
                     <h5 className="card-title">{product.name}</h5>
                     <p className="card-text">{product.description}</p>
                     <details close >
                        <summary className=''>
                           <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                              <i className="uil uil-info-circle  px-1 "></i>  Detalles
                           </span>
                        </summary>
                        {(Array.isArray(product.segments) ? product.segments : []).map(item => (
                           <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                              {/* <span className='kiosk-subtitle-s' >   </span> */}
                              <span className='text-muted m-0 p-0'>{item.segment_name ? item.segment_name : item.name}:</span>
                              <br />
                              <strong>
                                 <span className='me-2'>{item.name} </span>
                                 {item.price ? getModifierPrice(item.price).toFixed(2) : getModifierPrice(item.item?.price || 0).toFixed(2)}
                              </strong>
                           </span>
                        ))}
                     </details>
                  </div>
               </div>
            </div>
         </div>
      )
   }

   const previewSegmentDetected = (segment, item) => {
      let arrayTemporal = previewSegment
      console.log(previewSegment);
      if (previewSegment.length > 0) {
         let include = true;
         for (let i = 0; i < arrayTemporal.length; i++) {
            if (arrayTemporal[i].segment.segment_id == segment.segment_id) {
               arrayTemporal[i].item = item
               include = false
            }
         }
         if (include == true) {
            let jsonSegmentTem = { segment: segment, item: item }
            arrayTemporal.push(jsonSegmentTem)
         }
      } else {
         let jsonSegmentTem = { segment: segment, item: item }
         arrayTemporal.push(jsonSegmentTem)
      }

      let pricePreviewTemp = selectProduct.price
      arrayTemporal.forEach((i) => {
         pricePreviewTemp = (pricePreviewTemp + getModifierPrice(i.item.price))
      });
      console.log(arrayTemporal);
      setPreviewPriceItemsegmentSelect(pricePreviewTemp);

      setPreviewSegment(arrayTemporal)
      setEventHandlerPreviewsegment(1)
   }

   //Function to listen the swicht
   const handleSwitchChange = async (event) => {
      //We set the data to update

      let product = JSON.parse(event.target.value)
      let newDelivery_type = ""
      let validAllTypeOrder = true

      if (event.target.checked == true) {
         newDelivery_type = "comer aqui"
      } else {
         newDelivery_type = "para llevar"
      }

      let oldDelivery_typeItem = ""

      if (product.combo_id) {
         shoppingCartCombos.forEach((item, index) => {
            EditTypeProduct(item, index)
         });
      } else {
         shoppingCart.forEach((item, index) => {
            EditTypeProduct(item, index)
         });
      }

      function EditTypeProduct(item, index) {
         if (JSON.stringify(item) == JSON.stringify(product)) {
            item.delivery_type = newDelivery_type;
         }

         if (index !== 0) {
            if (item.delivery_type != oldDelivery_typeItem) {
               validAllTypeOrder = false
            }
         }
         oldDelivery_typeItem = item.delivery_type
      }

      if (validAllTypeOrder == false) {
         setCheckDeliveryOrder("mixto")
      } else {
         setCheckDeliveryOrder(newDelivery_type)
      }

      setShoppingCart(shoppingCart)
      setEventHandler(1)
   };

   const viewSelectSegmentItem = () => {
      const contentlistPreview = previewSegment.map((segmentpreview, index) => (
         <>

            <div className='col-sm-6 ' key={index}>
               <h6 className="pt-1 fw-bold text-underline">
                  <u>{segmentpreview.segment.name}:</u>
               </h6>
               <div className='bg-light border-sp d-flex align-items-center justify-content-center' >
                  <div className='d-flex align-items-center justify-content-center'>
                     <img loading='lazy' src={buildCloudinaryImageUrl({ url: segmentpreview.item.img, width: 300, quality: "auto", type: "image" }) || businessLogo} className=" border-sp m-2 " width="30px" />
                  </div>
                  <div className='m-2 d-flex align-items-center justify-content-center'>
                     <h6>{segmentpreview.item.name}</h6>
                  </div>
               </div>
            </div>
         </>
      ));
      return (contentlistPreview)
   }


   //Function to add format products to the shopping cart
   const addProductUpc = (selectProduct, segmentsTemp) => {
      //------------------------------------------------------------

      //For default we set that the amount of the selected product depending the number 
      if (selectProduct.img === null || selectProduct.img === "") {
         selectProduct.img = businessLogo
      }
      selectProduct.isNewAdd = true;
      selectProduct.amount = number;
      selectProduct.cantidadItem = number;
      selectProduct.delivery_type = "comer aqui";
      selectProduct.note = notesItem;
      selectProduct.unit_discount = 0;
      selectProduct.product_discount = 0;
      selectProduct.descuento = selectProduct.product_discount;
      selectProduct.discount = selectProduct.product_discount;
      selectProduct.kitchen_action = "send_to_kitchen"; // <-- NEW
      applyPointsPaymentData(selectProduct);

      //For default we initialice the segments empty of the selected product
      selectProduct.segments = [];
      selectProduct.DetalleSegmentos = [];
      selectProduct.segments_string = "" + selectProduct.group_id
      //We set the segment items selected on the product selected

      let temporal_segment_string = ""
      segmentsTemp.forEach((segment) => {
         let defaultCheckedSegment = segment.segment_item_id_default
         let items = segment.items

         if (defaultCheckedSegment == null || defaultCheckedSegment == "" || defaultCheckedSegment == undefined) {
            let item = items[0]
            let itemToAdd = buildModifierItemForProduct(item, selectProduct)
            //temporal_segment_string = selectProduct.segments_string + " " + segment.name + ": " + item.name
            //selectProduct.segments_string = selectProduct.segments_string + " " + segment.name + ": " + item.name
            temporal_segment_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            selectProduct.segments_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
            selectProduct.segments.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: 1, item: { name: itemToAdd.name, description: itemToAdd.description, img: itemToAdd.img, price: itemToAdd.price, item_id: itemToAdd.item_id, amount: 1, taxtValue: itemToAdd.taxtValue, tax: itemToAdd.tax, external_reference: itemToAdd.external_reference } })
            selectProduct.DetalleSegmentos.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: 1, item: { name: itemToAdd.name, description: itemToAdd.description, img: itemToAdd.img, price: itemToAdd.price, item_id: itemToAdd.item_id, amount: 1, taxtValue: itemToAdd.taxtValue, tax: itemToAdd.tax, external_reference: itemToAdd.external_reference } })
            selectProduct.price = selectProduct.price + itemToAdd.price
         } else {
            items.forEach((item) => {
               if (item.item_id == defaultCheckedSegment) {
                  let itemToAdd = buildModifierItemForProduct(item, selectProduct)
                  temporal_segment_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
                  selectProduct.segments_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
                  selectProduct.segments.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: 1, item: { name: itemToAdd.name, description: itemToAdd.description, img: itemToAdd.img, price: itemToAdd.price, item_id: itemToAdd.item_id, amount: 1, taxtValue: itemToAdd.taxtValue, tax: itemToAdd.tax, external_reference: itemToAdd.external_reference } })
                  selectProduct.DetalleSegmentos.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: 1, item: { name: itemToAdd.name, description: itemToAdd.description, img: itemToAdd.img, price: itemToAdd.price, item_id: itemToAdd.item_id, amount: 1, taxtValue: itemToAdd.taxtValue, tax: itemToAdd.tax, external_reference: itemToAdd.external_reference } })
                  selectProduct.price = selectProduct.price + itemToAdd.price
               }
            });
         }
      });

      addProductSelectToShoppingcart(selectProduct, temporal_segment_string)

      let asholp = shoppingCart
      console.log('Carrito Products ', asholp);

      setPreviewSegment([])
      setSegments([])
      setNotesItem("")

      //--------------------
      handlerInputFocus()
   }

   const getInventory = async (product) => {

      if (product.group_type === "infinite") { selectProductoInfo(product) } else {
         let data = { "products": [] }
         data = { "products": [{ "group_id": product.group_id }] }
         try {
            const response = await InventoryFechtAPI.getInventoryByProducts(data, localStorage.getItem("x-access-machine-token"))
            let dataInventory = response.data.inventory

            dataInventory[0].branchoffices.forEach((data) => {
               if (data.branchoffice_id == branchoffice.id) {
                  if (warehouseSelected.id != 0 && warehouseSelected.id != undefined && warehouseSelected.id != null) {
                     let datawarehouse = data.warehouses.find(({ warehouse_id }) => warehouse_id == warehouseSelected.id)
                     if (datawarehouse != undefined) {
                        validInventory(parseInt(datawarehouse.quantity), true)
                     } else {
                        ErrorAlert('', 'Este producto no tiene inventario disponible en la bodega ' + warehouseSelected.name, 'info')
                     }
                  } else {
                     validInventory(parseInt(data.quantity))
                  }
                  //Validates the inventory by quantity
                  function validInventory(quantity, warehouse) {
                     console.log(quantity);
                     if (quantity > 0) {
                        product.quantity = parseInt(quantity)
                        if (warehouse == true) {
                           product.warehouse_id = warehouseSelected.id
                        }
                        selectProductoInfo(product)
                        if (parseInt(quantity) < 20) {
                           let amountNow = 0
                           shoppingCart.forEach((item) => {
                              if (item.group_id == product.group_id) {
                                 amountNow = (amountNow + item.amount)
                              }
                           })
                           ErrorAlert('', "Este producto tiene " + (quantity - amountNow) + " inventario bajo", 'warning')
                        }

                     } else {
                        ErrorAlert('', 'Este producto no tiene inventario disponible', 'info')
                     }
                  }
               }
            })
         } catch (err) {
            console.log(err.response.data.message);
            selectProductoInfo(product)

         }
      }
   }


   //Function to add format products to the shopping cart
   const addProduct = (e) => {
      console.log(selectProduct)
      //------------------------------------------------------------
      e.preventDefault();
      formatJsonToAddShoppingCart()

      setStep(1);

      //For default we set that the amount of the selected product depending the number 
      /*if (selectProduct.img === null || selectProduct.img === "") {
         selectProduct.img = businessLogo
      }
      selectProduct.amount = number;
      selectProduct.cantidadItem = number;
      selectProduct.delivery_type = "comer aqui";
      selectProduct.note = notesItem;
      selectProduct.unit_discount = 0;
      selectProduct.product_discount = 0;
      selectProduct.descuento = selectProduct.product_discount;
      selectProduct.discount = selectProduct.product_discount;
      //For default we initialice the segments empty of the selected product
      selectProduct.segments = [];
      selectProduct.DetalleSegmentos = [];
      selectProduct.segments_string = ""
      //We set the segment items selected on the product selected

      let temporal_segment_string = ""
      for (let s = 0; s < segments.length; s++) {
         let segment = segments[s];

         for (let i = 0; i < segment.items.length; i++) {
            let item = segment.items[i]
            let radiobutton = document.getElementById("listGroupCheckableRadios" + segment.segment_id + item.item_id);

            if (radiobutton.checked) {
               temporal_segment_string = selectProduct.segments_string + " " + segment.name + ": " + item.name
               selectProduct.segments_string = selectProduct.segments_string + " " + segment.name + ": " + item.name
               selectProduct.segments.push({ ...item, segment_name: segment.name, cantidadItem: number, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: number, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
               selectProduct.DetalleSegmentos.push({ ...item, segment_name: segment.name, cantidadItem: number, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: number, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
               selectProduct.price = selectProduct.price + item.price
            }
         }

      }


      if (selectProduct.promotion_id) {
         addpromotionToShoppiingCart()
      } else {
         addProductSelectToShoppingcart(selectProduct, temporal_segment_string)
      }


      setPreviewSegment([])
      setSegments([])
      setNotesItem("")

      //restorage data menu
      let generalData = JSON.parse(localStorage.getItem('generalData'))

      dataconsolidation(generalData)

      if (categorieSelect == 'promociones') {
         selectCategorie('todos')
      } else {
         selectCategorie(categorieSelect)
      }*/
      //-----------------------------------------

   }

   // format json of product to add shopppingcart
   const formatJsonToAddShoppingCart = (dataProduct, status, addAuto, segmentsAuto) => {
      let formatProductAdd = {}
      let idCheckBox = ""
      let detailSegments = []
      if (dataProduct == undefined) {
         formatProductAdd = selectProduct
         idCheckBox = "listGroupCheckableRadios"
         detailSegments = segments
      } else {
         formatProductAdd = dataProduct
         idCheckBox = "listGroupCheckableRadios"

         if (addAuto == true) {
            detailSegments = segmentsAuto

            console.log(detailSegments);
         } else {
            detailSegments = segmentsNow
            console.log(formatProductAdd);
         }
      }

      if (formatProductAdd.img == null || formatProductAdd.img == "" || formatProductAdd.img == undefined) {
         formatProductAdd.img = businessLogo
      }
      //For default we set that the amount of the selected product depending the number
      formatProductAdd.isNewAdd = true;
      formatProductAdd.amount = number;
      formatProductAdd.cantidadItem = number;
      formatProductAdd.delivery_type = "comer aqui";
      formatProductAdd.note = notesItem;
      formatProductAdd.unit_discount = 0;
      formatProductAdd.product_discount = 0;
      formatProductAdd.base_price = formatProductAdd.price;
      formatProductAdd.valueOriginal = formatProductAdd.price;
      formatProductAdd.descuento = formatProductAdd.product_discount;
      formatProductAdd.discount = formatProductAdd.product_discount;
      formatProductAdd.kitchen_action = "send_to_kitchen"; // <-- NEW
      applyPointsPaymentData(formatProductAdd);
      //For default we initialice the segments empty of the selected product 
      formatProductAdd.segments = [];
      formatProductAdd.DetalleSegmentos = [];
      formatProductAdd.segments_string = "" + (shoppingCart.length + 1) + formatProductAdd.group_id

      //find segments checked
      let temporal_segment_string = ""
      detailSegments.forEach((segment) => {

         if (addAuto == true) {
            if (segment.segment_item_id_default == null) {
               let dataFirsItem = segment.items[0]
               addItem(dataFirsItem)
            } else {
               segmentsItems()
            }
         } else {
            segmentsItems()
         }

         //Scooch items of segment
         function segmentsItems() {
            segment.items.forEach((item) => {

               if (addAuto == true) {//if addAuto is true add automatic item defauld in group
                  if (item.item_id == segment.segment_item_id_default) {
                     addItem(item)
                  }

               } else {
                  let idCheckedItem = document.getElementById(idCheckBox + segment.segment_id + item.item_id)
                  if (idCheckedItem.checked == true) {
                     addItem(item)
                  }
               }
            })
         }

         //Add item selected
         function addItem(itemNow) {
            const itemToAdd = buildModifierItemForProduct(itemNow, formatProductAdd)
            itemToAdd.amount = number
            temporal_segment_string = formatProductAdd.segments_string + "" + segment.segment_id + "" + itemToAdd.item_id
            formatProductAdd.segments_string = formatProductAdd.segments_string + "" + segment.segment_id + "" + itemToAdd.item_id
            formatProductAdd.segments.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: number, item: itemToAdd })
            formatProductAdd.DetalleSegmentos.push({ ...itemToAdd, segment_name: segment.name, cantidadItem: number, item: itemToAdd })
            formatProductAdd.price = formatProductAdd.price + itemToAdd.price
         }

      });

      if (status == true) {
         saveDataGroupByCombo(formatProductAdd)
      } else {
         if (formatProductAdd.promotion_id) {
            addpromotionToShoppiingCart()
         } else {
            if (formatProductAdd.quantity) {

               let filter = shoppingCart.filter(group => group.group_id == selectProduct.group_id)
               console.log(filter);

               let amountNow = 0
               if (filter != undefined && filter.length > 0) {
                  filter.forEach(group => { amountNow = (amountNow + group.amount) })
               }

               console.log(amountNow);

               let newLimit = (selectProduct.quantity - amountNow)
               console.log(newLimit);
               if (newLimit >= number) {
                  addProductSelectToShoppingcart(formatProductAdd, temporal_segment_string)
               } else {
                  ErrorAlert("", "Este producto ya llego a limite de cantidad disponible en la cartilla", "info")
               }
            } else {
               addProductSelectToShoppingcart(formatProductAdd, temporal_segment_string)
            }
         }



         if (categorieSelect == 'promociones') {
            //selectCategorie('promociones')
            clearDataInfoProduct('promociones')
         } else {
            //selectCategorie(categorieSelect)
            clearDataInfoProduct(true)
         }
         //-----------------------------------------

      }
      setPreviewSegment([])
      setSegments([])
      setNotesItem("")
   }

   const saveDataGroupByCombo = (data) => {
      let setGroup = selectProduct.setGroups[activeTab]
      setGroup.activeTab = activeTab
      setGroup.ready = true

      let comboFind = comboSelect.find(({ set_id }) => set_id === setGroup.set_id)
      if (comboFind) {
         let comboIndex = comboSelect.findIndex(({ set_id }) => set_id === setGroup.set_id)
         let groupindex = comboSelect[comboIndex].groupsselected.findIndex(({ group_id }) => group_id === data.group_id)
         if (groupindex == -1) {
            if (comboSelect[comboIndex].count > 1) {
               comboSelect[comboIndex].groupsselected.push(data)
            } else {
               comboSelect[comboIndex].groupsselected = [data]
            }
         } else {
            comboSelect[comboIndex].groupsselected[groupindex] = data
         }
      } else {
         setGroup.groupsselected = []
         setGroup.groupsselected.push(data)
         comboSelect.push(setGroup)
      }
      stepSaveCombos()
   }

   //Esta funcion verifica que todos los pasos del combo se cumplan 
   const stepSaveCombos = (alert) => {
      //guarda tamaño del setgroups original
      let sizeSetGroups = selectProduct.setGroups.length;
      //convierte el tamaño del arreglo en un nuevo indice
      let array = Array.from({ length: sizeSetGroups }, (_, index) => index);
      let stepReady = [];

      //recorre el arreglo de los setGroups ya seleccionados y gusrda su index en un array 
      comboSelect.forEach((group) => {
         stepReady.push(group.activeTab)
      })
      setStepsReadyComboNow(stepReady)

      //Filtra los indices faltantes 
      let pendingStep = array.filter(index => !stepReady.includes(index));
      if (pendingStep.length > 0) {
         setActiveTab(pendingStep[0])
         if (alert == true) {
            ErrorAlert("Faltan pasos por completar", "Por favor completa todos los pasos del combo", "warning");
         }

      } else {
         let comboReadyFormat = {}
         comboReadyFormat.name = selectProduct.name
         comboReadyFormat.description = selectProduct.description
         comboReadyFormat.price = selectProduct.price
         comboReadyFormat.priceBase = selectProduct.price
         comboReadyFormat.img = selectProduct.img
         comboReadyFormat.combo_id = selectProduct.combo_id
         comboReadyFormat.descuento = 0
         comboReadyFormat.discount = 0
         comboReadyFormat.unit_discount = 0
         comboReadyFormat.taxes = selectProduct.taxes
         comboReadyFormat.external_reference = selectProduct.external_reference
         comboReadyFormat.note = notesItem
         comboReadyFormat.delivery_type = "comer aqui"
         comboReadyFormat.amount = number
         comboReadyFormat.isNewAdd = true
         comboReadyFormat.setGroups = []
         comboReadyFormat.setGroupString = ""
         comboReadyFormat.referenced_group = selectProduct.referenced_group
         comboReadyFormat.referenced_group_id = selectProduct.referenced_group_id
         comboReadyFormat.kitchen_action = "send_to_kitchen";
         comboReadyFormat.can_be_paid_with_points = selectProduct.can_be_paid_with_points
         comboReadyFormat.points_value = selectProduct.points_value
         applyPointsPaymentData(comboReadyFormat);
         let newPrice = 0
         comboSelect.forEach((combo) => {
            let newSetGroup = {}
            newSetGroup.name = combo.name
            newSetGroup.set_id = combo.set_id
            newSetGroup.groups = combo.groupsselected
            newSetGroup.isMainSetGroup = combo.isMainSetGroup
            comboReadyFormat.setGroups.push(newSetGroup)
            comboReadyFormat.setGroupString = comboReadyFormat.setGroupString + combo.name

            combo.groupsselected.forEach((group) => {
               comboReadyFormat.setGroupString = comboReadyFormat.setGroupString + group.segments_string
               newPrice = newPrice + group.price
            })
         })

         comboReadyFormat.price = (selectProduct.price + newPrice)
         let coincidence = false

         let cant = 0
         let datacombo = {}
         for (let i = 0; i < shoppingCartCombos.length; i++) {
            if (shoppingCartCombos[i].setGroupString === comboReadyFormat.setGroupString) {
               if (shoppingCartCombos[i].discount == 0) {
                  coincidence = true
                  cant = (shoppingCartCombos[i].amount + number)
                  console.log(cant);
                  shoppingCartCombos[i].amount = cant
                  datacombo = shoppingCartCombos[i]
               }
            }
         }
         if (coincidence == true) {
            setShoppingCartCombos(shoppingCartCombos)
            calculateInvoiceTotals(shoppingCart, shoppingCartCombos)
         } else {
            console.log(comboReadyFormat);
            setShoppingCartCombos([...shoppingCartCombos, comboReadyFormat])
            calculateInvoiceTotals(shoppingCart, [...shoppingCartCombos, comboReadyFormat])
         }
         setActiveTab(0)
         setComboSelect([])
         clearDataInfoProduct(true)
         setShowModalSelectItem(false);
         setShow(false)

      }
   }


   const deleteSetGroupOfComboSelected = (setgroupActive) => {

      selectProduct.setGroups[setgroupActive].ready = false
      let removeFilter = comboSelect.filter(({ activeTab }) => activeTab != setgroupActive)

      setComboSelect(removeFilter)
      stepSaveCombos()
      //sethandlerEventAction(1)
   }

   const addpromotionToShoppiingCart = () => {
      let turn = 0
      shoppingCart.forEach((product) => {

         if (product.promotion_id) {
            if (product.promotion_id == selectProduct.promotion_id) {
               /*if (selectProduct.segments_string == product.segments_string) {
                  console.log("este producto ya esta");
                  shoppingCart.amount = (shoppingCart.amount + number)
                  shoppingCart.cantidadItem = shoppingCart.amount
                  turn = 1
               }*/
               ErrorAlert("Puedes incrementar la cantidad del mismo en el carrito.", "Ya existe esta promocion en el carrito.", "warning");
               turn = 1
            }
         }

      });

      if (turn == 0) {
         //We add the new product to the shopping cart
         setShoppingCart([...shoppingCart, selectProduct]);
         //We calculate the invoice totals
         calculateInvoiceTotals([...shoppingCart, selectProduct], shoppingCartCombos)

         if (checkDeliveryOrder != "comer aqui") { setCheckDeliveryOrder("mixto") }
      } else {
         setShoppingCart(shoppingCart)
         //We calculate the invoice totals
         calculateInvoiceTotals(shoppingCart, shoppingCartCombos)
      }

      selectCategorie("promociones")
   }


   const handlerEditPriceProduct = () => {
      // Solo al guardar, suma el precio base y los segmentos y actualiza el carrito
      let ShoppingCarteditProduct = [...shoppingCart];
      ShoppingCarteditProduct.forEach((product, index) => {
         if (index === productEditPriceTemp.index) {
            // Sumar precio base y segmentos editados
            product.name = productEditPriceTemp.name;
            product.description = productEditPriceTemp.description;
            const basePrice = parseFloat(productEditPriceTemp.price) || 0;
            const editedSegments = productEditPriceTemp.segments.map(seg => ({
               ...seg,
               price: parseFloat(seg.price) || 0
            }));
            const segmentsTotal = editedSegments.reduce((acc, seg) => acc + seg.price, 0);
            product.price = basePrice + segmentsTotal;
            product.segments = editedSegments;

         }
      });
      setShoppingCart(ShoppingCarteditProduct);
      calculateInvoiceTotals(ShoppingCarteditProduct, shoppingCartCombos);
      setShowModalEditPrice(false);
   }


   const getCartProductKey = (product = {}) => {
      return [
         product.group_id || product.combo_id || product.id || "",
         product.segments_string || product.setGroupString || "",
         product.name || "",
      ].join("|");
   }

   const removeProductFromRemovedPreOrderList = (product) => {
      const productKey = getCartProductKey(product);
      setRemovedPreOrderShoppingCartProducts((prev) =>
         prev.filter((removedProduct) => getCartProductKey(removedProduct) !== productKey)
      );
   }

   const isRecoveredPreOrderProduct = (product = {}) => (
      product.amount_Original !== undefined
      && product.amount_Original !== null
      && product.amount_Original !== ""
      && product.isNewAdd !== true
   );

   const addProductToRemovedPreOrderList = (product) => {
      if (preOrderInvoice !== true || !isRecoveredPreOrderProduct(product)) return;

      const productKey = getCartProductKey(product);
      setRemovedPreOrderShoppingCartProducts((prev) => {
         const alreadyRemoved = prev.some((removedProduct) => getCartProductKey(removedProduct) === productKey);
         return alreadyRemoved ? prev : [...prev, product];
      });
   }

   const getCartItemAmount = (product = {}) => Number(product.amount ?? product.cantidadItem ?? 0);

   const cartItemNeedsPreOrderUpdate = (product = {}) => {
      const hasOriginalAmount = product.amount_Original !== undefined
         && product.amount_Original !== null
         && product.amount_Original !== "";

      return product.isNewAdd === true
         || Number(product.amount_to_impress || 0) > 0
         || !hasOriginalAmount
         || getCartItemAmount(product) !== Number(product.amount_Original);
   }

   const hasPendingPreOrderCartChanges = preOrderInvoice === true
      && selectPreOrder?.is_quote_order !== true
      && (
         removedPreOrderShoppingCartProducts.length > 0
         || shoppingCart.some(cartItemNeedsPreOrderUpdate)
         || shoppingCartCombos.some(cartItemNeedsPreOrderUpdate)
      );




   //add product to shopingcart
   const addProductSelectToShoppingcart = (selectProductItem, temporal_segment_string) => {

      let temporalShopingCart = [...shoppingCart]
      let turn = 0
      //check item string segments into shopingcart
      for (let shopping = 0; shopping < temporalShopingCart.length; shopping++) {

         if (selectProductItem.group_id == temporalShopingCart[shopping].group_id) {

            console.log(temporalShopingCart[shopping].segments_string);
            console.log(temporal_segment_string);
            if (temporalShopingCart[shopping].segments_string === temporal_segment_string) {
               console.log();
               if (temporalShopingCart[shopping].descuento == 0) {
                  console.log("este producto ya esta");
                  temporalShopingCart[shopping] = {
                     ...temporalShopingCart[shopping],
                     amount: (temporalShopingCart[shopping].amount + number)
                  }
                  temporalShopingCart[shopping].cantidadItem = temporalShopingCart[shopping].amount
                  turn = 1
               }
            } else {

            }
         }

      }

      if (turn == 0) {
         //We add the new product to the shopping cart
         const updatedShoppingCart = [...shoppingCart, selectProductItem];
         removeProductFromRemovedPreOrderList(selectProductItem);
         setShoppingCart(updatedShoppingCart);
         //We calculate the invoice totals
         calculateInvoiceTotals(updatedShoppingCart, shoppingCartCombos)
         if (checkDeliveryOrder != "comer aqui") { setCheckDeliveryOrder("mixto") }
      } else {
         removeProductFromRemovedPreOrderList(selectProductItem);
         setShoppingCart([...temporalShopingCart])
         //We calculate the invoice totals
         calculateInvoiceTotals([...temporalShopingCart], shoppingCartCombos)
      }
   }

   //Function to delete a product of the shopping cart
   const deleteProduct = (product_index, group) => {
      //We delete the product of the shopping cart list
      if (group == true) {
         const product = shoppingCart[product_index];
         shoppingCart.splice(product_index, 1);
         setShoppingCart([...shoppingCart]);
         if (preOrderInvoice == true && product) {
            addProductToRemovedPreOrderList(product);
         }
      } else {
         shoppingCartCombos.splice(product_index, 1);
         setShoppingCartCombos([...shoppingCartCombos]);
      }

      //We recalculate the invoice totals
      calculateInvoiceTotals([...shoppingCart], [...shoppingCartCombos])

      if (preOrderInvoice == true) {
         if (shoppingCart.length == 0) {
            setPageLoader(1);
         }
      }
   }

   const handleQuantityChange = (product_index, group, newQuantity) => {

      let quantity = parseInt(newQuantity);
      if (quantity > 0) {
         incrementProductAmount(product_index, group, quantity)
      } else {
         deleteProduct(product_index, group)
      }
   };

   // Recalculates the pending-to-print quantity for a recovered pre-order line
   // after its amount changes, so the + / - buttons produce a new comanda send.
   const syncPendingImpressAmount = (product) => {
      if (!product) return;
      product.amount_to_impress = getPendingImpressAmountAfterQuantityChange(product);
   };

   //Function to incremet the product amount on the shopping cart
   const incrementProductAmount = (product_index, group, directAmount) => {
      //We search the product on the list
      let product = {}
      if (group == true) {
         product = shoppingCart[product_index];

         if (product.quantity) {

            let filter = shoppingCart.filter(group => group.group_id == product.group_id)
            console.log(filter);

            let amountNow = 0
            if (filter != undefined && filter.length > 0) {
               filter.forEach(group => { amountNow = (amountNow + group.amount) })
            } else {
               amountNow = product.amount
            }

            console.log(amountNow);

            if (product.quantity > amountNow) {
               if (directAmount != undefined) {
                  product.amount = directAmount
               } else {
                  product.amount = product.amount + 1;
               }
            } else {
               const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  width: 600,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                     toast.onmouseenter = Swal.stopTimer;
                     toast.onmouseleave = Swal.resumeTimer;
                  }
               });
               Toast.fire({
                  icon: "info",
                  title: "Este producto solo tiene " + product.quantity + " unidades disponibles"
               });
            }
         } else {
            if (directAmount != undefined) {
               product.amount = directAmount
            } else {
               product.amount = product.amount + 1;
            }
         }



      } else {
         product = shoppingCartCombos[product_index];
         if (directAmount != undefined) {
            product.amount = directAmount
         } else {
            product.amount = product.amount + 1;
         }
      }



      //We affect the product data

      product.cantidadItem = product.amount;
      syncPendingImpressAmount(product);
      syncProductPointsTotal(product);
      product.descuento = product.descuento + product.unit_discount;
      product.discount = product.discount + product.unit_discount;

      //We set the handler to recharge the data
      setEventHandler(1);
   };

   //Function to incremet the product amount on the shopping cart
   const decrementProductAmount = (product_index, group) => {
      //We search the product on the list
      let product = {}

      if (group == true) {
         product = shoppingCart[product_index];
      } else {
         product = shoppingCartCombos[product_index];

      }
      //We affect the product data
      product.amount = product.amount - 1;
      product.cantidadItem = product.amount
      syncPendingImpressAmount(product);
      syncProductPointsTotal(product);
      product.descuento = product.descuento - product.unit_discount;
      product.discount = product.discount - product.unit_discount;

      //We check if the product amount is lower than 0
      if (product.amount <= 0) {
         //if is lower or equal to 0 we delete the product of the shopping cart list
         if (group == true) {
            shoppingCart.splice(product_index, 1);
            setShoppingCart([...shoppingCart])
            addProductToRemovedPreOrderList(product)
         } else {
            shoppingCartCombos.splice(product_index, 1);
            setShoppingCartCombos([...shoppingCartCombos])
         }
      }



      //We set the handler to recharge the data
      setEventHandler(1)
   };


   //decimal reduction
   const decimalReduction = (value) => {

      let string = value.toString()
      let arrayString = string.split(".");
      let newDecimalString = []
      let sample = ''
      if (arrayString[1] != undefined) {
         newDecimalString = arrayString[1].slice(0, 2);
         sample = arrayString[0] + "." + newDecimalString
         console.log("Hice la reduccion");
      } else {
         console.log("Array: " + arrayString);
         console.log("Decimal: " + newDecimalString);
         console.log("Nuevo valor: " + sample);
         sample = string;
      }

      let endValue = parseFloat(sample)
      return endValue
   }

   // Función para redondear hacia arriba si el tercer decimal es mayor a 0
   function roundUpToTwoDecimals(value) {
      console.log("Nuevo redondeo de tax");
      console.log(value);
      // Verificamos si hay más de dos decimales
      const decimals = value.toString().split('.')[1];

      if (decimals && decimals.length > 2) {
         // Si el tercer decimal es mayor que 0, redondeamos hacia arriba
         if (parseInt(decimals[2]) > 0) {
            return Math.ceil(value * 100) / 100;
         }
      }

      console.log(parseFloat(value.toFixed(2)));

      // Si ya tiene dos decimales o menos, devolvemos el valor tal cual
      return parseFloat(value.toFixed(2));
   }
   //Function to round to two decimals but if the third decimal is greater than 5, round up
   function roundToTwoDecimals(value) {
      // Verificamos si hay más de dos decimales
      const decimals = value.toString().split('.')[1];

      if (decimals && decimals.length > 2) {
         // Si el tercer decimal es mayor que 5, redondeamos hacia arriba
         if (parseInt(decimals[2]) > 5) {
            console.log("Redondeo hacia arriba");
            return parseFloat((Math.ceil(value * 100) / 100).toFixed(2));
         } else if (parseInt(decimals[2]) == 5) {
            console.log("devolvemos solo los dos decimales iniciales sin redondear");
            return parseFloat(value.toString().split('.')[0] + "." + decimals[0] + decimals[1]);
         }
      } else {
         console.log("Redondeo hacia abajo");
      }

      console.log(parseFloat(value.toFixed(2)));

      // Si ya tiene dos decimales o menos, devolvemos el valor tal cual
      return parseFloat(value.toFixed(2));
   }
   //Function to round to two decimals but if the third decimal is greater than 5 or equal to 5, round up
   function roundToTwoDecimals1(value) {
      // Verificamos si hay más de dos decimales
      const decimals = value.toString().split('.')[1];

      if (decimals && decimals.length > 2) {
         // Si el tercer decimal es mayor que 5, redondeamos hacia arriba
         if (parseInt(decimals[2]) >= 5) {
            return Math.ceil(value * 100) / 100;
         }
      }
      // Si ya tiene dos decimales o menos, devolvemos el valor tal cual
      return parseFloat(value.toFixed(2));
   }

   //Function to calculate the asap fee
   const calculateAsapFee = async () => {
      ErrorAlert("Calculando tarifa de delivery...", "Espere un momento por favor", "info");
      if (localStorage.getItem('addressNowLocation') == null || localStorage.getItem('addressNowLocation') == undefined || localStorage.getItem('addressNowLocation') == "null") {
         ErrorAlert("Para calcular el costo de envío, por favor ingrese una dirección de entrega.", "Alerta", "warning");
         return null
      }
      try {
         let data = {
            "branchoffice_id": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.id,
            "type_id": 1,
            "is_personal": 0,
            "is_oneway": 1,
            "source_lat": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
            "source_long": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
            "desti_lat": addressNowLocation.lat,
            "desti_long": addressNowLocation.lng,
            "vehicle_type": "bike",
            "order_id": 1
         }
         const response = await AsapFetchAPI.getAsapFareOrder(token, data);
         //Success alert
         SuccessAlert("Tarifa de delivery calculada con exito, en asap", "Exito", "success")

         return response.data.asap_response
      } catch (err) {
         ErrorAlert("No se pudo calcular la tarifa de delivery de asap, puede estar fuera de rango", "Alerta", "error")
         return null
      }
   }

   //Function to calculate the tookan fee 
   const calculateTookanFee = async () => {
      ErrorAlert("Calculando tarifa de delivery...", "Espere un momento por favor", "info");
      if (localStorage.getItem('addressNowLocation') == null || localStorage.getItem('addressNowLocation') == undefined || localStorage.getItem('addressNowLocation') == "null") {
         ErrorAlert("Para calcular el costo de envío, por favor ingrese una dirección de entrega.", "Alerta", "warning");
         return null
      }
      try {
         let data = {
            "business_id": JSON.parse(localStorage.getItem('generalData'))[0].data.business.id,
            "pickup_latitude": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
            "pickup_longitude": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
            "delivery_latitude": addressNowLocation.lat,
            "delivery_longitude": addressNowLocation.lng,
         }
         //We make the request to tookan to get the fare
         const response = await TookanFetchAPI.getTookanFareOrder(token, data);
         //Success alert
         SuccessAlert("Tarifa de delivery calculada con exito, en tookan", "Exito", "success")
         //Result
         return response.data.estimate
      } catch (err) {
         ErrorAlert("No se pudo calcular la tarifa de delivery de tookan, puede estar fuera de rango", "Alerta", "error")
         return null
      }
   }

   //------------------------------------------------------------------------------
   //Function to calculate the invoice totals
   const calculateInvoiceTotals = async (products, combos) => {

      console.log(products);
      //For every new calculate we set the totals
      let taxesArray = [];
      let invoiceTotalDiscount = 0
      let invoiceSubtotal = 0
      let invoiceTotalItbms = 0
      let invoiceTotal = 0
      let invoiceBaseReducedTax = 0
      let invoiceDeliveryFee = 0;
      let deliveryFeeTax = 0;

      //if we dont we products we put the totals in 0 for default
      if ((products.length + combos.length) === 0) {
         //We calculate the totals of the invoice
         setInvoiceTotalDiscount(0)
         setInvoiceSubtotal(0);
         setInvoiceTotalItbms(0)
         setInvoiceTotal(0);
         setInvoiceBaseReducedTax(0)
         setInvoiceTotalDelivery(0);
         setInvoiceTaxDeliveryFee(0);

         setTaxesArrayAll(taxesArray)
      } else {

         //For every combos we calculate
         combos.forEach((combo) => {
            byProductandCombo(combo)
         })

         products.forEach((group) => {
            byProductandCombo(group)
         })

         //Esta funcion calcula los valores por producto o combo por posicion
         function byProductandCombo(item) {

            //Variables
            let total_product_price = 0;
            let total_product_itbms = 0;
            let product_total_discount = 0;
            let base_reduced_tax = 0;
            //We set the total discount of the product
            product_total_discount = (item.unit_discount * item.amount);
            //We set the total of the product
            total_product_price = (item.amount * (item.price - item.unit_discount));

            //Calculate tax by group--------------------------------
            let taxesGroup = item.taxes;
            taxesGroup.forEach(tax => {
               //calculate tax  value and add it to array
               let valueTax = 0

               if (tax.tax === "state_tax") {
                  valueTax = roundToTwoDecimals1((item.amount * ((item.price - item.unit_discount) * tax.taxtValue)));
                  //valueTax = (item.amount * ((item.price - item.unit_discount) * tax.taxtValue))
               } else if (tax.tax === "reduced_tax") {
                  valueTax = roundToTwoDecimals1((item.amount * ((item.price - item.unit_discount) * tax.taxtValue)));
                  if (tax.taxtValue > 0) {
                     base_reduced_tax = base_reduced_tax + (item.amount * ((item.price - item.unit_discount)))
                  }
               } else if (tax.tax === "city_tax" && products.length === 1) {
                  valueTax = roundToTwoDecimals1(item.amount * ((item.price - item.unit_discount) * tax.taxtValue))
               } else if (tax.tax === "city_tax" && products.length > 1) {
                  valueTax = roundToTwoDecimals1(item.amount * ((item.price - item.unit_discount) * tax.taxtValue))
               }
               else {
                  valueTax = roundUpToTwoDecimals((item.amount * ((item.price - item.unit_discount) * tax.taxtValue)));
               }

               tax.total = valueTax;
               //Identifier tax of the group position
               var index = taxesArray.findIndex(function (info, i) {
                  return info.tax_id === tax.tax_id
               });

               if (index < 0) {
                  let taxInfoNow = {
                     "dTasaITBMSValue": tax.dTasaITBMSValue,
                     "percentage": tax.percentage,
                     "tax": tax.tax,
                     "tax_id": tax.tax_id,
                     "taxtValue": tax.taxtValue,
                     "total": valueTax
                  }
                  taxesArray.push(taxInfoNow);
               } else {
                  //taxesArray[index].total = roundToTwoDecimals((taxesArray[index].total + valueTax))
                  taxesArray[index].total = (taxesArray[index].total + valueTax)
               }
               console.log(valueTax)
               console.log("Valor del impuesto " + tax.tax + ":  " + valueTax);

               total_product_itbms = (total_product_itbms + valueTax)

            });
            //-------------------------------------------------------
            //We set the itbms of the product
            //total_product_itbms = (product_info.amount * ((product_info.price - product_info.unit_discount) * product_info.taxtValue));

            //We calculate the totals of the invoice
            invoiceTotalDiscount = roundUpToTwoDecimals(invoiceTotalDiscount + product_total_discount);
            invoiceSubtotal = decimalReduction(roundUpToTwoDecimals(invoiceSubtotal + total_product_price));
            invoiceTotalItbms = roundUpToTwoDecimals(invoiceTotalItbms + total_product_itbms);
            invoiceTotal = roundUpToTwoDecimals(invoiceTotal + total_product_price + total_product_itbms);
            invoiceBaseReducedTax = roundUpToTwoDecimals(invoiceBaseReducedTax + base_reduced_tax)

            console.log("invoiceTotalDiscount:" + invoiceTotalDiscount);
            console.log("invoiceSubtotal:" + invoiceSubtotal);
            console.log("invoiceTotalItbms:" + invoiceTotalItbms);
            console.log("invoiceTotal:" + invoiceTotal);
         }

         //We check the delivery fee rule
         if (checkDeliveryOrder === "delivery" && selectedDeliveryRule && selectedDeliveryRule !== null) {
            let feeBase = 0;
            let deliveryFeeTax = 0;
            if (Number(selectedDeliveryRule.min_subtotal_to_waive || 0) > invoiceSubtotal) {
               if (selectedDeliveryRule.fee_type === 'fixed') {
                  feeBase = Number(selectedDeliveryRule.fee_amount || 0);
               } else if (selectedDeliveryRule.fee_type === "percent") {
                  // % of the subtotal
                  feeBase = (Number(selectedDeliveryRule.fee_percent || 0) / 100) * invoiceSubtotal;
               } else if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source === "haversine") {
                  // Calculate distance: branchoffice vs selected address
                  const branch = JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice || {};
                  const branchCoord = { lat: Number(branch.lat), lng: Number(branch.lng) };
                  // Si no hay address seleccionada, usamos la direccion quemada
                  const destCoord = addressNowLocation
                     ? { lat: Number(addressNowLocation.lat), lng: Number(addressNowLocation.lng) }
                     : { lat: Number(JSON.parse(localStorage.getItem("addressNowLocation")).lat), lng: Number(JSON.parse(localStorage.getItem("addressNowLocation")).lng) };

                  let distanceKm = null;
                  if (branchCoord.lat && branchCoord.lng && destCoord?.lat && destCoord?.lng) {
                     // We use harversine rule (for now) to calculate the distance
                     distanceKm = haversineKm(branchCoord, destCoord);
                  }
                  // We round the distance based on rule setting
                  const calc = computeKilometerFee(selectedDeliveryRule, distanceKm ?? 0);
                  feeBase = calc.fee;
               } else if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source === "asap") {
                  // Calculate ASAP fee (if applicable)
                  let asapFeeResponse = await calculateAsapFee();
                  //We set the fee base
                  if (asapFeeResponse !== null) {
                     feeBase = asapFeeResponse.fareTotal?.total || 0;
                  } else {
                     feeBase = 0;
                  }
               } else if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source === "tookan") {
                  // Calculate Tookan fee (if applicable)
                  let tookanFeeResponse = await calculateTookanFee();
                  //We set the fee base
                  if (tookanFeeResponse !== null) {
                     feeBase = tookanFeeResponse.amount;
                  } else {
                     feeBase = 0;
                  }
               }

               // Delivery Fee taxes (if taxable)
               if (Number(selectedDeliveryRule.taxable) === 1 && Array.isArray(selectedDeliveryRule.taxes) && selectedDeliveryRule.taxes.length > 0) {
                  selectedDeliveryRule.taxes.forEach(tax => {
                     const val = roundUpToTwoDecimals(feeBase * Number(tax.taxtValue || 0));
                     deliveryFeeTax += val;
                     //Identifier tax of the delivery
                     var index = taxesArray.findIndex(function (info, i) {
                        return info.tax_id === tax.tax_id
                     });
                     if (index < 0) {
                        let taxInfoNow = {
                           "dTasaITBMSValue": tax.dTasaITBMSValue,
                           "percentage": tax.percentage,
                           "tax": tax.tax,
                           "tax_id": tax.tax_id,
                           "taxtValue": tax.taxtValue,
                           "total": val
                        }
                        taxesArray.push(taxInfoNow);
                     } else {
                        taxesArray[index].total = (taxesArray[index].total + val)
                     }
                  });
                  invoiceTotalItbms += deliveryFeeTax;
               }
               invoiceDeliveryFee = feeBase;
               invoiceTotal += (invoiceDeliveryFee + deliveryFeeTax);
            }
         }

         //We set the totals
         setInvoiceTotalDiscount(invoiceTotalDiscount);
         setInvoiceSubtotal(invoiceSubtotal);
         setInvoiceTotalItbms(invoiceTotalItbms);
         setInvoiceTotal(invoiceTotal);
         setInvoiceBaseReducedTax(invoiceBaseReducedTax);
         setTaxesArrayAll(taxesArray);

         //We set the recomended tips 
         validModuleTips(invoiceSubtotal)

         // Total a pagar = total + propina
         setTotaltopay(roundUpToTwoDecimals(invoiceTotal + invoiceTips));
         // Actualizamos el delivery visible en el resumen
         setInvoiceTotalDelivery(roundUpToTwoDecimals(invoiceDeliveryFee));
         // si quieres guardar también el impuesto de delivery:
         setInvoiceTaxDeliveryFee(roundUpToTwoDecimals(deliveryFeeTax));

         console.log("total: " + invoiceTotal);
         console.log("Propina: " + invoiceTips);
         console.log("total a pagar: " + (invoiceTotal + invoiceTips));
         console.log("delivery fee: " + invoiceDeliveryFee);


         let newArray = []
         console.log(dataDicountApply)
         //valid discount report
         dataDicountApply.forEach((discount, index) => {
            let discountvalid = 0
            discount.groups.forEach((group) => {
               let productfind = products.find(({ group_id }) => group_id === group.group_id)
               if (productfind) {
                  discountvalid = discountvalid + productfind.discount
               }
            })

            discount.combos.forEach((combo) => {
               let combofind = combos.find(({ combo_id }) => combo_id === combo.combo_id)
               if (combofind) {
                  discountvalid = discountvalid + combofind.discount
               }
            })


            discount.index = index
            if (discountvalid == 0) {
               let indexRemove = index
               dataDicountApply.forEach((item, index) => {
                  if (item.index != indexRemove) {
                     newArray.push(item)
                  }
               })

            } else {
               if (discountvalid != discount.total) {
                  discount.total = discountvalid
               }
            }
         })


         console.log("ldkfvlsdkfmv");
         if (newArray.length > 0) {
            console.log("Nuevo array de descuentos aplicados", newArray);
            setdataDiscountApply(newArray)
         } else {
            console.log("Array de descuentos aplicados", dataDicountApply);
            setdataDiscountApply(dataDicountApply)
         }
      }

   }


   const validModuleTips = (subtotal) => {//Module tips validation
      if (moduleTips == 1) {
         let data = [
            { rate: "10%", value: decimalReduction(subtotal * 0.10) },
            { rate: "15%", value: decimalReduction(subtotal * 0.15) },
            { rate: "20%", value: decimalReduction(subtotal * 0.20) }
         ]
         setRecomendationTips(data)

      }
   }

   // Propinas recomendadas derivadas del subtotal + la config de la sucursal. Antes solo se calculaban dentro de
   // calculateInvoiceTotals con el moduleTips de ESE render: en el cobro desde Mesas el carrito se arma una sola
   // vez al abrir (antes de que cargue la config de la sucursal) y el panel de Propina mostraba unicamente "0%"
   // hasta que algo mas recalculaba los totales.
   useEffect(() => {
      if (moduleTips == 1) {
         setRecomendationTips([
            { rate: "10%", value: decimalReduction(invoiceSubtotal * 0.10) },
            { rate: "15%", value: decimalReduction(invoiceSubtotal * 0.15) },
            { rate: "20%", value: decimalReduction(invoiceSubtotal * 0.20) }
         ]);
      } else {
         setRecomendationTips([]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [moduleTips, invoiceSubtotal]);

   //Function to clear all the shopping cart
   const clearShoppingCart = () => {
      if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
         const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
               confirmButton: 'btn btn-success',
               cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
         })

         let title = 'Aun hay productos en la cartilla'
         let text = "¿Estás seguro de que deseas eliminar todos los productos de tu carrito? Esta acción no se puede deshacer."

         if (selectPreOrder.order != "") {
            if (selectPreOrder.is_authorized == false) {
               title = 'Si cancelas esta precuenta se eliminara por completo'
               text = "¿Estas seguro de denegar la autorizacion? Esta acción no se puede deshacer."

            }
         }

         swalWithBootstrapButtons.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si!',
            cancelButtonText: 'No!',
            reverseButtons: true
         }).then((result) => {
            if (result.isConfirmed) {
               swalWithBootstrapButtons.fire(
                  'Orden cancelada!',
                  '',
                  'success'
               )

               if (selectPreOrder.order != "") {
                  if (selectPreOrder.is_authorized == false) {
                     deletePreOrder()
                  }
               }

               setdataClientSelected(null)
               setAddressNowLocation(null)
               localStorage.removeItem('client_data')
               localStorage.removeItem('addressNowLocation')
               setShoppingCart([]);
               setShoppingCartCombos([]);
               setProductChecked([])
               setCombosChecked([])
               setEventHandler(1);
               setPageLoader(1)


            } else if (
               /* Read more about handling dismissals below */
               result.dismiss === Swal.DismissReason.cancel
            ) {
               swalWithBootstrapButtons.fire(
                  'La orden se mantiene!',
                  '',
                  'info'
               )
            }
         })
      } else {
         setShoppingCart([]);
         setProductChecked([])
         setCombosChecked([])
         setEventHandler(1);
         setPageLoader(1)
      }
   }

   const buttonTypeOrdersDelivery = () => {
      let radioButtons = (
         <>
            {enabledTypeSelect == true && <>
               <input
                  type="radio"
                  className="btn-check "
                  name="btnradio"
                  id="btnradio1"
                  data-type="comer aqui"
                  autoComplete="off"
                  onChange={(e) => (selectTypyDeliveryOrder(e.target.dataset.type))}
                  checked={checkDeliveryOrder === "comer aqui"}
               />
               <label className="btn btn-outline-primary border rounded-pill " htmlFor="btnradio1">
                  <small className='fw-bold mx-1'><i className="uil uil-arrow-down"></i> Comer aquí</small>
               </label>

               <input
                  type="radio"
                  className="btn-check "
                  name="btnradio"
                  id="btnradio2"
                  data-type="para llevar"
                  autoComplete="off"
                  onChange={(e) => (selectTypyDeliveryOrder(e.target.dataset.type))}
                  checked={checkDeliveryOrder === "para llevar"}
               />
               <label className="btn btn-outline-primary border rounded-pill mx-1" htmlFor="btnradio2">
                  <small className='fw-bold mx-1'><i className="uil uil-arrow-up-right"></i> Para llevar</small>
               </label>

               {/* mixto, si lo usas después */}
               <input
                  type="radio"
                  className="btn-check "
                  name="btnradio"
                  data-type="mixto"
                  id="btnradio3"
                  autoComplete="off"
                  onChange={(e) => (selectTypyDeliveryOrder(e.target.dataset.type))}
                  checked={checkDeliveryOrder === "mixto"}
                  disabled
               />
               <label className="btn btn-outline-primary border rounded-pill" htmlFor="btnradio3">
                  <small className='fw-bold mx-1'><i className="uil uil-exchange-alt"></i> Mixto</small>
               </label></>}

            {/* DELIVERY  */}
            {enabledOnlineOrder == true && <>
               <button className={`btn btn-outline-primary border rounded-pill mx-1 ${checkDeliveryOrder === "delivery" ? "active" : ""
                  }`} htmlFor="btnradio4" onClick={() => (
                     selectTypyDeliveryOrder("delivery"),
                     checkDeliveryOrder === "delivery" ? null : handlerInputFocus()
                  )}>
                  <small className='fw-bold mx-1'><i className="uil uil-location-arrow-alt"></i> Delivery</small>
               </button>
            </>
            }
         </>
      )
      return radioButtons
   }


   //action focur input upc
   const handlerInputFocus = () => {
      AlertSmallInfo()
      inputRefLog.current?.focus();
   }

   //funciones especificas para el manejo de los combos

   //select tap of combo
   const changeTab = (tabIndex) => {
      setActiveTab(tabIndex);
   };

   const actionCheckIngradent = (group, datacheck, addAuto) => {
      setStatusRequest(true)
      if (datacheck != undefined) {
         if (document.getElementById(datacheck).checked) {
            getdataGroup(group, addAuto)
         } else {
            if (addAuto == true) {
               getdataGroup(group, addAuto)
            } else {
               console.log("no checked")
            }
         }
      }
   }

   const getdataGroup = async (group, addAuto, modification) => {
      setStatusRequest(false)
      try {
         if (statusRequest == true) {
            const response = await ProductsFetchAPI.getSegmentsByProducts(group.group_id, 1, branchoffice.id, token)
            let dataGroup = response.data.group

            if (modification == true) {
               dataGroup.price = group.base_price
            } else {
               dataGroup.price = group.price
            }

            setSegmentsNow(response.data.data);
            setGroupNow(dataGroup);


            if (addAuto == true) {
               console.log("Entre aqui");
               formatJsonToAddShoppingCart(dataGroup, true, addAuto, response.data.data)
            } else {
               console.log(dataGroup);
               setShowModalIngredient(true);
            }

            setStatusRequest(true)
         }
      } catch (err) {

         setSegmentsNow([]);
         setGroupNow(group);
         if (addAuto == true) { formatJsonToAddShoppingCart(group, true, true, []) }
         setStatusRequest(true)
         console.log(err.response.data.error);
      }

   }

   //clear data of menu
   const clearDataInfoProduct = (status) => {
      let generalData1 = JSON.parse(localStorage.getItem('generalData'))
      dataconsolidation(generalData1, status)
      if (categorieSelect == 'promociones') { promotions()/*document.getElementById("cateforieAll").checked = true*/ }
      setStep(1);
   }
   //-----------------------------------------------------------------------------

   const handleChange = async (e) => {

      if (e.key === 'Enter') {

         let inputValue = e.target.value
         let product_search = 0
         allProducts.forEach((product) => {
            let upc_codes = product.upc_codes;
            upc_codes.forEach((upc) => {
               if (upc.upc_code == inputValue) {
                  product_search = product
               }
            })
         });

         console.log(allProducts)

         LoadingAlert("Buscando producto", "Espere un momento por favor...")
         try {

            let token = localStorage.getItem('x-access-machine-token');
            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            const response = await ProductsFetchAPI.getSegmentsByProducts(product_search.group_id, 1, branchoffice.id, token);

            ErrorAlert("", "Producto encontrado.", "success");
            console.log("Esta es la peticion del segmento")
            console.log(response.data.group);
            setSelectProduct(response.data.group)

            let segmentsTemp = response.data.data
            //let temporal_segment_string = ""

            addProductUpc(response.data.group, segmentsTemp)

         } catch (err) {
            ErrorAlert("Error de consulta", "Producto no encontrado.", "error");
            console.log(err)
         }

         //setSearchTerm(inputValue)
         document.getElementById("input_upc").value = ""
      }
   }



   //====================================Parthners=================================================
   //save and select parthner
   const selectRestaurant = (data) => {
      console.log("selectRestaurant---------------------------------------------------------");
      console.log(data);
      localStorage.removeItem('warehouse');
      if (data.parthner_id == business.id) {
         resetData()
         //getUserByIdCard(data.parthner_business)
      } else {
         setParthner_order(true)

         let jsonNewParthner = { id: data.parthner_branchoffice_id, name: data.parthner_name, code: data.code, branchoffice_open: null, branchoffice_printer: null, branchoffice_support_phone: data.phone, parthner_business: data.parthner_business, data_Parthner: data }

         branchoffice = jsonNewParthner
         localStorage.setItem('branchoffice', JSON.stringify(jsonNewParthner))
         getWarehouseByBrachoffice(data.parthner_branchoffice_id)

         if (data.parthner_branch_machine_id != null) {
            getInfoMachine(data.parthner_branch_machine_id, true, data)
         }

         //setParthner_business(data.parthner_business)

         //getBusinessConfig()
         getRequest()

      }

      function resetData() {
         setParthner_order(false)
         if (localStorage.getItem('branchoffice_original') != null) {
            localStorage.setItem('branchoffice', localStorage.getItem('branchoffice_original'))
            branchoffice = JSON.parse(localStorage.getItem('branchoffice_original'))
         }

         if (localStorage.getItem('machine_original') != null) {
            localStorage.setItem('machine', localStorage.getItem('machine_original'))
            machine = JSON.parse(localStorage.getItem('machine_original'))
         }
         //setParthner_business(businessInfo.id)
         //getBusinessConfig()
         getRequest()
         localStorage.setItem('user', localStorage.getItem('user_original'))
      }

      function getRequest() {
         console.log("getRequest---------------------------------------------------------");
         localStorage.setItem('logo', data.logo)
         getStatusContentMenu(data.parthner_business, data.parthner_branchoffice_id, data.parthner_branch_machine_id);
      }
   }

   //delete preorder
   const deletePreOrder = async () => {
      let code = selectPreOrder.code
      //LoadingAlert()
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))
      let user = JSON.parse(localStorage.getItem('user'));

      let business_code = business.code
      let branch_code = branchoffice.code


      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      let jsonUpdate = {
         "order_code": code,
         "business_code": business_code,
         "branchoffice_code": branch_code,
         "justification": "Eliminacion de precuenta que requiere autorizacion",
         "deleted": true,
         "status": 5,
         "user_id": user.id
      }
      try {
         //We save the preorder
         await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);
         //We delete the preorder
         await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)
         let message = "precuenta eliminada con exito."
         let title = "Precuenta eliminada"
         let icon = "success"
         //ErrorAlert(message, title, icon)
         setSelectPreOrder({ order: "" })

      } catch (err) {
         console.log(err);
         ErrorAlert("Esta precuenta pertenece a otra sucursal", "Permiso denegado", "info")
      }
   }




   const getUserByIdCard = async (parthner_id) => {

      let userDataNow = JSON.parse(localStorage.getItem('user'))
      try {
         const response = await UsersFetchAPI.getUserByIdCard(userDataNow.idCard, token)
         console.log(response.data.user);
         let arrayUser = response.data.user
         console.log(arrayUser);
         console.log(parthner_id);

         let userByBusiness = arrayUser.find(user => user.business_id === parthner_id)
         if (userByBusiness !== undefined) {
            userDataNow.id = userByBusiness.id
            userDataNow.lastName = userByBusiness.lastName
            userDataNow.name = userByBusiness.name
            userDataNow.user_code = userByBusiness.user_code
            userDataNow.email = userByBusiness.email
            userDataNow.idCard = userByBusiness.idCard
            userDataNow.business_id = userByBusiness.business_id
            localStorage.setItem('user', JSON.stringify(userDataNow))

            console.log("Encontre el usuario");

         } else {

            console.log("user not found")
            ErrorAlert("", userDataNow.name + " " + "no tiene permitido facturar aqui.", "warning");
            resetDataRestaurant()

         }


      } catch (err) {
         console.log(err);
         ErrorAlert("", err.response.data.error, "warning");
         //resetDataRestaurant()
      }

   }

   const moveItemInArray = (array, fromIndex, toIndex) => {
      if (toIndex >= array.length || toIndex < 0) {
         console.log("La posición de destino está fuera de los límites del array.");
         console.log(array);
      }

      const item = array.splice(fromIndex, 1)[0]; // Elimina el elemento de la posición original
      array.splice(toIndex, 0, item); // Inserta el elemento en la nueva posición
      setShoppingCart(array);// Actualiza el estado del shopping cart
      setEventHandler(1);
      console.log(array);
   };


   //Reset branch office and machine data original
   const resetDataRestaurant = () => {

      if (showLoginByCode == false) {
         setTimeout(() => {
            if (localStorage.getItem('branchoffice_original') != null) {
               localStorage.setItem('branchoffice', localStorage.getItem('branchoffice_original'))
               branchoffice = JSON.parse(localStorage.getItem('branchoffice_original'))
            }

            if (localStorage.getItem('machine_original') != null) {
               localStorage.setItem('machine', localStorage.getItem('machine_original'))
               machine = JSON.parse(localStorage.getItem('machine_original'))
            }
            //setParthner_business(businessInfo.id)
            //getBusinessConfig()
            localStorage.setItem('logo', businessLogo)
            localStorage.setItem('user', localStorage.getItem('user_original'))

            updatePage()
         }, 1000);
      } else {
         controlModalLog()
      }
   }

   // Update kitchen_action for a product in shoppingCart
   const handleKitchenActionChange = (index, checked) => {
      const newAction = checked ? 'send_to_kitchen' : 'hold';

      setShoppingCart(prev =>
         prev.map((product, idx) =>
            idx === index
               ? { ...product, kitchen_action: newAction, isNewAdd: true }
               : product
         )
      );
   };

   const updatePage = () => {
      window.location.reload()
   }

   //function get machine info
   const getInfoMachine = async (machine_id, statusParthnerMachine, parthner) => {
      try {
         const response = await MachinesFetchAPI.getmachineByid(machine_id, token)
         let infoMachineJson = response.data.data

         if (statusParthnerMachine == true) {
            let jsonNewMachine = {
               id: infoMachineJson.machine_per_branch_id,
               code: infoMachineJson.code,
               is_logged: 0,
               name_type_machine: infoMachineJson.name_type_machine,
               machine_type_id: infoMachineJson.machine_type_id,
               printers: infoMachineJson.printers,
               machine_config: infoMachineJson.machine_config,
               user_code_validation: infoMachineJson.user_code_validation,
               external_menu: infoMachineJson.external_menu
            }


            if (infoMachineJson.user_code_validation == 1) {   // Solo mostrar login por código si no es pre_order=true en la URL
               controlModalLog()
            } else { setShowLoginByCode(false) }
            localStorage.setItem('machine', JSON.stringify(jsonNewMachine));
            machine = jsonNewMachine

            if (parthner != undefined) {
               getUserByIdCard(parthner.parthner_business)
            }
         }

      } catch (err) {
         console.log(err);
         ErrorAlert("", "Error de consulta de maquina", "error");
         resetDataRestaurant()
      }
   }

   const validWarehouse = (data) => {
      if (localStorage.getItem('warehouse') == null || localStorage.getItem('warehouse') == undefined || localStorage.getItem('warehouse') == '' || localStorage.getItem('warehouse') == null) {
         if (data.length > 0) { setShowModalWarehouses(true) }
      }
   }

   //=====================================================================================

   //Hook to load the initial info
   useEffect(() => {
      (async () => {

         // Captured once, up front: a page opened from the table module's "Enviar a pagar" (or any
         // other ?pre_order=true&order_id=... deep link) has ModalPendingOrders loading that order
         // into the cart on its own ~1s async timer (list fetch -> setTimeout(0) -> setInterval).
         // window.history.replaceState strips these params from the URL once that finishes, so we
         // read them now rather than after the awaits below - otherwise a mount where this session/
         // business validation happens to finish after the preorder was already applied would read
         // an already-cleaned URL and reset anyway.
         const initialParams = new URLSearchParams(window.location.search);
         const isLoadingPreOrderFromUrl = (initialParams.get('pre_order') || '').toLowerCase() === 'true'
            && Boolean(initialParams.get('order_id'));

         console.log("RENDERISADO DE LA PAGINA-------------------------------------");
         let token = localStorage.getItem('x-access-machine-token');
         let branchoffice = localStorage.getItem('branchoffice') !== '' ? JSON.parse(localStorage.getItem('branchoffice')) : '';


         try {
            ///valid token
            try {
               await validSession()
            } catch (err) {
               console.log(err);
            }
            //------------------------------------------------
            if (branchoffice !== '' && branchoffice !== null && branchoffice !== undefined) {

               if (localStorage.getItem('generalData') == null || localStorage.getItem('generalData') == undefined || localStorage.getItem('generalData') == '') {
                  LoadingAlert("Cargando información", "por favor espere...")
               }
               let branchoffice_original = JSON.parse(localStorage.getItem('branchoffice_original'))
               const responseBranchOfficeInfo = await BranchOfficeFetchAPI.getBranchOfficesByid(branchoffice_original.id, token)
               localStorage.setItem('external_menu', responseBranchOfficeInfo.data.data.branchoffice.external_menu);

               let codeParthner = localStorage.getItem('codeParthner');
               if (codeParthner !== null && codeParthner !== undefined && codeParthner !== '') {
                  codeParthner = JSON.parse(localStorage.getItem('codeParthner'))
                  getStatusContentMenu(codeParthner.business_id, codeParthner.branchoffice_id, codeParthner.machine_id)
               } else {

                  getStatusContentMenu()

               }

               getInfoBusiness(responseBranchOfficeInfo.data.data.branchoffice.external_menu);


               //getCategoriesByBranchOffices(branchoffice.id, token)
               //getProductsByBranchOfficessByStatus(branchoffice.id, token)
            }
         } catch (err) {
            console.log(err);
         }

         // Never wipe a cart that's mid-load (or already loaded) from a ?pre_order=true deep link -
         // see the comment above where isLoadingPreOrderFromUrl is captured. This used to run
         // unconditionally and race the ModalPendingOrders auto-apply flow, clearing the cart a
         // second or two after it had just loaded correctly.
         if (!isLoadingPreOrderFromUrl) {
            resetStates();
         }
         handlerInputFocus();

      })();

   }, [pageLoader]);


   useEffect(() => {
      resetStates()
      setResetData(0)

   }, [resetData])

   const recoveryOrder = (json) => {
      const pendingKinposPayment = kinposPaymentBridge.getPendingPayment();
      const belongsToPendingKinposPayment = pendingKinposPayment
         && String(pendingKinposPayment.order_reference) === String(json?.transaction_code);

      if (json?.aproved_register == true || belongsToPendingKinposPayment) {
         setRecoveryOrderApproved(true)
      } else {

         /*
         const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
               confirmButton: 'btn btn-success',
               cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
         })

         swalWithBootstrapButtons.fire({
            title: "Hay una orden en proceso",
            text: "Deseas recuperar la orden anterior?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, facturar!',
            cancelButtonText: 'No, olvidar la orden!',
            reverseButtons: true
         }).then((result) => {
            if (result.isConfirmed) {
               swalWithBootstrapButtons.fire(
                  'Orden recuperada!',
                  '',
                  'success'
               )
               setShoppingCart(json.Orden);
               setShoppingCartCombos(json.combos);
               calculateInvoiceTotals(json.Orden, json.combos)

            } else if (
               result.dismiss === Swal.DismissReason.cancel
            ) {
               swalWithBootstrapButtons.fire(
                  'La orden fue olvidada!',
                  '',
                  'info'
               )
               localStorage.removeItem('OrderDetails')
            }
         })*/

      }
   }

   const resetStates = () => {
      //clean input filter menu
      //document.getElementById("searchInput").value = "";
      //valid invoice to user code



      setSearchTerm("");
      localStorage.setItem('preOrderComparativeOld', 0)
      setdataDiscountApply([])
      setShoppingCart([]);
      setShoppingCartCombos([]);
      setRemovedPreOrderShoppingCartProducts([])
      setRecomendationTips([])
      setTaxesArrayAll([]);
      setlistPaymentReady([])
      setAmountPaymenReady(0.00)
      setInvoiceTips(0)
      setPreOrderInvoice(false)
      setInvoiceTotalDiscount(0)
      setInvoiceBaseReducedTax(0)
      setInvoiceSubtotal(0);
      setInvoiceTotalItbms(0)
      setInvoiceTotal(0);
      setPageLoader(0)
      setCheckDeliveryOrder("comer aqui")
      //setName("Cliente generico")
      //setDv(0)
      //setRuc(0)
      setRegisterTurnOrder(0)
      //setClient_phone("00")
      setLocator("0")
      setDataClient([]);
      //setDataResponse(false)
      setOptionalData(false)
      setSelectPreOrder({ order: "" })
      setYappy_transaction_id("")
      setDataPreOrder({ pre_Order: false, _id: "" })
      verificationDataClient();
      setAddressNowLocation(null)
      setdataClientSelected(null)
      setAditional_data("")
      localStorage.setItem('addressNowLocation', null)
      localStorage.setItem("client_data", null)

      if (machine.user_code_validation == 1) {   // Solo mostrar login por código si no es pre_order=true en la URL
         controlModalLog()
      } else { setShowLoginByCode(false); }
      if (localStorage.getItem('OrderDetails') !== null && localStorage.getItem('OrderDetails') !== undefined && localStorage.getItem('OrderDetails') !== '') {
         recoveryOrder(JSON.parse(localStorage.getItem('OrderDetails')))
      }
   }

   useEffect(() => {
      verificationDataClient()
   }, [dataClientSelected]);

   const verificationDataClient = () => {
      if (dataClientSelected != null) {
         setName(dataClientSelected?.name);
         setRuc(dataClientSelected?.ruc !== "" ? dataClientSelected?.ruc : 0);
         setDv(dataClientSelected?.dv !== "" ? dataClientSelected?.dv : 0);
         setClient_phone(dataClientSelected?.phone);
         setDataResponse(true);


      } else {
         setName("Cliente generico");
         setRuc(0);
         setDv(0);
         setClient_phone("");
         setDataResponse(false);
      }
   }


   //Hook to recharge data of the shopping cart
   useEffect(() => {
      setShoppingCart([...shoppingCart]);
      setShoppingCartCombos([...shoppingCartCombos])
      calculateInvoiceTotals([...shoppingCart], [...shoppingCartCombos])
      setEventHandler(0);
   }, [eventHandler]);

   //Hook to recharge data of preview segments
   useEffect(() => {
      setPreviewSegment([...previewSegment])
      setEventHandlerPreviewsegment(0)
   }, [eventHandlerPreviewsegment]);

   // layoutConfig, setlayoutConfig
   const [responseMachine, setResponseMachine] = useState(null);

   //layout config
   const [layoutConfig, setLayoutConfig] = useState([]);
   const [layoutConfigBtn, setLayoutConfigBtn] = useState([]);

   const [btnLayout, setBtnLayout] = useState({

      couponPlus: null,
      couponLite: null,

      discountsPlus: null,
      discountsLite: null,

      pendingOrdersPlus: null,
      pendingOrdersLite: null,

      returnPlus: null,
      returnLite: null,

      menuLite: null,


   });


   useEffect(() => {
      (async () => {
         try {
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            let code_language = response_machine.data.data.language.code

            setLayoutConfig(response_machine.data.data.machine_config)
            setLayoutConfigBtn(response_machine.data.data.machine_config.buttons.coupons.actvLite)

            setBtnLayout({
               couponPlus: response_machine.data.data.machine_config.buttons.coupons.actvPlus,
               couponLite: response_machine.data.data.machine_config.buttons.coupons.actvLite,

               discountsPlus: response_machine.data.data.machine_config.buttons.discounts.actvPlus,
               discountsLite: response_machine.data.data.machine_config.buttons.discounts.actvLite,

               pendingOrdersPlus: response_machine.data.data.machine_config.buttons.pendingOrders.actvPlus,
               pendingOrdersLite: response_machine.data.data.machine_config.buttons.pendingOrders.actvLite,

               returnPlus: response_machine.data.data.machine_config.buttons.return.actvPlus,
               returnLite: response_machine.data.data.machine_config.buttons.return.actvLite,

               menuLite: response_machine.data.data.machine_config.buttons.menu.actvLite,

            })
            // console.log(response_machine.data.data.machine_config);
            if (code_language != "es") {
               changeLanguage(code_language)
            }

         } catch (err) {

         }
      })()
   }, [])

   //btnLayout.menuLite buttons.menu.actvLite
   console.log("Contendor Main ", layoutConfig.mainContainer);
   console.log("Mesas:", btnLayout.pendingOrdersPlus);

   const [showLeftPanel, setShowLeftPanel] = useState(true);

   const [cartCount, setCartCount] = useState(3); // Ejemplo: cantidad de productos en carrito


   // Leer el valor inicial desde localStorage o usar false por defecto
   const [reverseOrder, setReverseOrder] = useState(() => {
      const saved = localStorage.getItem('reverseOrder');
      return saved === 'true'; // convierte string a boolean
   });

   const [isCollapsed, setIsCollapsed] = useState(() => {
      const saved = localStorage.getItem("isCollapsed");
      return saved !== null ? JSON.parse(saved) : false; // valor inicial false si no existe
   });

   // Cada vez que cambie, lo guardamos en localStorage
   useEffect(() => {
      localStorage.setItem("isCollapsed", JSON.stringify(isCollapsed));
   }, [isCollapsed]);

   const toggleCollapse = () => {
      setIsCollapsed((prev) => !prev);
   };

   // Guardar en localStorage cuando el estado cambie
   useEffect(() => {
      localStorage.setItem('reverseOrder', reverseOrder);
   }, [reverseOrder]);

   //Imagens Hidden and View
   const [hidden, setHidden] = useState(false);

   // Al montar, revisa si existe el valor en localStorage
   useEffect(() => {
      const saved = localStorage.getItem("imagesHidden");
      if (saved !== null) {
         setHidden(saved === "true"); // convierte string → boolean
      }
   }, []);

   // Cada vez que cambia hidden, guarda en localStorage
   useEffect(() => {
      localStorage.setItem("imagesHidden", hidden);
   }, [hidden]);

   const toggleHidden = () => {
      setHidden(!hidden);
   };

   const [showDiv, setShowDiv] = useState(false);

   const toggleDiv = () => {
      setShowDiv(!showDiv); // alterna entre true y false
   };

   //Modal Info product

   const [showModal, setShowModalNew] = useState(false);
   const [selectedSize, setSelectedSize] = useState('chico');
   const [quantity, setQuantity] = useState(1);
   const [notes, setNotes] = useState('');

   const sizes = [
      { id: 'chico', name: 'Chico', price: 0 },
      { id: 'regular', name: 'Regular', price: 1.75 }
   ];

   const handleDecrement = () => {
      if (quantity > 1) setQuantity(quantity - 1);
   };

   const handleIncrement = () => {
      setQuantity(quantity + 1);
   };

   const handleCloseNew = () => {
      setShowModalNew(false);
      setStep(1);
   };

   const handleAddToCart = () => {
      alert(`Agregado al carrito:\nTamaño: ${selectedSize}\nCantidad: ${quantity}\nNotas: ${notes || 'Ninguna'}`);
      setShowModalNew(false);
   };

   const selectedPrice = sizes.find(s => s.id === selectedSize)?.price || 0;
   const totalPrice = selectedPrice * quantity;

   const [step, setStep] = useState(1); // Estado para el paso actual
   const totalSteps = 2; // Número total de pasos

   const nextStep = () => {
      if (step < totalSteps) setStep(step + 1);
   };

   const prevStep = () => {
      if (step > 1) setStep(step - 1);
   };

   const [isOnline, setIsOnline] = useState(window.navigator.onLine);
   useEffect(() => {
      const handleOnline = () => {
         setIsOnline(true);
         if (window.navigator.onLine) {
            if (localStorage.getItem('OrderDetails') !== null && localStorage.getItem('OrderDetails') !== undefined && localStorage.getItem('OrderDetails') !== '') {
               recoveryOrder(JSON.parse(localStorage.getItem('OrderDetails')))
            }
         }
      };
      const handleOffline = () => setIsOnline(false);

      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);

      return () => {
         window.removeEventListener('online', handleOnline);
         window.removeEventListener('offline', handleOffline);
      };
   }, []);

   const normalizeTableSessionRequest = (raw = {}) => {
      const session = raw.session || raw.table_session || raw;
      const table = session.table || raw.table || {};
      const environment = session.environment || session.zone || table.environment || {};
      return {
         session_uuid: session.session_uuid || session.uuid || session.id || raw.session_uuid,
         table_id: session.table_id || table.id || raw.table_id,
         table_code: session.table_code || table.code || raw.table_code,
         table_name: session.table_name || table.name || raw.table_name,
         branchoffice_environment_id: session.branchoffice_environment_id || table.branchoffice_environment_id || table.environment_id || environment.id,
         zone_name: table.environment_name || environment.name || session.zone_name || raw.zone_name,
         status: session.status || raw.status,
         source: session.source || raw.source,
         requested_at: session.requested_at || raw.requested_at || session.createdAt || raw.createdAt,
         client_name: session.client_name || session.customer_name || session.customer?.name || session.client?.name || raw.client_name,
      };
   };

   //We fetch the pending table requests, this is called when the bell button is clicked so it is always up to date
   const fetchTableSessionRequests = async () => {
      try {
         const response = await TableSessionsFetchAPI.getPendingSessions(
            { branchoffice_code: branchoffice?.code, status: "PENDING", limit: 100 },
            token
         );
         const data = response?.data?.data;
         const source = Array.isArray(data) ? data : data?.items || response?.data?.items || [];
         const normalized = source.map(normalizeTableSessionRequest).filter((session) => session.session_uuid);
         setTableSessionRequests(normalized);
      } catch (error) {
         console.error("No se pudieron obtener las solicitudes de mesa", error);
      }
   };

   //Every time the requests bell is clicked we query the backend first so the count/list is always fresh, then we open the panel
   const handleOpenTableRequests = async () => {
      await fetchTableSessionRequests();
      setShowTableRequestsPanel(true);
   };

   const handleApproveTableSessionRequest = async (session) => {
      if (!session?.session_uuid || processingTableSessionId) return;
      setProcessingTableSessionId(session.session_uuid);
      try {
         await TableSessionsFetchAPI.approveSession(session.session_uuid, {}, token);
         setTableSessionRequests((prev) => prev.filter((item) => item.session_uuid !== session.session_uuid));
         ErrorAlert("Solicitud aprobada correctamente", "Mesa autorizada", "success");
      } catch (error) {
         ErrorAlert(error?.response?.data?.message || error?.response?.data?.error || "No se pudo aprobar la solicitud", "Solicitudes de mesa", "error");
      } finally {
         setProcessingTableSessionId(null);
      }
   };

   const handleRejectTableSessionRequest = async (session, reason) => {
      if (!session?.session_uuid || processingTableSessionId) return;
      setProcessingTableSessionId(session.session_uuid);
      try {
         await TableSessionsFetchAPI.rejectSession(session.session_uuid, { reason }, token);
         setTableSessionRequests((prev) => prev.filter((item) => item.session_uuid !== session.session_uuid));
         ErrorAlert("Solicitud rechazada", "Solicitudes de mesa", "success");
      } catch (error) {
         ErrorAlert(error?.response?.data?.message || error?.response?.data?.error || "No se pudo rechazar la solicitud", "Solicitudes de mesa", "error");
      } finally {
         setProcessingTableSessionId(null);
      }
   };

   //We fetch the pending count once on load so the badge is not empty until the user clicks it
   useEffect(() => {
      if (branchoffice.tables_enabled === 1) {
         fetchTableSessionRequests();
      }
   }, []);

   // "Pagar con POS": picks up the request handed off from Reservation.jsx's "Cobrar en terminal"
   // button - {session_uuid, payment_attempt_id, calculation_id, table_id, table_name, items}.
   // Captured in a ref (not just applied once) because this screen's own mount-time init effects
   // (catalog/machine/printer loads, etc.) can reset shoppingCart/shoppingCartCombos AFTER this runs -
   // the watcher effect below re-applies from the ref whenever that happens, converging once those
   // other effects settle instead of racing them.
   const pendingPosCartItemsRef = useRef([]);

   useEffect(() => {
      const req = embeddedPosRequest || location.state?.posPaymentRequest;
      if (!req?.payment_attempt_id) return;

      // Mirrors the canonical shoppingCart item shape built by the normal "add to cart" flow
      // (formatProductAdd, ~line 2440 above) - several other screens (ModalCallCenter's cart
      // preview, etc.) render any shoppingCart item assuming these fields exist, not just the ones
      // byProductandCombo needs for tax math.
      pendingPosCartItemsRef.current = (req.items || []).map((item) => ({
         name: item.name || "",
         price: Number(item.price) || 0,
         amount: Number(item.amount) || 1,
         cantidadItem: Number(item.amount) || 1,
         unit_discount: Number(item.unit_discount) || 0,
         product_discount: 0,
         discount: 0,
         descuento: 0,
         base_price: Number(item.price) || 0,
         valueOriginal: Number(item.price) || 0,
         taxes: Array.isArray(item.taxes) ? item.taxes : [],
         segments: [],
         DetalleSegmentos: [],
         segments_string: item.line_uuid || "",
         note: "",
         delivery_type: "comer aqui",
         type: "normal",
         status: 1,
         img: "",
         group_id: item.line_uuid,
      }));

      setTableInfo({ table_id: req.table_id, table_code: "", table_name: req.table_name || "" });
      setPosPaymentContext({
         session_uuid: req.session_uuid,
         payment_attempt_id: req.payment_attempt_id,
         calculation_id: req.calculation_id,
         table_name: req.table_name || "",
         expires_at: req.expires_at || null
      });

      // Consumes the router state so a refresh or navigating back here doesn't re-trigger this.
      // (Embebido no hay router state que consumir - la solicitud llego por prop.)
      if (!embedded) navigate(location.pathname, { replace: true, state: {} });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      if (!posPaymentContext?.payment_attempt_id) return;
      if (shoppingCart.length > 0) return;
      const cartItems = pendingPosCartItemsRef.current;
      if (!cartItems.length) return;

      setShoppingCart(cartItems);
      setShoppingCartCombos([]);
      calculateInvoiceTotals(cartItems, []);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [posPaymentContext, shoppingCart]);

   // Clears the prefilled cart/context once the physical-terminal charge is confirmed or the waiter
   // cancels the request - see ModalPayMet's onPosPaymentSettled.
   const handlePosPaymentSettled = (result) => {
      setPosPaymentContext(null);
      // La propina es POR COBRO: el siguiente cobro de la mesa empieza sin propina.
      setInvoiceTips(0);
      setShoppingCart([]);
      setShoppingCartCombos([]);
      calculateInvoiceTotals([], []);
      onEmbeddedSettled?.(result);
   };

   // Alerta sonora + badges cuando llega actividad de mesas mientras el cajero esta en /payments.
   // Socket propio (no el de la linea ~565, que es machine_code para eventos de caja) unido a la
   // misma sala business_{code}_branchoffice_{code} que ya usa Reservation.jsx, para recibir
   // tableSessionOrderUpdated/tableSessionRequested/tableSessionPaymentRequested en vivo aqui tambien.
   useEffect(() => {
      if (!business?.code || !branchoffice?.code) return undefined;
      const tableSocket = Socket({ business_code: business.code, branchoffice_code: branchoffice.code });
      const tableEvents = ["tableSessionRequested", "tableSessionOrderUpdated", "tableSessionPaymentRequested", "tableSessionPaymentAuthorized", "tableSessionPhysicalPaymentRequested"];

      const handleTableEvent = (payload = {}, eventName) => {
         // Pre-pay's payment-authorized fires for every table (post-pay included, when a waiter
         // authorizes from elsewhere) - only the customer-initiated pre-pay one is alarm-worthy here,
         // same guard as Reservation.jsx's handler.
         if (eventName === "tableSessionPaymentAuthorized" && String(payload?.payment_mode).toUpperCase() !== "PRE_PAY") {
            return;
         }

         // "Pagar con POS": if the claim ModalPayMet is currently waiting on (or about to charge)
         // just expired server-side (see tableSessionPayments.js#sweepExpiredPaymentClaims), close it
         // and block starting the physical charge - this is exactly the gap that let a KinPOS
         // transaction get orphaned (charged on the terminal, never registered on the table).
         if (eventName === "tableSessionOrderUpdated") {
            const activeAttemptId = posPaymentContextRef.current?.payment_attempt_id;
            if (activeAttemptId) {
               const attempt = (payload?.order?.payments || []).find(
                  (p) => p.payment_attempt_id === activeAttemptId
               );
               if (attempt && (attempt.status === "FAILED" || attempt.status === "ABANDONED")) {
                  setPosPaymentContext(null);
                  Swal.fire({
                     icon: "warning",
                     title: "Solicitud de cobro vencida",
                     text: "La solicitud de pago del cliente vencio antes de confirmarse. No cobres en el datafono por este intento; si el cliente sigue esperando, pidele que solicite pagar de nuevo.",
                     confirmButtonText: "Entendido"
                  });
                  onEmbeddedDismiss?.();
                  return;
               }
            }
         }

         // Embebido en /reservation: sus propias alertas/alarmas ya las maneja Reservation.jsx; aqui
         // solo importa el chequeo de vencimiento de arriba.
         if (embedded) return;

         startTableAlarm();
         markTableAlerted(payload?.table?.id);

         if (eventName === "tableSessionRequested") {
            fetchTableSessionRequests();
         }

         const tableLabel = payload?.table?.name || payload?.table?.code || "";
         const title = tableLabel ? `Mesa ${tableLabel}` : "Mesas";
         let text = "Actividad nueva en una mesa";
         if (eventName === "tableSessionRequested") text = "Nueva solicitud de mesa";
         else if (eventName === "tableSessionOrderUpdated") text = "Llego un pedido nuevo";
         else if (eventName === "tableSessionPaymentRequested") text = `${payload?.participant_display_name || "El cliente"} solicito pagar la cuenta`;
         else if (eventName === "tableSessionPaymentAuthorized") text = "El cliente ya pago - el pedido se envio directo a cocina";
         else if (eventName === "tableSessionPhysicalPaymentRequested") text = `${payload?.participant?.display_name || "El cliente"} pidio pagar $${Number(payload?.amount || 0).toFixed(2)} en el POS - abrela desde Mesas para cobrarla`;

         AlertSmall(`${title} · ${text}`, "info");
      };

      tableEvents.forEach((eventName) => tableSocket.on(eventName, (payload) => handleTableEvent(payload, eventName)));

      return () => {
         const removeSocketListener = tableSocket.off ? tableSocket.off.bind(tableSocket) : tableSocket.removeListener?.bind(tableSocket);
         tableEvents.forEach((eventName) => removeSocketListener?.(eventName));
         tableSocket.disconnect();
      };
   }, [business?.code, branchoffice?.code]);

   const pageContent = (
      <>
         {/*New Version POS  */}
         <div class="main-container bg-prueba">
            <header className='d-flex justify-content-between align-items-center gap-1 bg-secondary bg-opacity-10 rounded-2'>
               <div className='d-flex gap-1 '>
                  <a href="javascript:location.reload()"
                     className="d-flex align-items-center flex-fill bd-highlight text-dark text-decoration-none">
                     <img
                        className="navbar-logo-post"
                        src={logo_sp} alt="Logo Smart Pay" />
                     <span className="text-title-header h5 pt-2  fw-bold align-self-center  position-relative  d-none d-md-block   d-lg-block">
                        POS
                     </span>
                  </a>
               </div>
               <div className='d-flex gap-1 align-items-center'>
                  <div className='d-none d-md-flex d-lg-flex  align-items-center gap-1 align-items-center'>
                     {/** Discount modal */}
                     {/* <ModalPendingOrders
                        actvPlus={btnLayout.pendingOrdersPlus}
                        actvLite={btnLayout.pendingOrdersLite}
                        preOrderInvoice={preOrderInvoice}
                        setPreOrderInvoice={setPreOrderInvoice}
                        setCheckDeliveryOrder={setCheckDeliveryOrder}
                        setProductChecked={setProductChecked}
                        setCombosChecked={setCombosChecked}
                        setPageLoader={setPageLoader}
                        setEventHandler={setEventHandler}
                        shoppingCart={shoppingCart}
                        shoppingCartCombos={shoppingCartCombos}
                        setDv={setDv}
                        setName={setName}
                        setRuc={setRuc}
                        setDataResponse={setDataResponse}
                        setOptionalData={setOptionalData}
                        setShoppingCart={setShoppingCart}
                        setShoppingCartCombos={setShoppingCartCombos}
                        setInvoiceSubtotal={setInvoiceSubtotal}
                        setInvoiceTotal={setInvoiceTotal}
                        setInvoiceTotalDiscount={setInvoiceTotalDiscount}
                        setInvoiceTotalItbms={setInvoiceTotalItbms}
                        setDataPreOrder={setDataPreOrder}
                        setTableInfo={setTableInfo}
                        setTaxesArrayAll={setTaxesArrayAll}
                        setdataDiscountApply={setdataDiscountApply}
                        setDataReferenceOrderMicros={setDataReferenceOrderMicros}
                        codeParthner={codeParthner}
                        selectPreOrder={selectPreOrder}
                        setSelectPreOrder={setSelectPreOrder}
                        domain={domain}
                        setdataClientSelected={setdataClientSelected}
                        autoOpen={autoOpenPendingOrders}
                        autoSelectOrderId={autoSelectPendingOrderId}
                        setAddresDescriptionClientFiscal={setAddresDescriptionClientFiscal}
                        setAditional_data={setAditional_data}
                        setEventSelect={setEventSelect}
                        orderNumberNow={orderNumberNow}
                        getOrderNumber={getOrderNumber}
                        dataPreOrder={dataPreOrder}
                        setResetData={setResetData}
                        hasPendingTableAlert={pendingTableAlert}
                        onOpen={() => stopTableAlarm()}
                        alertedTableIds={alertedTableIds}
                        onSelectOrder={(order) => { clearTableAlert(order?.table_id); stopTableAlarm(); }}
                     /> */}


                     <ModalCoupons
                        actvPlus={btnLayout.couponPlus}
                        actvLite={btnLayout.couponLite}

                        shoppingCart={shoppingCart}
                        shoppingCartCombos={shoppingCartCombos}
                        total={invoiceTotal}
                        subtotal={invoiceSubtotal}
                        itbms={invoiceTotalItbms}
                        discount={invoiceTotalDiscount}
                        setLoad={setEventHandler}
                        setShoppingCart={setShoppingCart}
                        taxesArrayAll={taxesArrayAll} />

                     {/** Modal return (void order) */}
                     <RenderIf isTrue={checkUserPermission("void_order", user.permissions) !== -1}>
                        <ModalReturn
                           actvPlus={btnLayout.returnPlus}
                           actvLite={btnLayout.returnLite}
                           devolution_validation={devolution_validation}
                           pos_integration_name={pos_integration_name}
                           codeParthner={codeParthner}
                        />
                     </RenderIf>
                     {parthners.length > 0 && <ModalParthners parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} />}

                     <RenderIf isTrue={branchoffice.tables_enabled === 1 && checkUserModules("table_module", user.modules) !== -1}>


                        <button

                           className=" p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary position-relative"
                           style={{ borderRadius: 10 }}
                           onClick={() => { clearAllTableAlerts(); stopTableAlarm(); navigate("/reservation"); }}
                        >
                           <i className="uil uil-table icon "></i>
                           <small className='fw-bold text '>
                              Mesas
                           </small>
                           <RenderIf isTrue={pendingTableAlert}>
                              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">&bull;</span>
                           </RenderIf>
                        </button>


                     </RenderIf>
                  </div>

                  <RenderIf isTrue={branchoffice.tables_enabled === 1 && checkUserModules("table_module", user.modules) !== -1}>
                     <button

                        className=" p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary position-relative d-block d-md-block d-lg-block d-xl-block"
                        style={{ borderRadius: 10 }}
                        onClick={() => { clearAllTableAlerts(); stopTableAlarm(); handleOpenTableRequests(); }}
                        title="Solicitudes de mesa"
                     >
                        <i className="bi bi-bell icon "></i>
                        <small className='fw-bold text d-none d-md-inline d-lg-inline d-xl-inline'>
                           Solicitudes
                        </small>
                        <RenderIf isTrue={tableSessionRequests.length > 0}>
                           <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                              {tableSessionRequests.length}
                           </span>
                        </RenderIf>
                     </button>

                  </RenderIf>
                  <ModalPendingOrders
                     actvPlus={btnLayout.pendingOrdersPlus}
                     actvLite={btnLayout.pendingOrdersLite}
                     preOrderInvoice={preOrderInvoice}
                     setPreOrderInvoice={setPreOrderInvoice}
                     setCheckDeliveryOrder={setCheckDeliveryOrder}
                     setProductChecked={setProductChecked}
                     setCombosChecked={setCombosChecked}
                     setPageLoader={setPageLoader}
                     setEventHandler={setEventHandler}
                     shoppingCart={shoppingCart}
                     shoppingCartCombos={shoppingCartCombos}
                     setDv={setDv}
                     setName={setName}
                     setRuc={setRuc}
                     setDataResponse={setDataResponse}
                     setOptionalData={setOptionalData}
                     setShoppingCart={setShoppingCart}
                     setShoppingCartCombos={setShoppingCartCombos}
                     setInvoiceSubtotal={setInvoiceSubtotal}
                     setInvoiceTotal={setInvoiceTotal}
                     setInvoiceTotalDiscount={setInvoiceTotalDiscount}
                     setInvoiceTotalItbms={setInvoiceTotalItbms}
                     setDataPreOrder={setDataPreOrder}
                     setTableInfo={setTableInfo}
                     setTaxesArrayAll={setTaxesArrayAll}
                     setdataDiscountApply={setdataDiscountApply}
                     setDataReferenceOrderMicros={setDataReferenceOrderMicros}
                     codeParthner={codeParthner}
                     selectPreOrder={selectPreOrder}
                     setSelectPreOrder={setSelectPreOrder}
                     domain={domain}
                     setdataClientSelected={setdataClientSelected}
                     autoOpen={autoOpenPendingOrders}
                     autoSelectOrderId={autoSelectPendingOrderId}
                     setAddresDescriptionClientFiscal={setAddresDescriptionClientFiscal}
                     setAditional_data={setAditional_data}
                     setEventSelect={setEventSelect}
                     orderNumberNow={orderNumberNow}
                     getOrderNumber={getOrderNumber}
                     dataPreOrder={dataPreOrder}
                     setResetData={setResetData}
                     hasPendingTableAlert={pendingTableAlert}
                     onOpen={() => stopTableAlarm()}
                     alertedTableIds={alertedTableIds}
                     onSelectOrder={(order) => { clearTableAlert(order?.table_id); stopTableAlarm(); }}
                  />

                  {/** Discount modal */}
                  <RenderIf isTrue={checkUserPermission("discount_order", user.permissions) !== -1}>
                     <ModalDiscounts
                        actvPlus={btnLayout.discountsPlus}
                        actvLite={btnLayout.discountsLite}
                        productChecked={productChecked}
                        shoppingCart={shoppingCart}
                        shoppingCartCombos={shoppingCartCombos}
                        total={invoiceTotal}
                        subtotal={invoiceSubtotal}
                        itbms={invoiceTotalItbms}
                        discount={invoiceTotalDiscount}
                        setLoad={setEventHandler}
                        setShoppingCart={setShoppingCart}
                        setShoppingCartCombos={setShoppingCartCombos} setProductChecked={setProductChecked} taxesArrayAll={taxesArrayAll}
                        setCombosChecked={setCombosChecked}
                        combosChecked={combosChecked}
                        setdataDiscountApply={setdataDiscountApply}
                        dataDicountApply={dataDicountApply}
                        discount_validation={discount_validation}
                        codeParthner={codeParthner} />

                  </RenderIf>
               </div>
               <div className='d-flex gap-1 '>
                  <Dropdown className='d-xs-flex d-flex d-md-none d-lg-none d-xl-none' autoClose="outside">
                     <Dropdown.Toggle id="dropdown-autoclose-outside"
                        className='p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary border-0'>
                        <i class="uil uil-apps"></i>
                     </Dropdown.Toggle>

                     <Dropdown.Menu>
                        <Dropdown.Header>

                           {/* <i class="uil uil-setting"></i>  */}

                           <SecretSettingsIcon />
                           Opciones

                        </Dropdown.Header>
                        <Dropdown.Item >

                        </Dropdown.Item>
                        <Dropdown.Item >
                           <ModalDiscounts
                              actvPlus={btnLayout.discountsPlus}
                              actvLite={btnLayout.discountsLite}
                              productChecked={productChecked}
                              shoppingCart={shoppingCart}
                              shoppingCartCombos={shoppingCartCombos}
                              total={invoiceTotal}
                              subtotal={invoiceSubtotal}
                              itbms={invoiceTotalItbms}
                              discount={invoiceTotalDiscount}
                              setLoad={setEventHandler}
                              setShoppingCart={setShoppingCart}
                              setShoppingCartCombos={setShoppingCartCombos} setProductChecked={setProductChecked} taxesArrayAll={taxesArrayAll}
                              setCombosChecked={setCombosChecked}
                              combosChecked={combosChecked}
                              setdataDiscountApply={setdataDiscountApply}
                              dataDicountApply={dataDicountApply}
                              discount_validation={discount_validation}
                              codeParthner={codeParthner} />
                        </Dropdown.Item>
                        <Dropdown.Item >
                           <ModalCoupons
                              actvPlus={btnLayout.couponPlus}
                              actvLite={btnLayout.couponLite}

                              shoppingCart={shoppingCart}
                              shoppingCartCombos={shoppingCartCombos}
                              total={invoiceTotal}
                              subtotal={invoiceSubtotal}
                              itbms={invoiceTotalItbms}
                              discount={invoiceTotalDiscount}
                              setLoad={setEventHandler}
                              setShoppingCart={setShoppingCart}
                              taxesArrayAll={taxesArrayAll} />

                        </Dropdown.Item>
                        <Dropdown.Item>
                           <ModalReturn
                              actvPlus={btnLayout.returnPlus}
                              actvLite={btnLayout.returnLite}
                              devolution_validation={devolution_validation}
                              pos_integration_name={pos_integration_name}
                              codeParthner={codeParthner}
                           />
                        </Dropdown.Item>

                        {parthners.length > 0 && <Dropdown.Item>
                           <ModalParthners parthners={parthners}
                              selectRestaurant={selectRestaurant}
                              setResetData={setResetData}
                              calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart}
                              setShoppingCartCombos={setShoppingCartCombos} />

                        </Dropdown.Item>}

                        <RenderIf isTrue={branchoffice.tables_enabled === 1 && checkUserModules("table_module", user.modules) !== -1}>
                           <Dropdown.Item>  <button

                              className=" p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary position-relative"
                              style={{ borderRadius: 10 }}
                              onClick={() => { clearAllTableAlerts(); stopTableAlarm(); handleOpenTableRequests(); }}
                              title="Solicitudes de mesa"
                           >
                              <i className="bi bi-bell icon "></i>
                              <small className='fw-bold text '>
                                 Solicitudes
                              </small>
                              <RenderIf isTrue={tableSessionRequests.length > 0}>
                                 <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                    {tableSessionRequests.length}
                                 </span>
                              </RenderIf>
                           </button>
                           </Dropdown.Item> <Dropdown.Item>
                              <button

                                 className=" p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary position-relative"
                                 style={{ borderRadius: 10 }}
                                 onClick={() => { clearAllTableAlerts(); stopTableAlarm(); navigate("/reservation"); }}
                              >
                                 <i className="uil uil-table icon "></i>
                                 <small className='fw-bold text '>
                                    Mesas
                                 </small>
                                 <RenderIf isTrue={pendingTableAlert}>
                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">&bull;</span>
                                 </RenderIf>
                              </button></Dropdown.Item>
                        </RenderIf>


                     </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown className="d-inline" autoClose="outside">
                     <Dropdown.Toggle id="dropdown-autoclose-outside" className='p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary border-0'>
                        <i class="uil uil-setting"></i>
                     </Dropdown.Toggle>

                     <Dropdown.Menu>
                        <Dropdown.Header>   <i class="uil uil-setting"></i> Ajustes de vista</Dropdown.Header>
                        <Dropdown.Item eventKey="2" className='bg-white'>
                           <HiddenImg isHidden={hidden} onToggle={toggleHidden} />
                        </Dropdown.Item>
                        {/* <Dropdown.Item eventKey="3" className='bg-white' >              <Theme /></Dropdown.Item> */}
                        <Dropdown.Item eventKey="4" className='bg-white'>



                           <button
                              onClick={() => setReverseOrder(!reverseOrder)}
                              className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary" title='Cambiar orden de paneles'
                           >
                              {reverseOrder
                                 ? <><i class="uil uil-arrow-right"></i><span>Lado de carrito: Derecho </span></>

                                 : <> <i class="uil uil-arrow-left"></i><span>Lado de carrito: Izquiero</span></>

                              }

                           </button>





                        </Dropdown.Item>
                        <Dropdown.Item eventKey="5" className='bg-white' >                   <FullScreen /></Dropdown.Item>
                        <Dropdown.Item eventKey="6" className='bg-white' >
                           <button
                              onClick={() => setIsCollapsed(!isCollapsed)}
                              className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary"
                           >
                              {isCollapsed ?

                                 <>   <i class="uil uil-shopping-cart-alt"></i> <span>Ver Carrito</span></>

                                 : <>
                                    <i class="uil uil-angle-left" title='Ocultar panel izquierdo' ></i> <span> Ocultar Carrito </span>
                                 </>}
                           </button>



                        </Dropdown.Item>
                     </Dropdown.Menu>
                  </Dropdown>

                  <NavBar setPageLoader={setPageLoader} codeParthner={codeParthner}></NavBar>
               </div>
            </header >

            {/* Btn float cart */}
            {
               isCollapsed && (
                  <div className="cart-float" onClick={() => setIsCollapsed(false)}>

                     <div>
                        <i class="uil uil-shopping-cart"></i>
                        <small>Carrito</small>
                     </div>

                     <span className="cart-count">{shoppingCart.length + shoppingCartCombos.length}</span>
                  </div>
               )
            }
            {/* End Btn float cart */}
            <div className={` content ${reverseOrder ? 'reverse' : ''}`}>
               <div class={`border bg-light rounded-4 left-panel ${isCollapsed ? 'collapsed' : ''}`}>
                  <div className='flex-column'>
                     <div class="d-flex justify-content-between align-items-center p-1">
                        <h2 className='text-center'>Orden</h2>
                        <div className='d-flex justify-content-center  align-items-center gap-1 bg-white p-1 rounded-3 border'>
                           {separators.length > 0 ? <>

                              <ModalSeparators separators={separators} formatJsonToAddShoppingCart={formatJsonToAddShoppingCart} >
                              </ModalSeparators></>
                              :
                              <></>}
                           {/* <button onClick={() => (handlerInputFocus())}
                           className="btn btn-outline-warning  border border-1 rounded-pill me-1" >
                           <i className="uil uil-qrcode-scan"></i>
                           Upc
                        </button> */}
                           {layoutConfig.mainContainer
                              ? <>
                                 <ModalCreatePreOrder
                                    branchoffice={branchoffice}
                                    token={token}
                                    checkDeliveryOrder={checkDeliveryOrder}
                                    dv={dv} name={name} ruc={ruc}
                                    setDv={setDv}
                                    setName={setName}
                                    setRuc={setRuc}
                                    dataResponse={dataResponse}
                                    optionalData={optionalData}
                                    setDataResponse={setDataResponse}
                                    setOptionalData={setOptionalData}
                                    shoppingCart={shoppingCart}
                                    shoppingCartCombos={shoppingCartCombos}
                                    total={invoiceTotal}
                                    subtotal={invoiceSubtotal}
                                    tax={invoiceTotalItbms} discount={invoiceTotalDiscount}
                                    setPageLoader={setPageLoader} dataPreOrder={dataPreOrder}
                                    taxesArrayAll={taxesArrayAll}
                                    cardGroup={cardGroup}
                                    dataDicountApply={dataDicountApply}
                                    paramsMicros={paramsMicros}
                                    parthner_order={parthner_order}
                                    parthners={parthners}
                                    setdataClientSelected={setdataClientSelected}
                                    dataClientSelected={dataClientSelected}
                                    addressNowLocation={addressNowLocation}
                                    setAddressNowLocation={setAddressNowLocation}
                                    setShoppingCart={setShoppingCart}
                                    calculateInvoiceTotals={calculateInvoiceTotals}
                                    enabledOnlineOrder={enabledOnlineOrder}
                                    removedPreOrderShoppingCartProducts={removedPreOrderShoppingCartProducts}
                                    selectRestaurant={selectRestaurant} setResetData={setResetData} setShoppingCartCombos={setShoppingCartCombos}
                                    selectPreOrder={selectPreOrder}
                                    dataStyleBusiness={dataStyleBusiness}
                                    domain={domain}
                                    setSelectPreOrder={setSelectPreOrder}
                                    aditional_data={aditional_data}
                                    setAditional_data={setAditional_data}
                                    addresDescriptionClientFiscal={addresDescriptionClientFiscal}
                                    setAddresDescriptionClientFiscal={setAddresDescriptionClientFiscal}
                                    eventDataState={eventDataState}
                                    events={events}
                                 />
                              </>
                              : <></>}
                           <button type="button" className="btn-reset-order px-2 py-1 btn btn-outline-light-secondary   rounded-3 btn-sm "
                              onClick={clearShoppingCart} title='Limpiar orden' >

                              <i className="uil uil-trash-alt "></i>
                              <small className='fw-bold d-none d-lg-inline '>
                                 Limpiar orden
                              </small>

                           </button>

                           <input id="input_upc" className='input-upc' placeholder="Buscar Upc..." ref={inputRefLog} inputMode="none" type="text" onKeyPress={(e) => handleChange(e)} autoFocus ></input>
                        </div>

                     </div>

                     <div className=' bg-white mb-2'>
                        <ClientPillCard
                           dataClientSelected={dataClientSelected}
                           setdataClientSelected={setdataClientSelected}
                           addressNowLocation={addressNowLocation}
                           setAddressNowLocation={setAddressNowLocation}
                           parthner_order={parthner_order}
                           setShoppingCart={setShoppingCart}
                           calculateInvoiceTotals={calculateInvoiceTotals}
                           enabledOnlineOrder={enabledOnlineOrder}
                           parthners={parthners}
                           selectRestaurant={selectRestaurant}
                           setResetData={setResetData}
                           shoppingCart={shoppingCart}
                           shoppingCartCombos={shoppingCartCombos}
                           setShoppingCartCombos={setShoppingCartCombos}
                           questionConfirmation={questionConfirmation}
                        />

                     </div>

                  </div>



                  <div className={(preOrderInvoice == true)
                     ? "left-content  border border-warning rounded-3 border-2  position-relative"
                     : "left-content  bg-light position-relative border-top border-bottom"
                  }>


                     {preOrderInvoice == true
                        ? <div className='text-center sticky-top opacity-50 z-3'>
                           {selectPreOrder.is_authorized == false ? <>
                           </> : <>
                              <Badge rounded bg="warning" text="black">
                                 {selectPreOrder.is_quote_order == true ? "Cotizacion activa" : "Precuenta activa"}
                              </Badge> </>}</div>
                        : <></>
                     }

                     {(shoppingCart.length + shoppingCartCombos.length == 0)
                        ? <> <Empty title="Carrito vacío" msg="No hay productos en el carrito" />  </>

                        : <>

                           <div className={(shoppingCart.length + shoppingCartCombos.length == 0)} onClick={() => { handlerInputFocus() }}>
                              <div>
                                 {shoppingCart.map((product, index) => (
                                    <div key={product.group_id ?? index}>

                                       {product.type == "separator" ? (
                                          /* ---------------- SEPARADOR ---------------- */
                                          <div className="sp-sep">
                                             <button
                                                className="sp-sep-btn"
                                                title="Mover Producto"
                                                data-id={index}
                                                onClick={() => moveItemInArray(shoppingCart, index, (index + 1))}
                                             >
                                                <i className="uil uil-angle-double-down" />
                                             </button>

                                             <span className="sp-sep-name">{(index + 1)} - {product.name}</span>

                                             <button
                                                className="sp-sep-btn"
                                                title="Remover Separador"
                                                data-id={index}
                                                onClick={e => deleteProduct(index, true)}
                                             >
                                                <i className="uil uil-minus" />
                                             </button>
                                          </div>
                                       ) : (
                                          /* ---------------- PRODUCTO ---------------- */
                                          <div className={product.discount || product.unit_discount > 0
                                             ? "sp-pc sp-pc--warn"
                                             : product.quantity < product.amount ? "sp-pc sp-pc--danger" : "sp-pc"}
                                          >
                                             {/* Cinta de aviso: ocupa ancho completo, ya no flota sobre el borde */}
                                             <span className={product.discount || product.unit_discount > 0
                                                ? "sp-pc-flag sp-pc-flag--warn"
                                                : product.quantity < product.amount ? "sp-pc-flag sp-pc-flag--danger" : "visually-hidden"}
                                                translate='no'>
                                                {product.quantity < product.amount
                                                   ? <><i className="uil uil-exclamation-octagon" /> Cantidad no disponible</>
                                                   : <>Descuento aplicado: - {product.unit_discount}</>}
                                             </span>

                                             <div className="sp-pc-row">

                                                {/* ---- Media ---- */}
                                                {!hidden ? (
                                                   <div className="sp-pc-media fade-enter fade-enter-active">
                                                      <img
                                                         loading="lazy"
                                                         src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                         alt=""
                                                         width="80"
                                                         height="80"
                                                      />
                                                   </div>
                                                ) : null}

                                                {/* ---- Contenido ---- */}
                                                <div className="sp-pc-main">

                                                   {/* Nombre + precio */}
                                                   <div className="sp-pc-head">
                                                      <span className="sp-pc-name" title={product.name}>
                                                         <span className="sp-pc-index">{(index + 1)}</span>
                                                         {product.name}
                                                      </span>

                                                      <span className="sp-pc-price" translate="no">
                                                         {isCartProductPaidWithPoints(product) ? (
                                                            <span className="sp-pc-price-points">
                                                               {formatProductPoints(getProductPointsValue(product))} pts
                                                            </span>
                                                         ) : (
                                                            <>{product.price.toFixed(2)} $</>
                                                         )}
                                                      </span>
                                                   </div>

                                                   {/* Modificadores */}
                                                   <details className="sp-pc-details">
                                                      <summary>Detalles</summary>
                                                      <ul className="sp-pc-segments">
                                                         {/* A group can legitimately have no segments (simple product, no modifiers) - and a
                            line recovered from the ecommerce table-session flow may not even carry the key.
                            Without this guard, `.map` on undefined used to throw during render and blank out
                            the whole cart list instead of just skipping this product's (empty) modifier list. */}
                                                         {(Array.isArray(product.segments) ? product.segments : []).map((item, idx) => (
                                                            <li key={idx}>
                                                               <span className="sp-pc-seg-key">{item.segment_name}: {item.name}</span>
                                                               <span className="sp-pc-seg-val" translate="no">
                                                                  ${parseFloat(item.price || 0).toFixed(2)}
                                                               </span>
                                                            </li>
                                                         ))}
                                                      </ul>
                                                   </details>

                                                   {/* Avisos de la línea */}
                                                   <RenderIf isTrue={product.note != ""}>
                                                      <p className="sp-pc-note">Nota: {product.note}</p>
                                                   </RenderIf>

                                                   <RenderIf isTrue={product.quantity < product.amount}>
                                                      <p className="sp-pc-note sp-pc-note--stock">
                                                         <i className="uil uil-exclamation-octagon" /> Cantidad disponible: {product.quantity}
                                                      </p>
                                                   </RenderIf>

                                                   {/* ---- Controles ---- */}
                                                   <div className="sp-pc-controls">

                                                      <div className="quantity-control sp-pc-qty">
                                                         <RenderIf isTrue={product.descuento == 0 || product.quantity < product.amount || selectPreOrder?.is_quote_order == true}>
                                                            {preOrderInvoice === true ? (
                                                               <RenderIf isTrue={product.kitchen_action === "hold" || product.isNewAdd === true || selectPreOrder?.is_quote_order === true}>
                                                                  <button className="qty-btn" data-id={index}
                                                                     onClick={e => decrementProductAmount(index, true)}>
                                                                     <i className="uil uil-minus" />
                                                                  </button>
                                                               </RenderIf>
                                                            ) : (
                                                               <button className="qty-btn" data-id={index}
                                                                  onClick={e => decrementProductAmount(index, true)}>
                                                                  <i className="uil uil-minus" />
                                                               </button>
                                                            )}
                                                         </RenderIf>

                                                         <span className="quantity-number">{product.amount}</span>

                                                         <RenderIf isTrue={product.descuento == 0 || selectPreOrder?.is_quote_order == true}>
                                                            <button className="qty-btn" data-id={index}
                                                               onClick={e => incrementProductAmount(index, true)}>
                                                               <i className="uil uil-plus" />
                                                            </button>
                                                         </RenderIf>
                                                      </div>

                                                      {/* Acciones: mover, editar precio, eliminar */}
                                                      <div className="sp-pc-actions">
                                                         <button
                                                            className="sp-pc-act"
                                                            title="Mover Producto"
                                                            data-id={index}
                                                            onClick={() => moveItemInArray(shoppingCart, index, (index + 1))}
                                                         >
                                                            <i className="uil uil-arrow-from-top" />
                                                         </button>

                                                         {editPrice == true || selectPreOrder?.is_quote_order == true ? (
                                                            <button
                                                               className="sp-pc-act"
                                                               title="Editar Precio"
                                                               data-id={index}
                                                               onClick={e => {
                                                                  // Copia profunda del producto y segmentos para edición temporal
                                                                  const temp = JSON.parse(JSON.stringify({ ...product, index: index }));
                                                                  setProductEditPrice(temp);
                                                                  setProductEditPriceTemp(temp);
                                                                  setShowModalEditPrice(true);
                                                               }}
                                                            >
                                                               <i className="uil uil-pen" />
                                                            </button>
                                                         ) : null}

                                                         {selectPreOrder?.is_quote_order == true ? null : (
                                                            preOrderInvoice == true ? null : (
                                                               <button
                                                                  className="sp-pc-act sp-pc-act--danger"
                                                                  title="Eliminar Producto"
                                                                  data-id={index}
                                                                  onClick={e => deleteProduct(index, true)}
                                                               >
                                                                  <i className="uil uil-trash-alt" />
                                                               </button>
                                                            )
                                                         )}
                                                      </div>
                                                   </div>

                                                   {/* ---- Switches ---- */}
                                                   {selectPreOrder?.is_quote_order == true ? null : (
                                                      <>
                                                         {enabledTypeSelect == true && (
                                                            <div className="sp-pc-switch">
                                                               <Form.Switch
                                                                  className="switch-scale"
                                                                  type="switch"
                                                                  id={product.group_id}
                                                                  value={JSON.stringify(product)}
                                                                  label={product.delivery_type}
                                                                  defaultChecked={product.delivery_type === "comer aqui" ? true : false}
                                                                  onChange={handleSwitchChange}
                                                               />
                                                            </div>
                                                         )}

                                                         {/* Switch de acción de cocina SOLO si es precuenta */}
                                                         <RenderIf isTrue={preOrderInvoice === true}>
                                                            {preOrderInvoice === true && product.kitchen_action === 'send_to_kitchen' ? (
                                                               product?.isNewAdd == true ? (
                                                                  <div className="sp-pc-switch">
                                                                     <Form.Check
                                                                        type="switch"
                                                                        id={`kitchen-switch-group-${index}`}
                                                                        label={product.kitchen_action === 'send_to_kitchen' ? 'Enviar a cocina' : 'Mantener en espera'}
                                                                        checked={product.kitchen_action === 'send_to_kitchen'}
                                                                        onChange={(e) => handleKitchenActionChange(index, e.target.checked)}
                                                                     />
                                                                  </div>
                                                               ) : (
                                                                  <span className="sp-pc-sent">Enviado a cocina</span>
                                                               )
                                                            ) : (
                                                               <div className="sp-pc-switch">
                                                                  <Form.Check
                                                                     type="switch"
                                                                     id={`kitchen-switch-group-${index}`}
                                                                     label={product.kitchen_action === 'send_to_kitchen' ? 'Enviar a cocina' : 'Mantener en espera'}
                                                                     checked={product.kitchen_action === 'send_to_kitchen'}
                                                                     onChange={(e) => handleKitchenActionChange(index, e.target.checked)}
                                                                  />
                                                               </div>
                                                            )}
                                                         </RenderIf>
                                                      </>
                                                   )}

                                                </div>
                                             </div>
                                          </div>
                                       )}
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </>


                     }



                  </div>
                  {/* <div class="card">Tarjeta 1</div> */}

                  <div className='rounded-3 p-lg-2  p-0 mt-1 bg-white'>

                     <div className='w-100 d-flex justify-content-center'>
                        <div className="btn-group btn-group-sm" role="group" aria-label="Basic radio toggle button group">
                           {buttonTypeOrdersDelivery()}
                        </div>
                     </div>

                     <InvoiceTotals
                        cartIsPointsOrder={cartIsPointsOrder}
                        invoiceTotalPoints={invoiceTotalPoints}
                        formatProductPoints={formatProductPoints}
                        invoiceTotalDiscount={invoiceTotalDiscount}
                        invoiceTotalDelivery={invoiceTotalDelivery}
                        checkDeliveryOrder={checkDeliveryOrder}
                        invoiceSubtotal={invoiceSubtotal}
                        taxesArrayAll={taxesArrayAll}
                        invoiceTotal={invoiceTotal}
                     />

                     <div className='d-flex gap-1 mt-2'>
                        <button
                           className='btn btn-lg btn-add-product border-0 d-lg-none d-md-none d-block'
                           onClick={() => setIsCollapsed(true)}>
                           <div className='d-flex justify-content-center align-items-center flex-column'>
                              <strong><i className="uil uil-plus-circle" /></strong>
                           </div>
                        </button>

                        <RenderIf isTrue={checkUserPermission("close_order", user.permissions) !== -1}>
                           {/** Modal of the payment methods */}
                           <ModalPaymet
                              selectedDeliveryRule={selectedDeliveryRule}
                              invoiceTaxDeliveryFee={invoiceTaxDeliveryFee}
                              preOrderInvoice={preOrderInvoice}
                              dv={dv}
                              name={name}
                              ruc={ruc}
                              setDv={setDv}
                              setName={setName}
                              setRuc={setRuc}
                              dataResponse={dataResponse}
                              optionalData={optionalData}
                              setDataResponse={setDataResponse}
                              setOptionalData={setOptionalData}
                              shoppingCart={shoppingCart}
                              shoppingCartCombos={shoppingCartCombos}
                              total={invoiceTotal}
                              baseReducedTax={invoiceBaseReducedTax}
                              subtotal={invoiceSubtotal}
                              discount={invoiceTotalDiscount}
                              delivery={invoiceTotalDelivery}
                              tax={invoiceTotalItbms}
                              isPointsPayment={cartIsPointsOrder}
                              pointsTotal={invoiceTotalPoints}
                              setPageLoader={setPageLoader}
                              dataPreOrder={dataPreOrder}
                              checkDeliveryOrder={checkDeliveryOrder}
                              registerTurnOrder={registerTurnOrder}
                              setRegisterTurnOrder={setRegisterTurnOrder}
                              client_phone={client_phone}
                              setClient_phone={setClient_phone}
                              locator={locator}
                              setLocator={setLocator}
                              dataClient={dataClient}
                              setDataClient={setDataClient}
                              listPaymentReady={listPaymentReady}
                              setlistPaymentReady={setlistPaymentReady}
                              amountPaymentReady={amountPaymentReady}
                              setAmountPaymenReady={setAmountPaymenReady}
                              tableInfo={tableInfo}
                              taxesArrayAll={taxesArrayAll}
                              dataDicountApply={dataDicountApply}
                              invoiceTips={invoiceTips}
                              setInvoiceTips={setInvoiceTips}
                              moduleTips={moduleTips}
                              recomendationTips={recomendationTips}
                              totaltopay={totaltopay}
                              setEventHandler={setEventHandler}
                              pos_integration_name={pos_integration_name}
                              dataReferenceOrderMicros={dataReferenceOrderMicros}
                              parthner_order={parthner_order}
                              parthners={parthners}
                              codeParthner={codeParthner}
                              yappy_transaction_id={yappy_transaction_id}
                              setYappy_transaction_id={setYappy_transaction_id}
                              showModuleLocator={showModuleLocator}
                              cardGroup={cardGroup}
                              paramsMicros={paramsMicros}
                              dataClientSelected={dataClientSelected}
                              setdataClientSelected={setdataClientSelected}
                              addressNowLocation={addressNowLocation}
                              setAddressNowLocation={setAddressNowLocation}
                              businessLogo={businessLogo}
                              domain={domain}
                              enabledOnlineOrder={enabledOnlineOrder}
                              setShoppingCart={setShoppingCart}
                              calculateInvoiceTotals={calculateInvoiceTotals}
                              recoveryOrderApproved={recoveryOrderApproved}
                              setRecoveryOrderApproved={setRecoveryOrderApproved}
                              selectRestaurant={selectRestaurant}
                              setResetData={setResetData}
                              setShoppingCartCombos={setShoppingCartCombos}
                              orderNumber={orderNumber}
                              setOrderNumber={setOrderNumber}
                              orderNumberNow={orderNumberNow}
                              setOrderNumberNow={setOrderNumberNow}
                              dataStyleBusiness={dataStyleBusiness}
                              sendMail={sendMail}
                              sendStatus={sendStatus}
                              aditional_data={aditional_data}
                              setAditional_data={setAditional_data}
                              addresDescriptionClientFiscal={addresDescriptionClientFiscal}
                              setAddresDescriptionClientFiscal={setAddresDescriptionClientFiscal}
                              selectPreOrder={selectPreOrder}
                              hasPendingPreOrderCartChanges={hasPendingPreOrderCartChanges}
                              eventDataState={eventDataState}
                              events={events}
                              posPaymentContext={posPaymentContext}
                              onPosPaymentSettled={handlePosPaymentSettled}
                              onDismiss={onEmbeddedDismiss}
                           />
                        </RenderIf>
                     </div>

                  </div>

               </div>
               {/* Right Panel */}
               <div className={`right-panel ${isCollapsed ? 'expanded' : ''}`}>

                  <div className='header-right-panel flex-column pb-1 mt-1'>
                     <div className='flex-row d-lg-flex justify-content-lg-between align-items-lg-center gap-2 mb-1'>
                        <h2 className='m-0'>Menú      <button
                           type="button"
                           className={pointsMenuEnabled ? "btn btn-primary btn-sm rounded-3" : "btn btn-outline-primary btn-sm rounded-3"}
                           onClick={togglePointsMenu}
                           title={pointsMenuEnabled ? "Volver al menu regular" : "Ver productos pagables con puntos"}
                        >
                           <i className="uil uil-award"></i>
                           <span className="d-none d-lg-inline ms-1">
                              {pointsMenuEnabled ? "Menu regular" : (dataStyleBusiness?.business_points_name || "Puntos")}
                           </span>
                        </button></h2>

                        {eventDataState !== null && (
                           <ModalDetaillsEvent eventDataState={eventDataState} />
                        )}

                        <div className='d-flex mt-lg-0 mt-2'>
                           <div className='flex-fill bd-highlight search-bar'>
                              <form className=" w-100 ">

                                 <div className='d-flex justify-content-start align-items-center p-0 m-0'>
                                    <i class="uil uil-search icon-mobile"></i>
                                    <h2 className='m-0 text-desktop'>Buscar</h2>
                                    <input
                                       id='searchInput'
                                       spellcheck="false"
                                       className="form-control rounded-3 form-control-sm mx-2 bg-gray"
                                       type="text"
                                       step="any"
                                       placeholder="Productos..."
                                       onChange={e => setSearchTerm(e.target.value)}
                                    />

                                 </div>
                              </form>
                           </div>

                           {catalogs.length > 0 ? (

                              <div className='d-flex justify-content-between align-items-center  ms-2'>
                                 <i className="uil uil-swatchbook icon-mobile"></i>
                                 <h2 className='m-0 text-desktop'>

                                    Catálogo
                                 </h2>
                                 <div className='d-flex scroll-horizontal mx-2'>

                                    {/* {catalogs.length > 0 ? <>
                              <div className='m-1 ' >
                                 <span className={catalogSelect == 0 ? 'badge bg-warning text-dark summary-text-pos  fw-bold border rounded-4  text-wrap ' : 'badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '} onClick={(e) => selectCatalog(0)}>
                                    <i class="uil uil-swatchbook"> Todo</i>
                                 </span>
                              </div>

                              {catalogs.map((catalog) => (
                                 <>
                                    <div className='m-1 ' >
                                       <span className={catalogSelect == catalog.catalog_id ? 'badge bg-warning text-dark summary-text-pos  fw-bold border rounded-4  text-wrap ' : 'badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '} onClick={(e) => selectCatalog(catalog)}>
                                          <i class="uil uil-swatchbook"> {catalog.name}</i>
                                       </span>
                                    </div>

                                 </>
                              ))}</> : <></>} */}



                                    <div className="">
                                       <select
                                          id="catalogSelect"
                                          className="form-select form-select-md rounded-3"
                                          value={catalogSelect}
                                          onChange={(e) => {
                                             const selectedValue = e.target.value;
                                             if (selectedValue === "0") {
                                                selectCatalog(0);
                                             } else {
                                                // Buscar el catálogo seleccionado por ID
                                                const selectedCatalog = catalogs.find(catalog =>
                                                   catalog.catalog_id.toString() === selectedValue
                                                );
                                                if (selectedCatalog) {
                                                   selectCatalog(selectedCatalog);
                                                }
                                             }
                                          }}
                                       >

                                          {/* Opción "Todo" */}
                                          <option value="0">
                                             Ver Todo
                                          </option>

                                          {/* Mapear catálogos */}
                                          {catalogs.map((catalog) => (
                                             <option
                                                key={catalog.catalog_id}
                                                value={catalog.catalog_id}
                                             >
                                                {catalog.name}
                                             </option>
                                          ))}
                                       </select>
                                    </div>

                                 </div>
                              </div>)
                              : (
                                 <div className="d-none alert alert-info d-flex align-items-center" role="alert">
                                    <i className="uil uil-info-circle me-2"></i>
                                    No hay catálogos disponibles
                                 </div>
                              )}
                        </div>

                     </div>



                     {
                        !categories.length
                           ? ''//No hay categorias Asignadas
                           : <>
                              <div className="position-relative categories-list-post border-end">
                                 <div className="container-list no-scroll mx-1">
                                    <ul className="categories-list">
                                       <li>
                                          <div className="button-container ">
                                             <input type="radio" className="btn-check"
                                                name="options-outlined"
                                                key={0} id="cateforieAll"
                                                value={"todos"}
                                                onChange={(e) => selectCategorie(e.target.value)}
                                             />
                                             <label className="btn btn-outline-dark rounded-pill border" htmlFor="cateforieAll">
                                                Ver Todos
                                             </label>
                                          </div>
                                       </li>
                                       <li>
                                          <div className="button-container ">
                                             <input type="radio" className="btn-check"
                                                name="options-outlined"
                                                id="promociones"
                                                value={"promociones"}
                                                onChange={(e) => selectCategorie(e.target.value)}
                                             />
                                             <label className="btn btn-outline-dark rounded-pill border" htmlFor="promociones">
                                                Promociones
                                             </label>
                                          </div>
                                       </li>
                                       <li>
                                          <div className="button-container ">
                                             <input type="radio" className="btn-check"
                                                name="options-outlined"
                                                id="favorite"
                                                value={"favorite"}
                                                onChange={(e) => selectCategorie(e.target.value)}
                                             />
                                             <label className="btn btn-outline-dark rounded-pill border"
                                                htmlFor="favorite">
                                                Favoritos
                                             </label>
                                          </div>
                                       </li>

                                       {listCategories()}
                                    </ul>
                                 </div>

                              </div>
                           </>
                     }



                  </div>


                  <div class="right-content border rounded-3 p-1 ">
                     <div className="" >
                        <div className='row  g-2  no-scroll pb-5 '>
                           {!filteredProducts.length
                              ? <>
                                 {pointsMenuEnabled ? (
                                    <div className='my-5'>
                                       <Empty icon="ðŸ˜¢" title="Vacio" msg="No hay productos disponibles para pagar con puntos" img={sad_products} />
                                    </div>
                                 ) : (
                                    <div className='my-5'>
                                       <Empty icon="😢" title="Vacío" msg="No hay ningún producto asignado en esta categoria" img={sad_products} />
                                    </div>
                                 )}
                              </>
                              : filteredProducts.map((product) => (
                                 <>
                                    <div className={`col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3  ${isCollapsed ? 'col-xl-2 col-xxl-2' : 'col-xl-2 col-xxl-2'}`}
                                       data-product={JSON.stringify(product)}
                                       onClick={(e) => (getInventory(product))}
                                    >

                                       <div className='card-products-menu w-100 ' role='buttom' title={product.name}>
                                          <div className='card-products-header position-relative'>
                                             {!hidden ? (
                                                <div className={`fade-enter fade-enter-active`}>
                                                   <img
                                                      src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                      className="card-img-pre-acoount border border-1 card-view"
                                                      alt="Product"
                                                      loading="lazy"
                                                   />
                                                </div>
                                             ) : (
                                                <> </>
                                             )}


                                             {product.favorite == 1 ? <>
                                                <div className='position-absolute top-0 end-0'>
                                                   <span className='badge bg-warning-subtle rounded-2  text-wrap text-warning ' title='Favorito'>
                                                      <i class="uil uil-star"> </i>
                                                   </span>
                                                </div></> : <></>}
                                          </div>
                                          <div className='card-products-content'>
                                             <h6 className="text-left fw-semibold text-truncate text-dark m-0 p-0 ">
                                                {!hidden ? (
                                                   <></>
                                                ) : (
                                                   <span className={`fade-exit fade-exit-active me-1`}>
                                                      <span className="rounded-4 opacity-25 small">
                                                         <i class="uil uil-tag-alt"></i>
                                                      </span>
                                                   </span>
                                                )}

                                                {product.name}

                                             </h6>
                                             <p className="text-left fw-light text-truncate text-secondary opacity-75 mb-2 p-0"> {product.description}</p>


                                             <div className='d-flex justify-content-between align-items-center'>

                                                <h6 className="card-text  text-dark fw-bold h5 m-0">
                                                   {product.group_id ? (
                                                      pointsMenuEnabled
                                                         ? <>{formatProductPoints(product.points_value)} pts</>
                                                         : <>${formatProductPrice(product.price)}</>
                                                   ) : <></>}
                                                </h6>


                                                <button title='Añadir' className='btn btn-outline-light btn-sm rounded-circle lh-1 p-2  text-normal text-dark'> <i class="uil uil-plus"></i>  </button>


                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </>
                              ))
                           }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div >

         {/* End New Version POS  */}


         {/* Modal-Products Information*/}
         <Modal
            centered
            className='bg-blur-sp'
            // show={showModalSelectItem}
            size="xl"
            // fullscreen
            onHide={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct())}>
            <Modal.Body className='bg-light   '>
               <div className="position-relative ">
                  <div className='d-flex justify-content-center align-items-center' onClick={toggleDiv} >
                     <h2 className='h5'>Producto : {selectProduct.name} </h2> <i class="uil uil-info-circle fs-5 mx-2"></i>
                  </div>

                  {/* <button type="button" class="position-absolute top-0 end-0 p-3  btn-close bg-secondary bg-opacity-10 rounded-pill" aria-label="Close" onClick={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))}></button> */}
               </div>


               {selectProduct.favorite == 1 ? <>
                  <div className='d-flex justify-content-center alight-item-center  m-2'>
                     <span className='badge bg-warning text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                        <i class="uil uil-star"> Favorito</i>
                     </span>
                  </div></> : <></>}

               <div className='row g-2 mt-1 '>
                  <div className='col-md-12 col-12 '>
                     {showDiv && (

                        <div className='row border rounded-4 bg-white py-2'>

                           <div className='col'>
                              <div className='card-info-product-modal border rounded-4'>
                                 <h5 className='fw-bold text-primary'>Nombre de Producto</h5>
                                 <p className='h2'> {selectProduct.name} </p>
                              </div>
                           </div>
                           <div className='col'>
                              <div className='card-info-product-modal border rounded-4 position-relative'>
                                 <h5 className='fw-bold text-primary'>Producto</h5>
                                 <img className='rounded-4 img-info-product-modal'
                                    src={buildCloudinaryImageUrl({ url: selectProduct.img, width: 300, quality: "auto", type: "image" }) || img_default} alt="img-product "
                                 />

                                 <ZoomModalImg img_src={buildCloudinaryImageUrl({ url: selectProduct.img, width: 300, quality: "auto", type: "image" }) || img_default} />
                              </div>
                           </div>
                           <div className='col'>
                              <div className='card-info-product-modal border rounded-4'>
                                 <h5 className='fw-bold text-primary'>Información</h5>
                                 <p>      {selectProduct.description}  </p>
                              </div>
                           </div>
                        </div>
                     )}

                  </div>
                  {segments.length > 0 ? <>
                     <div className="col-md-9 col-12">
                        <div className='card-info-product-modal border rounded-4 h-100 bg-white'>
                           <h5 className='fw-bold text-primary pb-0 mb-0'>Opciones del producto</h5>
                           <div className='flex-container'>
                              {/* Product's Suggestions */}

                              <div className='item2 list-framer-segments'>
                                 {/* <div className='suggestions-over'>*/}
                                 <div className='w-100 pb-5'>
                                    {contentSegments()}
                                    {/* <StepByStepSegments
                                       segments={segments}
                                       renderItems={segmentsItems}                                   
                                    />  */}
                                 </div>
                                 {/*  </div> */}
                              </div>


                              {selectProduct.combo_id ? <>

                                 {
                                    <div className="bg-light   position-relative categories-list-post rounded border  ">
                                       <div className="container-list no-scroll mx-1">
                                          <ul>
                                             {selectProduct.setGroups.map((setGroup, index) => (
                                                <>
                                                   <li>
                                                      <button
                                                         key={index}
                                                         className={setGroup.ready == true ? 'btn btn-success rounded-3 border m-1' : index === activeTab ? 'btn btn-primary rounded-3 border m-1' : 'btn btn-outline-primary rounded-3 border '}
                                                         onClick={() => changeTab(index)}
                                                      >
                                                         {setGroup.name} {setGroup.ready == true ? <><i class="uil uil-check-circle"></i></> : <></>}
                                                      </button>

                                                   </li>

                                                </>
                                             ))}

                                             <div className='item2'>
                                                {/* <div className='suggestions-over'>*/}

                                                <div className=''>
                                                   <div>
                                                      <h5 className='pt-1 fw-bold text-underline'>
                                                         <u>{selectProduct.setGroups[activeTab].name}</u>
                                                      </h5>
                                                   </div>
                                                   <div className=''>
                                                      <div className="mt-1 ms-1 overflow-auto d-flex gap-3">
                                                         {selectProduct.setGroups[activeTab].groups.map((group) => (
                                                            <>
                                                               <article className='my-1 list-info-products-inputs  border-0 card-product-segments-kiosk' onClick={() => actionCheckIngradent(group, "setGroup" + selectProduct.setGroups[activeTab].set_id + group.group_id, true)} >


                                                                  <input
                                                                     className="list-group-products-check "
                                                                     type={selectProduct.setGroups[activeTab].count > 1 ? "checkbox" : "radio"}
                                                                     name={"setGroup" + selectProduct.setGroups[activeTab].set_id}
                                                                     id={"setGroup" + selectProduct.setGroups[activeTab].set_id + group.group_id}
                                                                     value=""
                                                                     checked={false}
                                                                  />
                                                                  <label className="list-group-item rounded-3 mb-0 fw-bold text-truncate bg-white p-1 shadow-sm position-relative h-100" >
                                                                     {group.name}
                                                                     <div className="d-flex align-items-center gap-3 py-3 rounded" >
                                                                        <img src={buildCloudinaryImageUrl({ url: group.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                                           alt="Product" width="50" height="50" className="rounded-3 flex-shrink-0 " />
                                                                        <div className="d-flex gap-2 justify-content-around">

                                                                           <div className='my-2'>
                                                                              <span className=" d-block mb-0 fw-normal text-wrap ">
                                                                                 {group.description}
                                                                              </span>

                                                                           </div>
                                                                        </div>
                                                                     </div>
                                                                     <span class="badge bg-success-subtle text-success-emphasis rounded-pill bottom-0 end-0 position-absolute m-1">
                                                                        {formatModifierPrice(group.price)}</span>
                                                                  </label>


                                                               </article>
                                                            </>
                                                         ))}
                                                      </div>
                                                   </div>
                                                </div>
                                                {/*  </div> */}
                                             </div>

                                          </ul>
                                       </div>
                                       <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-secondary">
                                          Pasos
                                       </span>


                                       {comboSelect.length > 0 ? <>
                                          <div className='m-3'>
                                             <h5 className='pt-1 fw-bold text-underline'>
                                                Resumen del combo
                                             </h5>
                                             <div className="mt-1 ms-1 overflow-auto d-flex gap-3">
                                                {comboSelect.map((setGroup) => (
                                                   <>
                                                      {setGroup.groupsselected.map((group, index) => (<>
                                                         <article className='my-1 list-info-products-inputs  border-0 card-product-segments-kiosk'  >



                                                            <label className="list-group-item rounded-3 mb-0 fw-bold text-truncate bg-white p-1 shadow-sm position-relative h-100" >
                                                               {setGroup.name}: {group.name}
                                                               <div className="d-flex align-items-center gap-3 py-3 rounded mb-2" >
                                                                  <img src={buildCloudinaryImageUrl({ url: group.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                                     alt="Product" width="50" height="50" className="rounded-3 flex-shrink-0 " />
                                                                  <div className="d-flex gap-2 justify-content-around">

                                                                     <div className='my-2'>
                                                                        <span className=" d-block mb-0 fw-normal text-wrap ">
                                                                           {group.description}
                                                                        </span>

                                                                        <div className={`d-flex bd-highlight text-muted opacity-75 position-relative justify-content-between align-items-center p-1`}>
                                                                           <details close >
                                                                              <summary className=''>
                                                                                 <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                                                                    <i className="uil uil-info-circle  px-1 "></i>  Detalles
                                                                                 </span>
                                                                              </summary>
                                                                              <div className='overflow-auto'>
                                                                                 {group.segments.map(item => (
                                                                                    <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                                                                                       {/* <span className='kiosk-subtitle-s' >   </span> */}
                                                                                       <span className='text-muted m-0 p-0'>{item.segment_name}:</span>
                                                                                       <br />
                                                                                       <strong>
                                                                                          <span className='me-2'>{item.name} </span>
                                                                                          {getModifierPrice(item.price).toFixed(2)}
                                                                                       </strong>
                                                                                    </span>
                                                                                 ))}</div>
                                                                           </details>

                                                                        </div>
                                                                     </div>
                                                                  </div>
                                                               </div>

                                                               <div className="bd-highlight fw-bold bottom-0 end-0 position-absolute m-1">
                                                                  <span class="badge bg-success-subtle text-success-emphasis rounded-pill  m-1">
                                                                     {formatModifierPrice(group.price)}</span>

                                                                  <button
                                                                     className='btn btn-warning btn-sm border-0 rounded-circle '
                                                                     title="Modificar Producto"
                                                                     data-id={index}
                                                                     onClick={() => (setActiveTab(setGroup.activeTab), getdataGroup(group, false, true))}
                                                                  >
                                                                     <i className="uil uil-edit text-wrap"></i>
                                                                  </button>
                                                                  <button
                                                                     className='btn btn-outline-danger btn-sm border-0 rounded-circle '
                                                                     title="Eliminar Producto"
                                                                     data-id={index}
                                                                     onClick={() => deleteSetGroupOfComboSelected(setGroup.activeTab)}>
                                                                     <i className="uil uil-trash-alt text-wrap"></i>
                                                                  </button>
                                                               </div>

                                                            </label>


                                                         </article>
                                                      </>))}
                                                   </>
                                                ))}
                                             </div>
                                          </div></> : <></>}

                                    </div>


                                 }
                              </> : <></>}
                           </div>

                        </div>

                     </div>
                  </> : <><Empty title="Vacio y ya" /> </>}
                  <div className={segments.length > 0 ? "col-md-3" : "col-md-8 m-auto  justify-content-center align-items-center col-12"}>
                     <div className='d-flex flex-column flex-shrink-0 h-100'>
                        <div className=' border rounded-4 bg-white p-2 '>

                           <h5 className='fw-bold text-primary pb-0 mb-0'>Cantidad </h5>
                           <div className='px-1 d-flex justify-content-center align-items-center'>
                              <button
                                 className="round-button decrement m-1"
                                 onClick={decrementNumber}>-</button>
                              <button
                                 className="round-count">{number}</button>
                              <button
                                 className="round-button increment  m-1" onClick={incrementNumber}>+</button>
                           </div>
                        </div>


                        <div className='p-2 border rounded-4 mt-2 mb-auto bg-white'>
                           <h5 className='fw-bold text-primary'>Notas</h5>
                           <Form>
                              <Form.Group className="m-1" controlId="exampleForm.ControlTextarea1">
                                 <Form.Control as="textarea" className='text-area-modal' onChange={(e) => (setNotesItem(e.target.value))} placeholder='Escribir...' />
                              </Form.Group>
                           </Form>

                        </div>
                        <div className=''>
                           <div className='d-block mt-lg-1 mt-0'>
                              <div className='d-flex justify-content-end mt-2'>
                                 <button className='btn bg-secondary-subtle text-secondary  border-0 fw-bold '
                                    onClick={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))}> Cerrar </button>

                                 {selectProduct.combo_id ? <><button className='btn bg-success-subtle text-success fw-bold border-0  ms-2'
                                    onClick={() => stepSaveCombos(true)}> Siguiente </button></> : <><button className='btn bg-success-subtle text-success fw-bold border-0  ms-2'
                                       onClick={e => (setShowModalSelectItem(false), setShow(false), addProduct(e))}> Agregar al carrito </button></>}                              </div>
                           </div></div>
                     </div>
                  </div>
                  <div className="col-md-10 d-none">

                     {/*temporal renderif for change price product*/}
                     {/* <RenderIf isTrue={selectProduct.name == "Medicamentos"}>
                     <div className='m-5'>
                        <h3 >Modificar precio</h3>
                        <div className="col-6 col-md-8">

                           <label>Precio</label>
                           <input type="text" className="form-control" placeholder={"$ " + selectProduct.price} onChange={(e) => (handlerchangePriceProductGeneric(e))} />
                        </div>
                        <div className="col-6 col-md-8">
                           <label>Impuesto $</label>
                           <input type="text" className="form-control" placeholder={"$" + selectProduct.taxtValue} onChange={(e) => (handlerchangeTaxProductGeneric(e))} />
                        </div>

                     </div>
                  </RenderIf>
                  <h6 className="fw-bold text-center mb-2" >Precio base: <p translate='no'>${parseFloat(selectProduct.price).toFixed(2)}</p> </h6>
                  <h5 className="fw-bold text-center mb-2" translate='no'>{"$ " + previewPriceItemsegmentSelect.toFixed(2)}</h5> */}
                     {/* {viewSelectSegmentItem()} */}
                  </div>
               </div>
            </Modal.Body>
         </Modal >



         {/* Demo Page - Botón para abrir modal */}
         {/* <div className="demo-container">
            <button
               className="btn-open-modal"
               onClick={() => setShowModalNew(true)}
            >
               <i class="fa-solid fa-cart-shopping"></i>
               Agregar Costillas al vapor
            </button>
         </div> */}

         {/* Modal */}
         {/* ==================================================================
    MODAL DE PRODUCTO
   ================================================================== */}

         {
            showModalSelectItem && (
               <div
                  className="prdt-mdl-backdrop"
                  onClick={handleClose}
                  onHide={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct())}
               >
                  <div className="prdt-mdl" onClick={(e) => e.stopPropagation()}>

                     {/* ---------------- HEADER ---------------- */}
                     <header className="prdt-mdl-head">
                        <img
                           className="prdt-mdl-thumb"
                           src={buildCloudinaryImageUrl({ url: selectProduct.img, width: 300, quality: "auto", type: "image" }) || img_default}
                           alt={selectProduct.name}
                        />

                        <div className="prdt-mdl-id">
                           <h2 className="prdt-mdl-title" title={selectProduct.name}>
                              {selectProduct.name}
                           </h2>
                           <p className="prdt-mdl-desc">{selectProduct.description}</p>
                           {selectProduct.favorite == 1 ? (
                              <span className="prdt-mdl-fav">
                                 <i className="uil uil-star" /> Favorito
                              </span>
                           ) : null}
                        </div>

                        <button
                           className="prdt-mdl-close"
                           aria-label="Cerrar"
                           onClick={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))}
                        >
                           <i className="fa-solid fa-xmark" />
                        </button>
                     </header>

                     {/* ---------------- BODY ---------------- */}
                     <div className="prdt-mdl-body">

                        {/* ===== PASO 1 — opciones ===== */}
                        <section className={`prdt-mdl-step ${step === 1 ? "is-active" : ""}`}>
                           {segments.length > 0 ? (
                              <div className="prdt-mdl-panel">
                                 <h5 className="prdt-mdl-panel-title">Opciones del producto</h5>

                                 <div className="prdt-mdl-segments">
                                    {contentSegments()}
                                 </div>

                                 {selectProduct.combo_id ? (
                                    <div className="prdt-mdl-combo">

                                       {/* Pasos del combo */}
                                       <div className="prdt-mdl-steps-head">
                                          <span className="prdt-mdl-steps-label">Pasos</span>
                                          <div className="prdt-mdl-tabs">
                                             {selectProduct.setGroups.map((setGroup, index) => (
                                                <button
                                                   key={setGroup.set_id ?? index}
                                                   className={`prdt-mdl-tab ${setGroup.ready == true ? "is-ready" : index === activeTab ? "is-active" : ""}`}
                                                   onClick={() => changeTab(index)}
                                                >
                                                   {setGroup.name}
                                                   {setGroup.ready == true ? <i className="uil uil-check-circle" /> : null}
                                                </button>
                                             ))}
                                          </div>
                                       </div>

                                       <h5 className="prdt-mdl-group-title">
                                          {selectProduct.setGroups[activeTab].name}
                                       </h5>

                                       {/* Opciones del paso activo */}
                                       <div className="prdt-mdl-grid">
                                          {selectProduct.setGroups[activeTab].groups.map((group) => {
                                             const inputId = "setGroup" + selectProduct.setGroups[activeTab].set_id + group.group_id;
                                             return (
                                                <article
                                                   className="prdt-mdl-opt"
                                                   key={group.group_id}
                                                   onClick={() => actionCheckIngradent(group, inputId, true)}
                                                >
                                                   <input
                                                      className="prdt-mdl-opt-input"
                                                      type={selectProduct.setGroups[activeTab].count > 1 ? "checkbox" : "radio"}
                                                      name={"setGroup" + selectProduct.setGroups[activeTab].set_id}
                                                      id={inputId}
                                                      value=""
                                                      checked={false}
                                                   />
                                                   <label className="prdt-mdl-opt-card">
                                                      <span className="prdt-mdl-opt-check" aria-hidden="true" />
                                                      <img
                                                         className="prdt-mdl-opt-img"
                                                         src={buildCloudinaryImageUrl({ url: group.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                         alt=""
                                                      />
                                                      <span className="prdt-mdl-opt-name">{group.name}</span>
                                                      {group.description ? (
                                                         <span className="prdt-mdl-opt-desc">{group.description}</span>
                                                      ) : null}
                                                      <span className="prdt-mdl-opt-price">
                                                         {formatModifierPrice(group.price)}
                                                      </span>
                                                   </label>
                                                </article>
                                             );
                                          })}
                                       </div>

                                       {/* Resumen del combo */}
                                       {comboSelect.length > 0 ? (
                                          <div className="prdt-mdl-summary">
                                             <h5 className="prdt-mdl-group-title">Resumen del combo</h5>
                                             <div className="prdt-mdl-grid">
                                                {comboSelect.map((setGroup, sIdx) => (
                                                   setGroup.groupsselected.map((group, index) => (
                                                      <article className="prdt-mdl-opt is-picked" key={`${sIdx}-${index}`}>
                                                         <div className="prdt-mdl-opt-card">
                                                            <img
                                                               className="prdt-mdl-opt-img"
                                                               src={buildCloudinaryImageUrl({ url: group.img, width: 300, quality: "auto", type: "image" }) || img_default}
                                                               alt=""
                                                            />
                                                            <span className="prdt-mdl-opt-name">
                                                               {setGroup.name}: {group.name}
                                                            </span>
                                                            {group.description ? (
                                                               <span className="prdt-mdl-opt-desc">{group.description}</span>
                                                            ) : null}

                                                            <details className="prdt-mdl-opt-details">
                                                               <summary>
                                                                  <i className="uil uil-info-circle" /> Detalles
                                                               </summary>
                                                               <ul className="prdt-mdl-opt-segs">
                                                                  {group.segments.map((item, i) => (
                                                                     <li key={i}>
                                                                        <span className="prdt-mdl-seg-key">{item.segment_name}</span>
                                                                        <span className="prdt-mdl-seg-val">
                                                                           {item.name} · {getModifierPrice(item.price).toFixed(2)}
                                                                        </span>
                                                                     </li>
                                                                  ))}
                                                               </ul>
                                                            </details>

                                                            <div className="prdt-mdl-opt-foot">
                                                               <span className="prdt-mdl-opt-price">
                                                                  {formatModifierPrice(group.price)}
                                                               </span>
                                                               <span className="prdt-mdl-opt-acts">
                                                                  <button
                                                                     className="prdt-mdl-act"
                                                                     title="Modificar Producto"
                                                                     data-id={index}
                                                                     onClick={() => (setActiveTab(setGroup.activeTab), getdataGroup(group, false, true))}
                                                                  >
                                                                     <i className="uil uil-edit" />
                                                                  </button>
                                                                  <button
                                                                     className="prdt-mdl-act prdt-mdl-act--danger"
                                                                     title="Eliminar Producto"
                                                                     data-id={index}
                                                                     onClick={() => deleteSetGroupOfComboSelected(setGroup.activeTab)}
                                                                  >
                                                                     <i className="uil uil-trash-alt" />
                                                                  </button>
                                                               </span>
                                                            </div>
                                                         </div>
                                                      </article>
                                                   ))
                                                ))}
                                             </div>
                                          </div>
                                       ) : null}
                                    </div>
                                 ) : null}
                              </div>
                           ) : (
                              <Empty
                                 title="Sin opciones disponibles"
                                 icon="😢 "
                                 msg="Este producto no cuenta con opciones disponibles por el momento."
                              />
                           )}
                        </section>

                        {/* ===== PASO 2 — cantidad y notas ===== */}
                        <section className={`prdt-mdl-step ${step === 2 ? "is-active" : ""}`}>
                           <div className="prdt-mdl-fields">

                              <div className="prdt-mdl-field">
                                 <h3 className="prdt-mdl-field-title">Cantidad</h3>
                                 <div className="prdt-mdl-qty">
                                    <button
                                       onClick={() => decrementNumber()}
                                       className="prdt-mdl-qty-btn"
                                       disabled={number <= 1}
                                       type="button"
                                    >−</button>
                                    <input
                                       type="number"
                                       min={1}
                                       value={number}
                                       className="prdt-mdl-qty-input"
                                       onChange={e => incrementNumber(parseInt(e.target.value))}
                                    />
                                    <button
                                       onClick={() => incrementNumber()}
                                       className="prdt-mdl-qty-btn"
                                       type="button"
                                    >+</button>
                                 </div>
                              </div>

                              <div className="prdt-mdl-field">
                                 <h3 className="prdt-mdl-field-title">Notas</h3>
                                 <textarea
                                    onChange={(e) => (setNotesItem(e.target.value))}
                                    placeholder="Escribir..."
                                    className="prdt-mdl-notes"
                                    rows="3"
                                    maxLength={200}
                                 />
                              </div>

                           </div>
                        </section>

                     </div>

                     {/* ---------------- FOOTER ---------------- */}
                     <footer className="d-flex justify-content-between p-2 hidden-frame-pos">
                        {step === 1 ? (
                           <>
                              <button
                                 className="prdt-mdl-btn prdt-mdl-btn--ghost"
                                 onClick={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))}
                                 type="button"
                                 disabled={step === totalSteps}
                              >
                                 Cerrar
                              </button>

                              <button
                                 className="prdt-mdl-btn prdt-mdl-btn--primary"
                                 onClick={nextStep}
                                 type="button"
                                 disabled={step === totalSteps}
                              >
                                 Siguiente
                              </button>
                           </>
                        ) : (
                           <>
                              <button
                                 className="prdt-mdl-btn prdt-mdl-btn--ghost"
                                 onClick={prevStep}
                                 disabled={step === 1}
                                 type="button"
                              >
                                 Regresar
                              </button>

                              <button
                                 className="prdt-mdl-btn prdt-mdl-btn--cart"
                                 onClick={e => (setShowModalSelectItem(false), setShow(false), addProduct(e))}
                                 disabled={step === 1}
                                 type="button"
                              >
                                 Agregar al carrito
                              </button>
                           </>
                        )}
                     </footer>

                     {/* <footer className="prdt-mdl-foot display-frame-pos">
            <button
               className="prdt-mdl-btn prdt-mdl-btn--ghost"
               onClick={() => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))}
               type="button"
               disabled={step === totalSteps}
            >
               Cerrar
            </button>

            <button
               className="prdt-mdl-btn prdt-mdl-btn--cart"
               onClick={e => (setShowModalSelectItem(false), setShow(false), addProduct(e))}
               type="button"
            >
               Agregar al carrito
            </button>
         </footer> */}

                  </div>
               </div>
            )
         }





         {/* Modal inform z settle */}
         < Modal show={modalInformZSettle} onHide={() => setModalInformZSettle(false)}>
            <Modal.Header closeButton>
               <Modal.Title>Información</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="d-flex alight-item-center justify-content-center">
                  <RenderIf isTrue={modalInformZSettleInfo !== null}>
                     <div>
                        <pre>{modalInformZSettleInfo}</pre>
                     </div>
                  </RenderIf>

                  <RenderIf isTrue={modalInformZSettleInfo === null}>
                     <div>
                        <pre>No se genero voucher</pre>
                     </div>
                  </RenderIf>

               </div>
               <div className="d-flex justify-content-center">
                  <button className="btn btn-info" onClick={() => setModalInformZSettle(false)}>Cerrar</button>
               </div>
            </Modal.Body >
         </ Modal>
         <ModalLoginUserByCode showLoginByCode={showLoginByCode} setShowLoginByCode={setShowLoginByCode} businessLogo={businessLogo} parthners={parthners} logo={businessLogo} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} codeParthner={codeParthner} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} setShowModalWarehouses={setShowModalWarehouses} warehouses={warehouses} getInventory={getInventory}  ></ModalLoginUserByCode>
         <ModalIngredient setShowModalIngredient={setShowModalIngredient} showModalIngredient={showModalIngredient} groupNow={groupNow} businessLogo={businessLogo} formatJsonToAddShoppingCart={formatJsonToAddShoppingCart} segmentsNow={segmentsNow} img_default={img_default} />
         <ModalWarehouses show={showModalWarehouses} setShow={setShowModalWarehouses} warehouses={warehouses} setWarehouseSelected={setWarehouseSelected}></ModalWarehouses>

         {/* Modal to select delivery rules */}
         <Modal
            show={showDeliveryModal}
            onHide={() => setShowDeliveryModal(false)}
            centered
         >
            <Modal.Header closeButton>
               <Modal.Title>Opciones de Delivery</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="mb-3">
                  <label className="form-label">Método de envío</label>
                  <div className="row g-2">
                     {deliveryFeeRule && deliveryFeeRule.length > 0 ? (
                        deliveryFeeRule.map((rule) => (

                           <>
                              {/* <div className="col-12" key={rule.id}>
                                 <input
                                    type="radio"
                                    className="btn-check"
                                    name="delivery-method-pos"
                                    id={`delivery-method-pos-${rule.id}`}
                                    checked={selectedDeliveryRule && selectedDeliveryRule.id === rule.id}
                                    onChange={() => setSelectedDeliveryRule(rule)}
                                 />
                                 <label
                                    className="btn btn-outline-primary w-100 text-start"
                                    htmlFor={`delivery-method-pos-${rule.id}`}
                                 >
                                    <strong>{rule.name}</strong><br />
                                    <small className="text-muted">
                                       {rule.fee_type === "fixed" ? `Costo fijo: $${rule.fee_amount}` : null}
                                       {rule.fee_type === "kilometer" ? `Según distancia (${rule.distance_source})` : null}
                                       {Number(rule.min_subtotal_to_waive || 0) > 0
                                          ? ` | Gratis desde $${rule.min_subtotal_to_waive}`
                                          : null}
                                    </small>
                                 </label>
                              </div> */}


                              <div className="col-12" key={rule.id}>
                                 <input
                                    type="radio"
                                    className="delivery-radio-ecommerce"
                                    name="delivery-method-pos"
                                    id={`delivery-method-pos-${rule.id}`}
                                    checked={selectedDeliveryRule && selectedDeliveryRule.id === rule.id}
                                    onChange={() => setSelectedDeliveryRule(rule)}
                                 />
                                 <label
                                    className="delivery-option-ecommerce"
                                    htmlFor={`delivery-method-pos-${rule.id}`}
                                 >
                                    <div className="delivery-radio-circle-ecommerce"></div>
                                    <div className="delivery-content-ecommerce">
                                       <div className="delivery-name-ecommerce">{rule.name}</div>
                                       <div className="delivery-details-ecommerce">
                                          {rule.fee_type === "fixed" ? (
                                             <span className="delivery-badge-ecommerce delivery-badge-price-ecommerce">
                                                Costo fijo: ${rule.fee_amount}
                                             </span>
                                          ) : null}
                                          {rule.fee_type === "kilometer" ? (
                                             <span className="delivery-badge-ecommerce delivery-badge-distance-ecommerce">
                                                Según distancia ({rule.distance_source})
                                             </span>
                                          ) : null}
                                          {Number(rule.min_subtotal_to_waive || 0) > 0 ? (
                                             <span className="delivery-badge-ecommerce delivery-badge-free-ecommerce">
                                                Gratis desde ${rule.min_subtotal_to_waive}
                                             </span>
                                          ) : null}
                                       </div>
                                    </div>
                                 </label>
                              </div>

                           </>

                        ))
                     ) : (
                        <p className="text-muted small">No hay reglas de delivery cargadas.</p>
                     )}
                  </div>
               </div>
            </Modal.Body>
            <Modal.Footer>
               <button
                  className="btn btn-secondary"
                  onClick={() => setShowDeliveryModal(false)}
               >
                  Cancelar
               </button>

               <button
                  className="btn btn-primary"
                  onClick={async () => {
                     if (!selectedDeliveryRule) return;

                     // Save selected delivery rule to localStorage
                     localStorage.setItem(
                        'posDeliveryRuleSelected',
                        JSON.stringify(selectedDeliveryRule)
                     );
                     //We check if there is a current location saved
                     if (localStorage.getItem("addressNowLocation") !== null && localStorage.getItem("addressNowLocation") !== undefined && localStorage.getItem("addressNowLocation") !== "null") {
                        // Recalcular totales incluyendo el delivery
                        await calculateInvoiceTotals(shoppingCart, shoppingCartCombos);
                     } else {
                        ErrorAlert("Para calcular el costo de envío, por favor ingrese una dirección de entrega.", "¡Atención!", "warning");
                     }

                     // Cerrar modal
                     setShowDeliveryModal(false);
                  }}
                  disabled={!selectedDeliveryRule}
               >
                  Calcular
               </button>
            </Modal.Footer>
         </Modal>


         {/*Modal Edit price of item in order type quote */}
         <Modal
            show={showModalEditPrice}
            onHide={() => setShowModalEditPrice(false)}
            centered
         >
            <Modal.Header closeButton>
               <Modal.Title>Modificar producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="mb-3">
                  <div className={"d-flex rounded m-1 bg-white mt-1 card-pos overflow-x position-relative"}
                  >
                     <div className="flex-shrink-0 position-relative">
                        {!hidden ? (
                           <div className={`fade-enter fade-enter-active`}>
                              <img className='m-1 rounded  bg-light border ' loading="lazy" src={buildCloudinaryImageUrl({ url: productEditPrice.img, width: 300, quality: "auto", type: "image" }) || businessLogo} alt="..." width="80" height="80" />
                           </div>
                        ) : (
                           <>

                           </>
                        )}
                     </div>
                     <div className="flex-grow-1 m-2 w-100" >
                        <input
                           type="text"
                           value={productEditPriceTemp?.name === 0 || productEditPriceTemp?.name === undefined ? "" : productEditPriceTemp.name}
                           className='p-2  border-0 title-product-cart '
                           onChange={e => {
                              setProductEditPriceTemp({
                                 ...productEditPriceTemp,
                                 name: e.target.value
                              });

                           }}
                        />
                        {/*<div className={"ms-auto px-2 text-price-cart"}
                              translate='no'>$ {productEditPrice.price.toFixed(2)}</div>*/}


                        <Form>
                           <Form.Group className="m-1" >
                              <Form.Control as="textarea" className=''
                                 value={productEditPriceTemp?.description === 0 || productEditPriceTemp?.description === undefined ? "" : productEditPriceTemp.description}
                                 onChange={e => {
                                    setProductEditPriceTemp({
                                       ...productEditPriceTemp,
                                       description: e.target.value
                                    });

                                 }} placeholder='Escribir...' />
                           </Form.Group>
                        </Form>


                        <small className='opacity-75'> Precio unitario </small>
                        <div className=" mb-3 d-flex justify-content-between align-content-center align-items-center">
                           <input
                              type="number"
                              min={0}
                              step="0.01"
                              value={productEditPriceTemp?.price === 0 || productEditPriceTemp?.price === undefined ? "" : productEditPriceTemp.price}
                              className='p-2 text-center  value-ecommerce-menu-card'
                              onChange={e => {
                                 let value = e.target.value.replace(/,/g, '.');
                                 if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                    setProductEditPriceTemp({
                                       ...productEditPriceTemp,
                                       price: value
                                    });
                                 }
                              }}
                           />
                        </div>

                        <div className="">
                           <details open>
                              <summary> <small className='opacity-75'> Detalles de segmentos </small> </summary>


                              <ul className="list-group">
                                 {productEditPriceTemp?.segments?.map((item, idx) => (
                                    <li
                                       key={idx}
                                       className="list-group-item small list-group-item-action
                 d-flex flex-column flex-sm-row
                 align-items-start align-items-sm-center
                 justify-content-between   opacity-50 w-75"
                                    >
                                       <div>
                                          <span className="flex-grow-1 text-wrap">
                                             {item.segment_name}: {item.name}
                                          </span>

                                          {/*<span className="fw-bold ms-sm-auto" translate="no">
                                          ${parseFloat(item.price).toFixed(2)}
                                       </span>*/}

                                          <div className="m-2 d-flex justify-content-between align-content-center align-items-center">
                                             <input
                                                type="number"
                                                min={0}
                                                step="0.01"
                                                value={item.price === 0 || item.price === undefined ? 0 : item.price}
                                                className='p-2 text-center border-0 value-ecommerce-menu-card'
                                                onChange={e => {
                                                   let value = e.target.value.replace(/,/g, '.');
                                                   if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                      const newSegments = [...productEditPriceTemp.segments];
                                                      newSegments[idx] = {
                                                         ...newSegments[idx],
                                                         price: value
                                                      };
                                                      setProductEditPriceTemp({
                                                         ...productEditPriceTemp,
                                                         segments: newSegments
                                                      });
                                                   }
                                                }}
                                             />
                                          </div>
                                       </div>
                                    </li>
                                 ))}
                              </ul>
                           </details>
                        </div>

                     </div>
                  </div>

               </div>
            </Modal.Body>
            <Modal.Footer>
               <button
                  className="btn btn-secondary"
                  onClick={() => handlerEditPriceProduct()}
               >
                  Guardar cambios
               </button>
            </Modal.Footer>
         </Modal>

         {
            !isOnline && (
               <div style={{
                  position: 'fixed',
                  top: 0, left: 0, right: 0, bottom: 0,
                  background: '#fff',
                  zIndex: 2147483647, // Asegura que esté por encima de todo
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
               }}>
                  <img src={sadImg} alt="No Internet" style={{ width: 120, marginBottom: 24 }} />
                  <h2>No Internet Connection</h2>
                  <p>Please check your network and try again.</p>
                  {/*<button
                  className="btn btn-primary mt-3"
                  onClick={() => window.location.reload()}
               >
                  Intentar nuevamente
               </button>*/}
               </div>
            )
         }

         <RfmTableRequestsPanel
            open={showTableRequestsPanel}
            onClose={() => setShowTableRequestsPanel(false)}
            requests={tableSessionRequests}
            processingSessionId={processingTableSessionId}
            onApprove={handleApproveTableSessionRequest}
            onReject={handleRejectTableSessionRequest}
         />

         {
            showTableAudioUnlock && (
               <div className="position-fixed bottom-0 start-50 translate-middle-x mb-2 px-3 py-2 rounded-3 bg-warning text-dark shadow"
                  style={{ zIndex: 2000 }}>
                  <button className="btn btn-sm btn-dark me-2" onClick={handleUnlockTableAudio} title="Habilitar sonido">
                     🔊 Habilitar sonido
                  </button>
                  <small>Toque “Habilitar sonido” una vez para permitir la alerta audible.</small>
               </div>
            )
         }

      </>
   )

   // Embebido: toda la pantalla queda oculta; lo unico visible es el Centro de Pagos, que ModalPayMet
   // dibuja en un portal (createPortal a document.body) y por eso no le afecta el display:none.
   return embedded ? <div style={{ display: 'none' }}>{pageContent}</div> : pageContent
}

export default PaymentPost
